/**
 * Equivalencias INE-Catastro para municipios de Andalucía
 * Fuente: SIGPAC/FEGA 2025 - Relación Municipios Rusector Agregado Zona Campaña
 * 
 * Discrepancias documentadas:
 * - 8 capitales provinciales: Catastro usa código 900
 * - 174 municipios Granada: Catastro = INE + 1 (offset histórico)
 * - 8 municipios Cádiz zona 53: Catastro usa prefijo 53 en lugar de 11
 * - 39 segregaciones recientes (INE ≥ 901): Catastro mantiene código original
 * 
 * @generated 2025-01-25 from SIGPAC 2025
 */

export interface EquivalenciaMunicipio {
  codProvincia: number;
  provincia: string;
  codIne: number;
  codCatastro: number;
  nombre: string;
  nombreAntiguo?: string;
  hojasSigpac: string | string[];
  esCapital: boolean;
  esSegregacion: boolean;
}

export const EQUIVALENCIAS_INE_CATASTRO: EquivalenciaMunicipio[] = [
  {
    "codProvincia": 4,
    "provincia": "Almería",
    "codIne": 1,
    "codCatastro": 1,
    "nombre": "ABLA",
    "hojasSigpac": "04001A",
    "esCapital": false,
    "esSegregacion": false
  },
  {
    "codProvincia": 4,
    "provincia": "Almería",
    "codIne": 2,
    "codCatastro": 2,
    "nombre": "ABRUCENA",
    "hojasSigpac": "04002A",
    "esCapital": false,
    "esSegregacion": false
  },
  {
    "codProvincia": 4,
    "provincia": "Almería",
    "codIne": 3,
    "codCatastro": 3,
    "nombre": "ADRA",
    "hojasSigpac": "04003A",
    "esCapital": false,
    "esSegregacion": false
  },
  {
    "codProvincia": 4,
    "provincia": "Almería",
    "codIne": 4,
    "codCatastro": 4,
    "nombre": "ALBANCHEZ",
    "hojasSigpac": "04004A",
    "esCapital": false,
    "esSegregacion": false
  },
  {
    "codProvincia": 4,
    "provincia": "Almería",
    "codIne": 5,
    "codCatastro": 5,
    "nombre": "ALBOLODUY",
    "hojasSigpac": "04005A",
    "esCapital": false,
    "esSegregacion": false
  },
  {
    "codProvincia": 4,
    "provincia": "Almería",
    "codIne": 6,
    "codCatastro": 6,
    "nombre": "ALBOX",
    "hojasSigpac": "04006A",
    "esCapital": false,
    "esSegregacion": false
  },
  {
    "codProvincia": 4,
    "provincia": "Almería",
    "codIne": 7,
    "codCatastro": 7,
    "nombre": "ALCOLEA",
    "hojasSigpac": "04007A",
    "esCapital": false,
    "esSegregacion": false
  },
  {
    "codProvincia": 4,
    "provincia": "Almería",
    "codIne": 8,
    "codCatastro": 8,
    "nombre": "ALCONTAR",
    "hojasSigpac": "04008A",
    "esCapital": false,
    "esSegregacion": false
  },
  {
    "codProvincia": 4,
    "provincia": "Almería",
    "codIne": 9,
    "codCatastro": 9,
    "nombre": "ALCUDIA DE MONTEAGUD",
    "hojasSigpac": "04009A",
    "esCapital": false,
    "esSegregacion": false
  },
  {
    "codProvincia": 4,
    "provincia": "Almería",
    "codIne": 10,
    "codCatastro": 10,
    "nombre": "ALHABIA",
    "hojasSigpac": "04010A",
    "esCapital": false,
    "esSegregacion": false
  },
  {
    "codProvincia": 4,
    "provincia": "Almería",
    "codIne": 11,
    "codCatastro": 11,
    "nombre": "ALHAMA DE ALMERIA",
    "hojasSigpac": "04011A",
    "esCapital": false,
    "esSegregacion": false
  },
  {
    "codProvincia": 4,
    "provincia": "Almería",
    "codIne": 12,
    "codCatastro": 12,
    "nombre": "ALICUN",
    "hojasSigpac": "04012A",
    "esCapital": false,
    "esSegregacion": false
  },
  {
    "codProvincia": 4,
    "provincia": "Almería",
    "codIne": 13,
    "codCatastro": 900,
    "nombre": "ALMERIA",
    "hojasSigpac": [
      "04900A",
      "04900B"
    ],
    "esCapital": true,
    "esSegregacion": false
  },
  {
    "codProvincia": 4,
    "provincia": "Almería",
    "codIne": 14,
    "codCatastro": 14,
    "nombre": "ALMOCITA",
    "hojasSigpac": "04014A",
    "esCapital": false,
    "esSegregacion": false
  },
  {
    "codProvincia": 4,
    "provincia": "Almería",
    "codIne": 15,
    "codCatastro": 15,
    "nombre": "ALSODUX",
    "hojasSigpac": "04015A",
    "esCapital": false,
    "esSegregacion": false
  },
  {
    "codProvincia": 4,
    "provincia": "Almería",
    "codIne": 16,
    "codCatastro": 16,
    "nombre": "ANTAS",
    "hojasSigpac": "04016A",
    "esCapital": false,
    "esSegregacion": false
  },
  {
    "codProvincia": 4,
    "provincia": "Almería",
    "codIne": 17,
    "codCatastro": 17,
    "nombre": "ARBOLEAS",
    "hojasSigpac": "04017A",
    "esCapital": false,
    "esSegregacion": false
  },
  {
    "codProvincia": 4,
    "provincia": "Almería",
    "codIne": 18,
    "codCatastro": 18,
    "nombre": "ARMUÑA DEL ALMANZORA",
    "hojasSigpac": "04018A",
    "esCapital": false,
    "esSegregacion": false
  },
  {
    "codProvincia": 4,
    "provincia": "Almería",
    "codIne": 19,
    "codCatastro": 19,
    "nombre": "BACARES",
    "hojasSigpac": "04019A",
    "esCapital": false,
    "esSegregacion": false
  },
  {
    "codProvincia": 4,
    "provincia": "Almería",
    "codIne": 20,
    "codCatastro": 20,
    "nombre": "BAYARCAL",
    "hojasSigpac": "04020A",
    "esCapital": false,
    "esSegregacion": false
  },
  {
    "codProvincia": 4,
    "provincia": "Almería",
    "codIne": 21,
    "codCatastro": 21,
    "nombre": "BAYARQUE",
    "hojasSigpac": "04021A",
    "esCapital": false,
    "esSegregacion": false
  },
  {
    "codProvincia": 4,
    "provincia": "Almería",
    "codIne": 22,
    "codCatastro": 22,
    "nombre": "BEDAR",
    "hojasSigpac": "04022A",
    "esCapital": false,
    "esSegregacion": false
  },
  {
    "codProvincia": 4,
    "provincia": "Almería",
    "codIne": 23,
    "codCatastro": 23,
    "nombre": "BEIRES",
    "hojasSigpac": "04023A",
    "esCapital": false,
    "esSegregacion": false
  },
  {
    "codProvincia": 4,
    "provincia": "Almería",
    "codIne": 24,
    "codCatastro": 24,
    "nombre": "BENAHADUX",
    "hojasSigpac": "04024A",
    "esCapital": false,
    "esSegregacion": false
  },
  {
    "codProvincia": 4,
    "provincia": "Almería",
    "codIne": 26,
    "codCatastro": 26,
    "nombre": "BENITAGLA",
    "hojasSigpac": "04026A",
    "esCapital": false,
    "esSegregacion": false
  },
  {
    "codProvincia": 4,
    "provincia": "Almería",
    "codIne": 27,
    "codCatastro": 27,
    "nombre": "BENIZALON",
    "hojasSigpac": "04027A",
    "esCapital": false,
    "esSegregacion": false
  },
  {
    "codProvincia": 4,
    "provincia": "Almería",
    "codIne": 28,
    "codCatastro": 28,
    "nombre": "BENTARIQUE",
    "hojasSigpac": "04028A",
    "esCapital": false,
    "esSegregacion": false
  },
  {
    "codProvincia": 4,
    "provincia": "Almería",
    "codIne": 29,
    "codCatastro": 29,
    "nombre": "BERJA",
    "hojasSigpac": "04029A",
    "esCapital": false,
    "esSegregacion": false
  },
  {
    "codProvincia": 4,
    "provincia": "Almería",
    "codIne": 30,
    "codCatastro": 30,
    "nombre": "CANJAYAR",
    "hojasSigpac": "04030A",
    "esCapital": false,
    "esSegregacion": false
  },
  {
    "codProvincia": 4,
    "provincia": "Almería",
    "codIne": 31,
    "codCatastro": 31,
    "nombre": "CANTORIA",
    "hojasSigpac": "04031A",
    "esCapital": false,
    "esSegregacion": false
  },
  {
    "codProvincia": 4,
    "provincia": "Almería",
    "codIne": 32,
    "codCatastro": 32,
    "nombre": "CARBONERAS",
    "hojasSigpac": "04032A",
    "esCapital": false,
    "esSegregacion": false
  },
  {
    "codProvincia": 4,
    "provincia": "Almería",
    "codIne": 33,
    "codCatastro": 33,
    "nombre": "CASTRO DE FILABRES",
    "hojasSigpac": "04033A",
    "esCapital": false,
    "esSegregacion": false
  },
  {
    "codProvincia": 4,
    "provincia": "Almería",
    "codIne": 34,
    "codCatastro": 34,
    "nombre": "COBDAR",
    "hojasSigpac": "04034A",
    "esCapital": false,
    "esSegregacion": false
  },
  {
    "codProvincia": 4,
    "provincia": "Almería",
    "codIne": 35,
    "codCatastro": 35,
    "nombre": "CUEVAS DEL ALMANZORA",
    "hojasSigpac": "04035A",
    "esCapital": false,
    "esSegregacion": false
  },
  {
    "codProvincia": 4,
    "provincia": "Almería",
    "codIne": 36,
    "codCatastro": 36,
    "nombre": "CHERCOS",
    "hojasSigpac": "04036A",
    "esCapital": false,
    "esSegregacion": false
  },
  {
    "codProvincia": 4,
    "provincia": "Almería",
    "codIne": 37,
    "codCatastro": 37,
    "nombre": "CHIRIVEL",
    "hojasSigpac": "04037A",
    "esCapital": false,
    "esSegregacion": false
  },
  {
    "codProvincia": 4,
    "provincia": "Almería",
    "codIne": 38,
    "codCatastro": 38,
    "nombre": "DALIAS",
    "hojasSigpac": "04038A",
    "esCapital": false,
    "esSegregacion": false
  },
  {
    "codProvincia": 4,
    "provincia": "Almería",
    "codIne": 41,
    "codCatastro": 41,
    "nombre": "ENIX",
    "hojasSigpac": "04041A",
    "esCapital": false,
    "esSegregacion": false
  },
  {
    "codProvincia": 4,
    "provincia": "Almería",
    "codIne": 43,
    "codCatastro": 43,
    "nombre": "FELIX",
    "hojasSigpac": "04043A",
    "esCapital": false,
    "esSegregacion": false
  },
  {
    "codProvincia": 4,
    "provincia": "Almería",
    "codIne": 44,
    "codCatastro": 44,
    "nombre": "FINES",
    "hojasSigpac": "04044A",
    "esCapital": false,
    "esSegregacion": false
  },
  {
    "codProvincia": 4,
    "provincia": "Almería",
    "codIne": 45,
    "codCatastro": 45,
    "nombre": "FIÑANA",
    "hojasSigpac": "04045A",
    "esCapital": false,
    "esSegregacion": false
  },
  {
    "codProvincia": 4,
    "provincia": "Almería",
    "codIne": 46,
    "codCatastro": 46,
    "nombre": "FONDON",
    "hojasSigpac": "04046A",
    "esCapital": false,
    "esSegregacion": false
  },
  {
    "codProvincia": 4,
    "provincia": "Almería",
    "codIne": 47,
    "codCatastro": 47,
    "nombre": "GADOR",
    "hojasSigpac": "04047A",
    "esCapital": false,
    "esSegregacion": false
  },
  {
    "codProvincia": 4,
    "provincia": "Almería",
    "codIne": 48,
    "codCatastro": 48,
    "nombre": "LOS GALLARDOS",
    "hojasSigpac": "04048A",
    "esCapital": false,
    "esSegregacion": false
  },
  {
    "codProvincia": 4,
    "provincia": "Almería",
    "codIne": 49,
    "codCatastro": 49,
    "nombre": "GARRUCHA",
    "hojasSigpac": "04049A",
    "esCapital": false,
    "esSegregacion": false
  },
  {
    "codProvincia": 4,
    "provincia": "Almería",
    "codIne": 50,
    "codCatastro": 50,
    "nombre": "GERGAL",
    "hojasSigpac": "04050A",
    "esCapital": false,
    "esSegregacion": false
  },
  {
    "codProvincia": 4,
    "provincia": "Almería",
    "codIne": 51,
    "codCatastro": 51,
    "nombre": "HUECIJA",
    "hojasSigpac": "04051A",
    "esCapital": false,
    "esSegregacion": false
  },
  {
    "codProvincia": 4,
    "provincia": "Almería",
    "codIne": 52,
    "codCatastro": 52,
    "nombre": "HUERCAL DE ALMERIA",
    "hojasSigpac": "04052A",
    "esCapital": false,
    "esSegregacion": false
  },
  {
    "codProvincia": 4,
    "provincia": "Almería",
    "codIne": 53,
    "codCatastro": 53,
    "nombre": "HUERCAL-OVERA",
    "hojasSigpac": "04053A",
    "esCapital": false,
    "esSegregacion": false
  },
  {
    "codProvincia": 4,
    "provincia": "Almería",
    "codIne": 54,
    "codCatastro": 54,
    "nombre": "ILLAR",
    "hojasSigpac": "04054A",
    "esCapital": false,
    "esSegregacion": false
  },
  {
    "codProvincia": 4,
    "provincia": "Almería",
    "codIne": 55,
    "codCatastro": 55,
    "nombre": "INSTINCION",
    "hojasSigpac": "04055A",
    "esCapital": false,
    "esSegregacion": false
  },
  {
    "codProvincia": 4,
    "provincia": "Almería",
    "codIne": 56,
    "codCatastro": 56,
    "nombre": "LAROYA",
    "hojasSigpac": "04056A",
    "esCapital": false,
    "esSegregacion": false
  },
  {
    "codProvincia": 4,
    "provincia": "Almería",
    "codIne": 57,
    "codCatastro": 57,
    "nombre": "LAUJAR DE ANDARAX",
    "hojasSigpac": "04057A",
    "esCapital": false,
    "esSegregacion": false
  },
  {
    "codProvincia": 4,
    "provincia": "Almería",
    "codIne": 58,
    "codCatastro": 58,
    "nombre": "LIJAR",
    "hojasSigpac": "04058A",
    "esCapital": false,
    "esSegregacion": false
  },
  {
    "codProvincia": 4,
    "provincia": "Almería",
    "codIne": 59,
    "codCatastro": 59,
    "nombre": "LUBRIN",
    "hojasSigpac": "04059A",
    "esCapital": false,
    "esSegregacion": false
  },
  {
    "codProvincia": 4,
    "provincia": "Almería",
    "codIne": 60,
    "codCatastro": 60,
    "nombre": "LUCAINENA DE LAS TORRES",
    "hojasSigpac": "04060A",
    "esCapital": false,
    "esSegregacion": false
  },
  {
    "codProvincia": 4,
    "provincia": "Almería",
    "codIne": 61,
    "codCatastro": 61,
    "nombre": "LUCAR",
    "hojasSigpac": "04061A",
    "esCapital": false,
    "esSegregacion": false
  },
  {
    "codProvincia": 4,
    "provincia": "Almería",
    "codIne": 62,
    "codCatastro": 62,
    "nombre": "MACAEL",
    "hojasSigpac": "04062A",
    "esCapital": false,
    "esSegregacion": false
  },
  {
    "codProvincia": 4,
    "provincia": "Almería",
    "codIne": 63,
    "codCatastro": 63,
    "nombre": "MARIA",
    "hojasSigpac": "04063A",
    "esCapital": false,
    "esSegregacion": false
  },
  {
    "codProvincia": 4,
    "provincia": "Almería",
    "codIne": 64,
    "codCatastro": 64,
    "nombre": "MOJACAR",
    "hojasSigpac": "04064A",
    "esCapital": false,
    "esSegregacion": false
  },
  {
    "codProvincia": 4,
    "provincia": "Almería",
    "codIne": 65,
    "codCatastro": 65,
    "nombre": "NACIMIENTO",
    "hojasSigpac": "04065A",
    "esCapital": false,
    "esSegregacion": false
  },
  {
    "codProvincia": 4,
    "provincia": "Almería",
    "codIne": 66,
    "codCatastro": 66,
    "nombre": "NIJAR",
    "hojasSigpac": "04066A",
    "esCapital": false,
    "esSegregacion": false
  },
  {
    "codProvincia": 4,
    "provincia": "Almería",
    "codIne": 67,
    "codCatastro": 67,
    "nombre": "OHANES",
    "hojasSigpac": "04067A",
    "esCapital": false,
    "esSegregacion": false
  },
  {
    "codProvincia": 4,
    "provincia": "Almería",
    "codIne": 68,
    "codCatastro": 68,
    "nombre": "OLULA DE CASTRO",
    "hojasSigpac": "04068A",
    "esCapital": false,
    "esSegregacion": false
  },
  {
    "codProvincia": 4,
    "provincia": "Almería",
    "codIne": 69,
    "codCatastro": 69,
    "nombre": "OLULA DEL RIO",
    "hojasSigpac": "04069A",
    "esCapital": false,
    "esSegregacion": false
  },
  {
    "codProvincia": 4,
    "provincia": "Almería",
    "codIne": 70,
    "codCatastro": 70,
    "nombre": "ORIA",
    "hojasSigpac": [
      "04070A",
      "04070A"
    ],
    "esCapital": false,
    "esSegregacion": false
  },
  {
    "codProvincia": 4,
    "provincia": "Almería",
    "codIne": 71,
    "codCatastro": 71,
    "nombre": "PADULES",
    "hojasSigpac": "04071A",
    "esCapital": false,
    "esSegregacion": false
  },
  {
    "codProvincia": 4,
    "provincia": "Almería",
    "codIne": 72,
    "codCatastro": 72,
    "nombre": "PARTALOA",
    "hojasSigpac": "04072A",
    "esCapital": false,
    "esSegregacion": false
  },
  {
    "codProvincia": 4,
    "provincia": "Almería",
    "codIne": 73,
    "codCatastro": 73,
    "nombre": "PATERNA DEL RIO",
    "hojasSigpac": "04073A",
    "esCapital": false,
    "esSegregacion": false
  },
  {
    "codProvincia": 4,
    "provincia": "Almería",
    "codIne": 74,
    "codCatastro": 74,
    "nombre": "PECHINA",
    "hojasSigpac": "04074A",
    "esCapital": false,
    "esSegregacion": false
  },
  {
    "codProvincia": 4,
    "provincia": "Almería",
    "codIne": 75,
    "codCatastro": 75,
    "nombre": "PULPI",
    "hojasSigpac": "04075A",
    "esCapital": false,
    "esSegregacion": false
  },
  {
    "codProvincia": 4,
    "provincia": "Almería",
    "codIne": 76,
    "codCatastro": 76,
    "nombre": "PURCHENA",
    "hojasSigpac": "04076A",
    "esCapital": false,
    "esSegregacion": false
  },
  {
    "codProvincia": 4,
    "provincia": "Almería",
    "codIne": 77,
    "codCatastro": 77,
    "nombre": "RAGOL",
    "hojasSigpac": "04077A",
    "esCapital": false,
    "esSegregacion": false
  },
  {
    "codProvincia": 4,
    "provincia": "Almería",
    "codIne": 78,
    "codCatastro": 78,
    "nombre": "RIOJA",
    "hojasSigpac": "04078A",
    "esCapital": false,
    "esSegregacion": false
  },
  {
    "codProvincia": 4,
    "provincia": "Almería",
    "codIne": 79,
    "codCatastro": 79,
    "nombre": "ROQUETAS DE MAR",
    "hojasSigpac": "04079A",
    "esCapital": false,
    "esSegregacion": false
  },
  {
    "codProvincia": 4,
    "provincia": "Almería",
    "codIne": 80,
    "codCatastro": 80,
    "nombre": "SANTA CRUZ",
    "hojasSigpac": "04080A",
    "esCapital": false,
    "esSegregacion": false
  },
  {
    "codProvincia": 4,
    "provincia": "Almería",
    "codIne": 81,
    "codCatastro": 81,
    "nombre": "SANTA FE DE MONDUJAR",
    "hojasSigpac": "04081A",
    "esCapital": false,
    "esSegregacion": false
  },
  {
    "codProvincia": 4,
    "provincia": "Almería",
    "codIne": 82,
    "codCatastro": 82,
    "nombre": "SENES",
    "hojasSigpac": "04082A",
    "esCapital": false,
    "esSegregacion": false
  },
  {
    "codProvincia": 4,
    "provincia": "Almería",
    "codIne": 83,
    "codCatastro": 83,
    "nombre": "SERON",
    "hojasSigpac": "04083A",
    "esCapital": false,
    "esSegregacion": false
  },
  {
    "codProvincia": 4,
    "provincia": "Almería",
    "codIne": 84,
    "codCatastro": 84,
    "nombre": "SIERRO",
    "hojasSigpac": "04084A",
    "esCapital": false,
    "esSegregacion": false
  },
  {
    "codProvincia": 4,
    "provincia": "Almería",
    "codIne": 85,
    "codCatastro": 85,
    "nombre": "SOMONTIN",
    "hojasSigpac": "04085A",
    "esCapital": false,
    "esSegregacion": false
  },
  {
    "codProvincia": 4,
    "provincia": "Almería",
    "codIne": 86,
    "codCatastro": 86,
    "nombre": "SORBAS",
    "hojasSigpac": "04086A",
    "esCapital": false,
    "esSegregacion": false
  },
  {
    "codProvincia": 4,
    "provincia": "Almería",
    "codIne": 87,
    "codCatastro": 87,
    "nombre": "SUFLI",
    "hojasSigpac": "04087A",
    "esCapital": false,
    "esSegregacion": false
  },
  {
    "codProvincia": 4,
    "provincia": "Almería",
    "codIne": 88,
    "codCatastro": 88,
    "nombre": "TABERNAS",
    "hojasSigpac": "04088A",
    "esCapital": false,
    "esSegregacion": false
  },
  {
    "codProvincia": 4,
    "provincia": "Almería",
    "codIne": 89,
    "codCatastro": 89,
    "nombre": "TABERNO",
    "hojasSigpac": "04089A",
    "esCapital": false,
    "esSegregacion": false
  },
  {
    "codProvincia": 4,
    "provincia": "Almería",
    "codIne": 90,
    "codCatastro": 90,
    "nombre": "TAHAL",
    "hojasSigpac": "04090A",
    "esCapital": false,
    "esSegregacion": false
  },
  {
    "codProvincia": 4,
    "provincia": "Almería",
    "codIne": 91,
    "codCatastro": 91,
    "nombre": "TERQUE",
    "hojasSigpac": "04091A",
    "esCapital": false,
    "esSegregacion": false
  },
  {
    "codProvincia": 4,
    "provincia": "Almería",
    "codIne": 92,
    "codCatastro": 92,
    "nombre": "TIJOLA",
    "hojasSigpac": "04092A",
    "esCapital": false,
    "esSegregacion": false
  },
  {
    "codProvincia": 4,
    "provincia": "Almería",
    "codIne": 93,
    "codCatastro": 93,
    "nombre": "TURRE",
    "hojasSigpac": "04093A",
    "esCapital": false,
    "esSegregacion": false
  },
  {
    "codProvincia": 4,
    "provincia": "Almería",
    "codIne": 94,
    "codCatastro": 94,
    "nombre": "TURRILLAS",
    "hojasSigpac": "04094A",
    "esCapital": false,
    "esSegregacion": false
  },
  {
    "codProvincia": 4,
    "provincia": "Almería",
    "codIne": 95,
    "codCatastro": 95,
    "nombre": "ULEILA DEL CAMPO",
    "hojasSigpac": "04095A",
    "esCapital": false,
    "esSegregacion": false
  },
  {
    "codProvincia": 4,
    "provincia": "Almería",
    "codIne": 96,
    "codCatastro": 96,
    "nombre": "URRACAL",
    "hojasSigpac": "04096A",
    "esCapital": false,
    "esSegregacion": false
  },
  {
    "codProvincia": 4,
    "provincia": "Almería",
    "codIne": 97,
    "codCatastro": 97,
    "nombre": "VELEFIQUE",
    "hojasSigpac": "04097A",
    "esCapital": false,
    "esSegregacion": false
  },
  {
    "codProvincia": 4,
    "provincia": "Almería",
    "codIne": 98,
    "codCatastro": 98,
    "nombre": "VELEZ BLANCO",
    "hojasSigpac": "04098A",
    "esCapital": false,
    "esSegregacion": false
  },
  {
    "codProvincia": 4,
    "provincia": "Almería",
    "codIne": 99,
    "codCatastro": 99,
    "nombre": "VELEZ RUBIO",
    "hojasSigpac": "04099A",
    "esCapital": false,
    "esSegregacion": false
  },
  {
    "codProvincia": 4,
    "provincia": "Almería",
    "codIne": 100,
    "codCatastro": 100,
    "nombre": "VERA",
    "hojasSigpac": "04100A",
    "esCapital": false,
    "esSegregacion": false
  },
  {
    "codProvincia": 4,
    "provincia": "Almería",
    "codIne": 101,
    "codCatastro": 101,
    "nombre": "VIATOR",
    "hojasSigpac": "04101A",
    "esCapital": false,
    "esSegregacion": false
  },
  {
    "codProvincia": 4,
    "provincia": "Almería",
    "codIne": 102,
    "codCatastro": 102,
    "nombre": "VICAR",
    "hojasSigpac": "04102A",
    "esCapital": false,
    "esSegregacion": false
  },
  {
    "codProvincia": 4,
    "provincia": "Almería",
    "codIne": 103,
    "codCatastro": 103,
    "nombre": "ZURGENA",
    "hojasSigpac": "04103A",
    "esCapital": false,
    "esSegregacion": false
  },
  {
    "codProvincia": 4,
    "provincia": "Almería",
    "codIne": 901,
    "codCatastro": 40,
    "nombre": "LAS TRES VILLAS",
    "hojasSigpac": "04040A",
    "esCapital": false,
    "esSegregacion": true
  },
  {
    "codProvincia": 4,
    "provincia": "Almería",
    "codIne": 902,
    "codCatastro": 104,
    "nombre": "EL EJIDO",
    "hojasSigpac": "04104A",
    "esCapital": false,
    "esSegregacion": true
  },
  {
    "codProvincia": 4,
    "provincia": "Almería",
    "codIne": 903,
    "codCatastro": 105,
    "nombre": "LA MOJONERA",
    "hojasSigpac": "04105A",
    "esCapital": false,
    "esSegregacion": true
  },
  {
    "codProvincia": 4,
    "provincia": "Almería",
    "codIne": 904,
    "codCatastro": 106,
    "nombre": "BALANEGRA",
    "hojasSigpac": "04029A",
    "esCapital": false,
    "esSegregacion": true
  },
  {
    "codProvincia": 11,
    "provincia": "Cádiz",
    "codIne": 1,
    "codCatastro": 1,
    "nombre": "ALCALA DE LOS GAZULES",
    "hojasSigpac": "11001A",
    "esCapital": false,
    "esSegregacion": false
  },
  {
    "codProvincia": 11,
    "provincia": "Cádiz",
    "codIne": 2,
    "codCatastro": 2,
    "nombre": "ALCALA DEL VALLE",
    "hojasSigpac": "11002A",
    "esCapital": false,
    "esSegregacion": false
  },
  {
    "codProvincia": 11,
    "provincia": "Cádiz",
    "codIne": 3,
    "codCatastro": 3,
    "nombre": "ALGAR",
    "hojasSigpac": "53003A",
    "esCapital": false,
    "esSegregacion": false
  },
  {
    "codProvincia": 11,
    "provincia": "Cádiz",
    "codIne": 4,
    "codCatastro": 4,
    "nombre": "ALGECIRAS",
    "hojasSigpac": "11004A",
    "esCapital": false,
    "esSegregacion": false
  },
  {
    "codProvincia": 11,
    "provincia": "Cádiz",
    "codIne": 5,
    "codCatastro": 5,
    "nombre": "ALGODONALES",
    "hojasSigpac": "11005A",
    "esCapital": false,
    "esSegregacion": false
  },
  {
    "codProvincia": 11,
    "provincia": "Cádiz",
    "codIne": 6,
    "codCatastro": 6,
    "nombre": "ARCOS DE LA FRONTERA",
    "hojasSigpac": "53006A",
    "esCapital": false,
    "esSegregacion": false
  },
  {
    "codProvincia": 11,
    "provincia": "Cádiz",
    "codIne": 7,
    "codCatastro": 7,
    "nombre": "BARBATE",
    "hojasSigpac": "11007A",
    "esCapital": false,
    "esSegregacion": false
  },
  {
    "codProvincia": 11,
    "provincia": "Cádiz",
    "codIne": 8,
    "codCatastro": 8,
    "nombre": "LOS BARRIOS",
    "hojasSigpac": "11008A",
    "esCapital": false,
    "esSegregacion": false
  },
  {
    "codProvincia": 11,
    "provincia": "Cádiz",
    "codIne": 9,
    "codCatastro": 9,
    "nombre": "BENAOCAZ",
    "hojasSigpac": "11009A",
    "esCapital": false,
    "esSegregacion": false
  },
  {
    "codProvincia": 11,
    "provincia": "Cádiz",
    "codIne": 10,
    "codCatastro": 10,
    "nombre": "BORNOS",
    "hojasSigpac": "53010A",
    "esCapital": false,
    "esSegregacion": false
  },
  {
    "codProvincia": 11,
    "provincia": "Cádiz",
    "codIne": 11,
    "codCatastro": 11,
    "nombre": "EL BOSQUE",
    "hojasSigpac": "11011A",
    "esCapital": false,
    "esSegregacion": false
  },
  {
    "codProvincia": 11,
    "provincia": "Cádiz",
    "codIne": 12,
    "codCatastro": 900,
    "nombre": "CADIZ",
    "hojasSigpac": "11900A",
    "esCapital": true,
    "esSegregacion": false
  },
  {
    "codProvincia": 11,
    "provincia": "Cádiz",
    "codIne": 13,
    "codCatastro": 13,
    "nombre": "CASTELLAR DE LA FRONTERA",
    "hojasSigpac": "11013A",
    "esCapital": false,
    "esSegregacion": false
  },
  {
    "codProvincia": 11,
    "provincia": "Cádiz",
    "codIne": 14,
    "codCatastro": 14,
    "nombre": "CONIL DE LA FRONTERA",
    "hojasSigpac": "11014A",
    "esCapital": false,
    "esSegregacion": false
  },
  {
    "codProvincia": 11,
    "provincia": "Cádiz",
    "codIne": 15,
    "codCatastro": 15,
    "nombre": "CHICLANA DE LA FRONTERA",
    "hojasSigpac": "11015A",
    "esCapital": false,
    "esSegregacion": false
  },
  {
    "codProvincia": 11,
    "provincia": "Cádiz",
    "codIne": 16,
    "codCatastro": 16,
    "nombre": "CHIPIONA",
    "hojasSigpac": "11016A",
    "esCapital": false,
    "esSegregacion": false
  },
  {
    "codProvincia": 11,
    "provincia": "Cádiz",
    "codIne": 17,
    "codCatastro": 17,
    "nombre": "ESPERA",
    "hojasSigpac": "53017A",
    "esCapital": false,
    "esSegregacion": false
  },
  {
    "codProvincia": 11,
    "provincia": "Cádiz",
    "codIne": 18,
    "codCatastro": 18,
    "nombre": "EL GASTOR",
    "hojasSigpac": "11018A",
    "esCapital": false,
    "esSegregacion": false
  },
  {
    "codProvincia": 11,
    "provincia": "Cádiz",
    "codIne": 19,
    "codCatastro": 19,
    "nombre": "GRAZALEMA",
    "hojasSigpac": "11019A",
    "esCapital": false,
    "esSegregacion": false
  },
  {
    "codProvincia": 11,
    "provincia": "Cádiz",
    "codIne": 20,
    "codCatastro": 20,
    "nombre": "JEREZ DE LA FRONTERA",
    "hojasSigpac": "53020A",
    "esCapital": false,
    "esSegregacion": false
  },
  {
    "codProvincia": 11,
    "provincia": "Cádiz",
    "codIne": 21,
    "codCatastro": 21,
    "nombre": "JIMENA DE LA FRONTERA",
    "hojasSigpac": "11021A",
    "esCapital": false,
    "esSegregacion": false
  },
  {
    "codProvincia": 11,
    "provincia": "Cádiz",
    "codIne": 22,
    "codCatastro": 22,
    "nombre": "LA LINEA DE LA CONCEPCION",
    "hojasSigpac": [
      "11022A",
      "11033A"
    ],
    "esCapital": false,
    "esSegregacion": false
  },
  {
    "codProvincia": 11,
    "provincia": "Cádiz",
    "codIne": 23,
    "codCatastro": 23,
    "nombre": "MEDINA-SIDONIA",
    "hojasSigpac": "11023A",
    "esCapital": false,
    "esSegregacion": false
  },
  {
    "codProvincia": 11,
    "provincia": "Cádiz",
    "codIne": 24,
    "codCatastro": 24,
    "nombre": "OLVERA",
    "hojasSigpac": "11024A",
    "esCapital": false,
    "esSegregacion": false
  },
  {
    "codProvincia": 11,
    "provincia": "Cádiz",
    "codIne": 25,
    "codCatastro": 25,
    "nombre": "PATERNA DE RIVERA",
    "hojasSigpac": "11025A",
    "esCapital": false,
    "esSegregacion": false
  },
  {
    "codProvincia": 11,
    "provincia": "Cádiz",
    "codIne": 26,
    "codCatastro": 26,
    "nombre": "PRADO DEL REY",
    "hojasSigpac": "53026A",
    "esCapital": false,
    "esSegregacion": false
  },
  {
    "codProvincia": 11,
    "provincia": "Cádiz",
    "codIne": 27,
    "codCatastro": 27,
    "nombre": "EL PUERTO DE SANTA MARIA",
    "hojasSigpac": "11027A",
    "esCapital": false,
    "esSegregacion": false
  },
  {
    "codProvincia": 11,
    "provincia": "Cádiz",
    "codIne": 28,
    "codCatastro": 28,
    "nombre": "PUERTO REAL",
    "hojasSigpac": "11028A",
    "esCapital": false,
    "esSegregacion": false
  },
  {
    "codProvincia": 11,
    "provincia": "Cádiz",
    "codIne": 29,
    "codCatastro": 29,
    "nombre": "PUERTO SERRANO",
    "hojasSigpac": "11029A",
    "esCapital": false,
    "esSegregacion": false
  },
  {
    "codProvincia": 11,
    "provincia": "Cádiz",
    "codIne": 30,
    "codCatastro": 30,
    "nombre": "ROTA",
    "hojasSigpac": [
      "11027A",
      "11030A"
    ],
    "esCapital": false,
    "esSegregacion": false
  },
  {
    "codProvincia": 11,
    "provincia": "Cádiz",
    "codIne": 31,
    "codCatastro": 31,
    "nombre": "SAN FERNANDO",
    "hojasSigpac": "11031A",
    "esCapital": false,
    "esSegregacion": false
  },
  {
    "codProvincia": 11,
    "provincia": "Cádiz",
    "codIne": 32,
    "codCatastro": 32,
    "nombre": "SANLUCAR DE BARRAMEDA",
    "hojasSigpac": "11032A",
    "esCapital": false,
    "esSegregacion": false
  },
  {
    "codProvincia": 11,
    "provincia": "Cádiz",
    "codIne": 33,
    "codCatastro": 33,
    "nombre": "SAN ROQUE",
    "hojasSigpac": "11033A",
    "esCapital": false,
    "esSegregacion": false
  },
  {
    "codProvincia": 11,
    "provincia": "Cádiz",
    "codIne": 34,
    "codCatastro": 34,
    "nombre": "SETENIL DE LAS BODEGAS",
    "hojasSigpac": "11034A",
    "esCapital": false,
    "esSegregacion": false
  },
  {
    "codProvincia": 11,
    "provincia": "Cádiz",
    "codIne": 35,
    "codCatastro": 35,
    "nombre": "TARIFA",
    "hojasSigpac": "11035A",
    "esCapital": false,
    "esSegregacion": false
  },
  {
    "codProvincia": 11,
    "provincia": "Cádiz",
    "codIne": 36,
    "codCatastro": 36,
    "nombre": "TORRE-ALHAQUIME",
    "hojasSigpac": "11036A",
    "esCapital": false,
    "esSegregacion": false
  },
  {
    "codProvincia": 11,
    "provincia": "Cádiz",
    "codIne": 37,
    "codCatastro": 37,
    "nombre": "TREBUJENA",
    "hojasSigpac": "11037A",
    "esCapital": false,
    "esSegregacion": false
  },
  {
    "codProvincia": 11,
    "provincia": "Cádiz",
    "codIne": 38,
    "codCatastro": 38,
    "nombre": "UBRIQUE",
    "hojasSigpac": "11038A",
    "esCapital": false,
    "esSegregacion": false
  },
  {
    "codProvincia": 11,
    "provincia": "Cádiz",
    "codIne": 39,
    "codCatastro": 39,
    "nombre": "VEJER DE LA FRONTERA",
    "hojasSigpac": [
      "11039A",
      "11039G"
    ],
    "esCapital": false,
    "esSegregacion": false
  },
  {
    "codProvincia": 11,
    "provincia": "Cádiz",
    "codIne": 40,
    "codCatastro": 40,
    "nombre": "VILLALUENGA DEL ROSARIO",
    "hojasSigpac": "11040A",
    "esCapital": false,
    "esSegregacion": false
  },
  {
    "codProvincia": 11,
    "provincia": "Cádiz",
    "codIne": 41,
    "codCatastro": 41,
    "nombre": "VILLAMARTIN",
    "hojasSigpac": "53041A",
    "esCapital": false,
    "esSegregacion": false
  },
  {
    "codProvincia": 11,
    "provincia": "Cádiz",
    "codIne": 42,
    "codCatastro": 42,
    "nombre": "ZAHARA DE LA SIERRA",
    "hojasSigpac": "11042A",
    "esCapital": false,
    "esSegregacion": false
  },
  {
    "codProvincia": 11,
    "provincia": "Cádiz",
    "codIne": 901,
    "codCatastro": 43,
    "nombre": "BENALUP-CASAS VIEJAS",
    "hojasSigpac": "11043A",
    "esCapital": false,
    "esSegregacion": true
  },
  {
    "codProvincia": 11,
    "provincia": "Cádiz",
    "codIne": 902,
    "codCatastro": 44,
    "nombre": "SAN JOSE DEL VALLE",
    "hojasSigpac": "53044A",
    "esCapital": false,
    "esSegregacion": true
  },
  {
    "codProvincia": 11,
    "provincia": "Cádiz",
    "codIne": 903,
    "codCatastro": 45,
    "nombre": "SAN MARTIN DEL TESORILLO",
    "hojasSigpac": "11021A",
    "esCapital": false,
    "esSegregacion": true
  },
  {
    "codProvincia": 14,
    "provincia": "Córdoba",
    "codIne": 1,
    "codCatastro": 1,
    "nombre": "ADAMUZ",
    "hojasSigpac": "14001A",
    "esCapital": false,
    "esSegregacion": false
  },
  {
    "codProvincia": 14,
    "provincia": "Córdoba",
    "codIne": 2,
    "codCatastro": 2,
    "nombre": "AGUILAR",
    "hojasSigpac": "14002A",
    "esCapital": false,
    "esSegregacion": false
  },
  {
    "codProvincia": 14,
    "provincia": "Córdoba",
    "codIne": 3,
    "codCatastro": 3,
    "nombre": "ALCARACEJOS",
    "hojasSigpac": "14003A",
    "esCapital": false,
    "esSegregacion": false
  },
  {
    "codProvincia": 14,
    "provincia": "Córdoba",
    "codIne": 4,
    "codCatastro": 4,
    "nombre": "ALMEDINILLA",
    "hojasSigpac": "14004A",
    "esCapital": false,
    "esSegregacion": false
  },
  {
    "codProvincia": 14,
    "provincia": "Córdoba",
    "codIne": 5,
    "codCatastro": 5,
    "nombre": "ALMODOVAR DEL RIO",
    "hojasSigpac": "14005A",
    "esCapital": false,
    "esSegregacion": false
  },
  {
    "codProvincia": 14,
    "provincia": "Córdoba",
    "codIne": 6,
    "codCatastro": 6,
    "nombre": "AÑORA",
    "hojasSigpac": "14006A",
    "esCapital": false,
    "esSegregacion": false
  },
  {
    "codProvincia": 14,
    "provincia": "Córdoba",
    "codIne": 7,
    "codCatastro": 7,
    "nombre": "BAENA",
    "hojasSigpac": "14007A",
    "esCapital": false,
    "esSegregacion": false
  },
  {
    "codProvincia": 14,
    "provincia": "Córdoba",
    "codIne": 8,
    "codCatastro": 8,
    "nombre": "BELALCAZAR",
    "hojasSigpac": "14008A",
    "esCapital": false,
    "esSegregacion": false
  },
  {
    "codProvincia": 14,
    "provincia": "Córdoba",
    "codIne": 9,
    "codCatastro": 9,
    "nombre": "BELMEZ",
    "hojasSigpac": "14009A",
    "esCapital": false,
    "esSegregacion": false
  },
  {
    "codProvincia": 14,
    "provincia": "Córdoba",
    "codIne": 10,
    "codCatastro": 10,
    "nombre": "BENAMEJI",
    "hojasSigpac": "14010A",
    "esCapital": false,
    "esSegregacion": false
  },
  {
    "codProvincia": 14,
    "provincia": "Córdoba",
    "codIne": 11,
    "codCatastro": 11,
    "nombre": "BLAZQUEZ",
    "hojasSigpac": "14011A",
    "esCapital": false,
    "esSegregacion": false
  },
  {
    "codProvincia": 14,
    "provincia": "Córdoba",
    "codIne": 12,
    "codCatastro": 12,
    "nombre": "BUJALANCE",
    "hojasSigpac": "14012A",
    "esCapital": false,
    "esSegregacion": false
  },
  {
    "codProvincia": 14,
    "provincia": "Córdoba",
    "codIne": 13,
    "codCatastro": 13,
    "nombre": "CABRA",
    "hojasSigpac": "14013A",
    "esCapital": false,
    "esSegregacion": false
  },
  {
    "codProvincia": 14,
    "provincia": "Córdoba",
    "codIne": 14,
    "codCatastro": 14,
    "nombre": "CAÑETE DE LAS TORRES",
    "hojasSigpac": "14014A",
    "esCapital": false,
    "esSegregacion": false
  },
  {
    "codProvincia": 14,
    "provincia": "Córdoba",
    "codIne": 15,
    "codCatastro": 15,
    "nombre": "CARCABUEY",
    "hojasSigpac": "14015A",
    "esCapital": false,
    "esSegregacion": false
  },
  {
    "codProvincia": 14,
    "provincia": "Córdoba",
    "codIne": 16,
    "codCatastro": 16,
    "nombre": "CARDEÑA",
    "hojasSigpac": "14016A",
    "esCapital": false,
    "esSegregacion": false
  },
  {
    "codProvincia": 14,
    "provincia": "Córdoba",
    "codIne": 17,
    "codCatastro": 17,
    "nombre": "LA CARLOTA",
    "hojasSigpac": "14017A",
    "esCapital": false,
    "esSegregacion": false
  },
  {
    "codProvincia": 14,
    "provincia": "Córdoba",
    "codIne": 18,
    "codCatastro": 18,
    "nombre": "EL CARPIO",
    "hojasSigpac": "14018A",
    "esCapital": false,
    "esSegregacion": false
  },
  {
    "codProvincia": 14,
    "provincia": "Córdoba",
    "codIne": 19,
    "codCatastro": 19,
    "nombre": "CASTRO DEL RIO",
    "hojasSigpac": "14019A",
    "esCapital": false,
    "esSegregacion": false
  },
  {
    "codProvincia": 14,
    "provincia": "Córdoba",
    "codIne": 20,
    "codCatastro": 20,
    "nombre": "CONQUISTA",
    "hojasSigpac": "14020A",
    "esCapital": false,
    "esSegregacion": false
  },
  {
    "codProvincia": 14,
    "provincia": "Córdoba",
    "codIne": 21,
    "codCatastro": 900,
    "nombre": "CORDOBA",
    "hojasSigpac": "14900A",
    "esCapital": true,
    "esSegregacion": false
  },
  {
    "codProvincia": 14,
    "provincia": "Córdoba",
    "codIne": 22,
    "codCatastro": 22,
    "nombre": "DOÑA MENCIA",
    "hojasSigpac": "14022A",
    "esCapital": false,
    "esSegregacion": false
  },
  {
    "codProvincia": 14,
    "provincia": "Córdoba",
    "codIne": 23,
    "codCatastro": 23,
    "nombre": "DOS TORRES",
    "hojasSigpac": "14023A",
    "esCapital": false,
    "esSegregacion": false
  },
  {
    "codProvincia": 14,
    "provincia": "Córdoba",
    "codIne": 24,
    "codCatastro": 24,
    "nombre": "ENCINAS REALES",
    "hojasSigpac": "14024A",
    "esCapital": false,
    "esSegregacion": false
  },
  {
    "codProvincia": 14,
    "provincia": "Córdoba",
    "codIne": 25,
    "codCatastro": 25,
    "nombre": "ESPEJO",
    "hojasSigpac": "14025A",
    "esCapital": false,
    "esSegregacion": false
  },
  {
    "codProvincia": 14,
    "provincia": "Córdoba",
    "codIne": 26,
    "codCatastro": 26,
    "nombre": "ESPIEL",
    "hojasSigpac": [
      "14026A",
      "14026B"
    ],
    "esCapital": false,
    "esSegregacion": false
  },
  {
    "codProvincia": 14,
    "provincia": "Córdoba",
    "codIne": 27,
    "codCatastro": 27,
    "nombre": "FERNAN NUÑEZ",
    "hojasSigpac": "14027A",
    "esCapital": false,
    "esSegregacion": false
  },
  {
    "codProvincia": 14,
    "provincia": "Córdoba",
    "codIne": 28,
    "codCatastro": 28,
    "nombre": "FUENTE LA LANCHA",
    "hojasSigpac": "14028A",
    "esCapital": false,
    "esSegregacion": false
  },
  {
    "codProvincia": 14,
    "provincia": "Córdoba",
    "codIne": 29,
    "codCatastro": 29,
    "nombre": "FUENTE OBEJUNA",
    "hojasSigpac": "14029A",
    "esCapital": false,
    "esSegregacion": false
  },
  {
    "codProvincia": 14,
    "provincia": "Córdoba",
    "codIne": 30,
    "codCatastro": 30,
    "nombre": "FUENTE PALMERA",
    "hojasSigpac": "14030A",
    "esCapital": false,
    "esSegregacion": false
  },
  {
    "codProvincia": 14,
    "provincia": "Córdoba",
    "codIne": 31,
    "codCatastro": 31,
    "nombre": "FUENTE TOJAR",
    "hojasSigpac": "14031A",
    "esCapital": false,
    "esSegregacion": false
  },
  {
    "codProvincia": 14,
    "provincia": "Córdoba",
    "codIne": 32,
    "codCatastro": 32,
    "nombre": "LA GRANJUELA",
    "hojasSigpac": "14032A",
    "esCapital": false,
    "esSegregacion": false
  },
  {
    "codProvincia": 14,
    "provincia": "Córdoba",
    "codIne": 33,
    "codCatastro": 33,
    "nombre": "GUADALCAZAR",
    "hojasSigpac": "14033A",
    "esCapital": false,
    "esSegregacion": false
  },
  {
    "codProvincia": 14,
    "provincia": "Córdoba",
    "codIne": 34,
    "codCatastro": 34,
    "nombre": "GUIJO",
    "hojasSigpac": "14034A",
    "esCapital": false,
    "esSegregacion": false
  },
  {
    "codProvincia": 14,
    "provincia": "Córdoba",
    "codIne": 35,
    "codCatastro": 35,
    "nombre": "HINOJOSA DEL DUQUE",
    "hojasSigpac": "14035A",
    "esCapital": false,
    "esSegregacion": false
  },
  {
    "codProvincia": 14,
    "provincia": "Córdoba",
    "codIne": 36,
    "codCatastro": 36,
    "nombre": "HORNACHUELOS",
    "hojasSigpac": "14036A",
    "esCapital": false,
    "esSegregacion": false
  },
  {
    "codProvincia": 14,
    "provincia": "Córdoba",
    "codIne": 37,
    "codCatastro": 37,
    "nombre": "IZNAJAR",
    "hojasSigpac": "14037A",
    "esCapital": false,
    "esSegregacion": false
  },
  {
    "codProvincia": 14,
    "provincia": "Córdoba",
    "codIne": 38,
    "codCatastro": 38,
    "nombre": "LUCENA",
    "hojasSigpac": "14038A",
    "esCapital": false,
    "esSegregacion": false
  },
  {
    "codProvincia": 14,
    "provincia": "Córdoba",
    "codIne": 39,
    "codCatastro": 39,
    "nombre": "LUQUE",
    "hojasSigpac": "14039A",
    "esCapital": false,
    "esSegregacion": false
  },
  {
    "codProvincia": 14,
    "provincia": "Córdoba",
    "codIne": 40,
    "codCatastro": 40,
    "nombre": "MONTALBAN DE CORDOBA",
    "hojasSigpac": "14040A",
    "esCapital": false,
    "esSegregacion": false
  },
  {
    "codProvincia": 14,
    "provincia": "Córdoba",
    "codIne": 41,
    "codCatastro": 41,
    "nombre": "MONTEMAYOR",
    "hojasSigpac": "14041A",
    "esCapital": false,
    "esSegregacion": false
  },
  {
    "codProvincia": 14,
    "provincia": "Córdoba",
    "codIne": 42,
    "codCatastro": 42,
    "nombre": "MONTILLA",
    "hojasSigpac": "14042A",
    "esCapital": false,
    "esSegregacion": false
  },
  {
    "codProvincia": 14,
    "provincia": "Córdoba",
    "codIne": 43,
    "codCatastro": 43,
    "nombre": "MONTORO",
    "hojasSigpac": "14043A",
    "esCapital": false,
    "esSegregacion": false
  },
  {
    "codProvincia": 14,
    "provincia": "Córdoba",
    "codIne": 44,
    "codCatastro": 44,
    "nombre": "MONTURQUE",
    "hojasSigpac": "14044A",
    "esCapital": false,
    "esSegregacion": false
  },
  {
    "codProvincia": 14,
    "provincia": "Córdoba",
    "codIne": 45,
    "codCatastro": 45,
    "nombre": "MORILES",
    "hojasSigpac": "14045A",
    "esCapital": false,
    "esSegregacion": false
  },
  {
    "codProvincia": 14,
    "provincia": "Córdoba",
    "codIne": 46,
    "codCatastro": 46,
    "nombre": "NUEVA CARTEYA",
    "hojasSigpac": "14046A",
    "esCapital": false,
    "esSegregacion": false
  },
  {
    "codProvincia": 14,
    "provincia": "Córdoba",
    "codIne": 47,
    "codCatastro": 47,
    "nombre": "OBEJO",
    "hojasSigpac": "14047A",
    "esCapital": false,
    "esSegregacion": false
  },
  {
    "codProvincia": 14,
    "provincia": "Córdoba",
    "codIne": 48,
    "codCatastro": 48,
    "nombre": "PALENCIANA",
    "hojasSigpac": "14048A",
    "esCapital": false,
    "esSegregacion": false
  },
  {
    "codProvincia": 14,
    "provincia": "Córdoba",
    "codIne": 49,
    "codCatastro": 49,
    "nombre": "PALMA DEL RIO",
    "hojasSigpac": "14049A",
    "esCapital": false,
    "esSegregacion": false
  },
  {
    "codProvincia": 14,
    "provincia": "Córdoba",
    "codIne": 50,
    "codCatastro": 50,
    "nombre": "PEDRO ABAD",
    "hojasSigpac": "14050A",
    "esCapital": false,
    "esSegregacion": false
  },
  {
    "codProvincia": 14,
    "provincia": "Córdoba",
    "codIne": 51,
    "codCatastro": 51,
    "nombre": "PEDROCHE",
    "hojasSigpac": "14051A",
    "esCapital": false,
    "esSegregacion": false
  },
  {
    "codProvincia": 14,
    "provincia": "Córdoba",
    "codIne": 52,
    "codCatastro": 52,
    "nombre": "PEÑARROYA PUEBLONUEVO",
    "hojasSigpac": "14052A",
    "esCapital": false,
    "esSegregacion": false
  },
  {
    "codProvincia": 14,
    "provincia": "Córdoba",
    "codIne": 53,
    "codCatastro": 53,
    "nombre": "POSADAS",
    "hojasSigpac": "14053A",
    "esCapital": false,
    "esSegregacion": false
  },
  {
    "codProvincia": 14,
    "provincia": "Córdoba",
    "codIne": 54,
    "codCatastro": 54,
    "nombre": "POZOBLANCO",
    "hojasSigpac": "14054A",
    "esCapital": false,
    "esSegregacion": false
  },
  {
    "codProvincia": 14,
    "provincia": "Córdoba",
    "codIne": 55,
    "codCatastro": 55,
    "nombre": "PRIEGO DE CORDOBA",
    "hojasSigpac": "14055A",
    "esCapital": false,
    "esSegregacion": false
  },
  {
    "codProvincia": 14,
    "provincia": "Córdoba",
    "codIne": 56,
    "codCatastro": 56,
    "nombre": "PUENTE GENIL",
    "hojasSigpac": "14056A",
    "esCapital": false,
    "esSegregacion": false
  },
  {
    "codProvincia": 14,
    "provincia": "Córdoba",
    "codIne": 57,
    "codCatastro": 57,
    "nombre": "LA RAMBLA",
    "hojasSigpac": "14057A",
    "esCapital": false,
    "esSegregacion": false
  },
  {
    "codProvincia": 14,
    "provincia": "Córdoba",
    "codIne": 58,
    "codCatastro": 58,
    "nombre": "RUTE",
    "hojasSigpac": "14058A",
    "esCapital": false,
    "esSegregacion": false
  },
  {
    "codProvincia": 14,
    "provincia": "Córdoba",
    "codIne": 59,
    "codCatastro": 59,
    "nombre": "SAN SEBASTIAN DE LOS BALLESTER",
    "hojasSigpac": "14059A",
    "esCapital": false,
    "esSegregacion": false
  },
  {
    "codProvincia": 14,
    "provincia": "Córdoba",
    "codIne": 60,
    "codCatastro": 60,
    "nombre": "SANTAELLA",
    "hojasSigpac": "14060A",
    "esCapital": false,
    "esSegregacion": false
  },
  {
    "codProvincia": 14,
    "provincia": "Córdoba",
    "codIne": 61,
    "codCatastro": 61,
    "nombre": "SANTA EUFEMIA",
    "hojasSigpac": "14061A",
    "esCapital": false,
    "esSegregacion": false
  },
  {
    "codProvincia": 14,
    "provincia": "Córdoba",
    "codIne": 62,
    "codCatastro": 62,
    "nombre": "TORRECAMPO",
    "hojasSigpac": "14062A",
    "esCapital": false,
    "esSegregacion": false
  },
  {
    "codProvincia": 14,
    "provincia": "Córdoba",
    "codIne": 63,
    "codCatastro": 63,
    "nombre": "VALENZUELA",
    "hojasSigpac": "14063A",
    "esCapital": false,
    "esSegregacion": false
  },
  {
    "codProvincia": 14,
    "provincia": "Córdoba",
    "codIne": 64,
    "codCatastro": 64,
    "nombre": "VALSEQUILLO",
    "hojasSigpac": "14064A",
    "esCapital": false,
    "esSegregacion": false
  },
  {
    "codProvincia": 14,
    "provincia": "Córdoba",
    "codIne": 65,
    "codCatastro": 65,
    "nombre": "LA VICTORIA",
    "hojasSigpac": "14065A",
    "esCapital": false,
    "esSegregacion": false
  },
  {
    "codProvincia": 14,
    "provincia": "Córdoba",
    "codIne": 66,
    "codCatastro": 66,
    "nombre": "VILLA DEL RIO",
    "hojasSigpac": "14066A",
    "esCapital": false,
    "esSegregacion": false
  },
  {
    "codProvincia": 14,
    "provincia": "Córdoba",
    "codIne": 67,
    "codCatastro": 67,
    "nombre": "VILLAFRANCA DE CORDOBA",
    "hojasSigpac": "14067A",
    "esCapital": false,
    "esSegregacion": false
  },
  {
    "codProvincia": 14,
    "provincia": "Córdoba",
    "codIne": 68,
    "codCatastro": 68,
    "nombre": "VILLAHARTA",
    "hojasSigpac": "14068A",
    "esCapital": false,
    "esSegregacion": false
  },
  {
    "codProvincia": 14,
    "provincia": "Córdoba",
    "codIne": 69,
    "codCatastro": 69,
    "nombre": "VILLANUEVA DE CORDOBA",
    "hojasSigpac": "14069A",
    "esCapital": false,
    "esSegregacion": false
  },
  {
    "codProvincia": 14,
    "provincia": "Córdoba",
    "codIne": 70,
    "codCatastro": 70,
    "nombre": "VILLANUEVA DEL DUQUE",
    "hojasSigpac": "14070A",
    "esCapital": false,
    "esSegregacion": false
  },
  {
    "codProvincia": 14,
    "provincia": "Córdoba",
    "codIne": 71,
    "codCatastro": 71,
    "nombre": "VILLANUEVA DEL REY",
    "hojasSigpac": "14071A",
    "esCapital": false,
    "esSegregacion": false
  },
  {
    "codProvincia": 14,
    "provincia": "Córdoba",
    "codIne": 72,
    "codCatastro": 72,
    "nombre": "VILLARALTO",
    "hojasSigpac": "14072A",
    "esCapital": false,
    "esSegregacion": false
  },
  {
    "codProvincia": 14,
    "provincia": "Córdoba",
    "codIne": 73,
    "codCatastro": 73,
    "nombre": "VILLAVICIOSA DE CORDOBA",
    "hojasSigpac": "14073A",
    "esCapital": false,
    "esSegregacion": false
  },
  {
    "codProvincia": 14,
    "provincia": "Córdoba",
    "codIne": 74,
    "codCatastro": 74,
    "nombre": "EL VISO",
    "hojasSigpac": "14074A",
    "esCapital": false,
    "esSegregacion": false
  },
  {
    "codProvincia": 14,
    "provincia": "Córdoba",
    "codIne": 75,
    "codCatastro": 75,
    "nombre": "ZUHEROS",
    "hojasSigpac": "14075A",
    "esCapital": false,
    "esSegregacion": false
  },
  {
    "codProvincia": 14,
    "provincia": "Córdoba",
    "codIne": 901,
    "codCatastro": 76,
    "nombre": "FUENTE CARRETEROS",
    "hojasSigpac": "14030A",
    "esCapital": false,
    "esSegregacion": true
  },
  {
    "codProvincia": 14,
    "provincia": "Córdoba",
    "codIne": 902,
    "codCatastro": 77,
    "nombre": "LA GUIJARROSA",
    "hojasSigpac": "14060A",
    "esCapital": false,
    "esSegregacion": true
  },
  {
    "codProvincia": 18,
    "provincia": "Granada",
    "codIne": 1,
    "codCatastro": 2,
    "nombre": "AGRON",
    "hojasSigpac": "18002A",
    "esCapital": false,
    "esSegregacion": false
  },
  {
    "codProvincia": 18,
    "provincia": "Granada",
    "codIne": 2,
    "codCatastro": 3,
    "nombre": "ALAMEDILLA",
    "hojasSigpac": "18003A",
    "esCapital": false,
    "esSegregacion": false
  },
  {
    "codProvincia": 18,
    "provincia": "Granada",
    "codIne": 3,
    "codCatastro": 4,
    "nombre": "ALBOLOTE",
    "hojasSigpac": "18004A",
    "esCapital": false,
    "esSegregacion": false
  },
  {
    "codProvincia": 18,
    "provincia": "Granada",
    "codIne": 4,
    "codCatastro": 5,
    "nombre": "ALBONDON",
    "hojasSigpac": "18005A",
    "esCapital": false,
    "esSegregacion": false
  },
  {
    "codProvincia": 18,
    "provincia": "Granada",
    "codIne": 5,
    "codCatastro": 6,
    "nombre": "ALBUÑAN",
    "hojasSigpac": [
      "18006A",
      "18006B"
    ],
    "esCapital": false,
    "esSegregacion": false
  },
  {
    "codProvincia": 18,
    "provincia": "Granada",
    "codIne": 6,
    "codCatastro": 7,
    "nombre": "ALBUÑOL",
    "hojasSigpac": "18007A",
    "esCapital": false,
    "esSegregacion": false
  },
  {
    "codProvincia": 18,
    "provincia": "Granada",
    "codIne": 7,
    "codCatastro": 8,
    "nombre": "ALBUÑUELAS",
    "hojasSigpac": "18008A",
    "esCapital": false,
    "esSegregacion": false
  },
  {
    "codProvincia": 18,
    "provincia": "Granada",
    "codIne": 10,
    "codCatastro": 11,
    "nombre": "ALDEIRE",
    "hojasSigpac": "18011A",
    "esCapital": false,
    "esSegregacion": false
  },
  {
    "codProvincia": 18,
    "provincia": "Granada",
    "codIne": 11,
    "codCatastro": 12,
    "nombre": "ALFACAR",
    "hojasSigpac": "18012A",
    "esCapital": false,
    "esSegregacion": false
  },
  {
    "codProvincia": 18,
    "provincia": "Granada",
    "codIne": 12,
    "codCatastro": 13,
    "nombre": "ALGARINEJO",
    "hojasSigpac": "18013A",
    "esCapital": false,
    "esSegregacion": false
  },
  {
    "codProvincia": 18,
    "provincia": "Granada",
    "codIne": 13,
    "codCatastro": 14,
    "nombre": "ALHAMA DE GRANADA",
    "hojasSigpac": "18014A",
    "esCapital": false,
    "esSegregacion": false
  },
  {
    "codProvincia": 18,
    "provincia": "Granada",
    "codIne": 14,
    "codCatastro": 15,
    "nombre": "ALHENDIN",
    "hojasSigpac": "18015A",
    "esCapital": false,
    "esSegregacion": false
  },
  {
    "codProvincia": 18,
    "provincia": "Granada",
    "codIne": 15,
    "codCatastro": 16,
    "nombre": "ALICUN DE ORTEGA",
    "hojasSigpac": "18016A",
    "esCapital": false,
    "esSegregacion": false
  },
  {
    "codProvincia": 18,
    "provincia": "Granada",
    "codIne": 16,
    "codCatastro": 17,
    "nombre": "ALMEGIJAR",
    "hojasSigpac": "18017A",
    "esCapital": false,
    "esSegregacion": false
  },
  {
    "codProvincia": 18,
    "provincia": "Granada",
    "codIne": 17,
    "codCatastro": 18,
    "nombre": "ALMUÑECAR",
    "hojasSigpac": "18018A",
    "esCapital": false,
    "esSegregacion": false
  },
  {
    "codProvincia": 18,
    "provincia": "Granada",
    "codIne": 18,
    "codCatastro": 19,
    "nombre": "ALQUIFE",
    "hojasSigpac": "18019A",
    "esCapital": false,
    "esSegregacion": false
  },
  {
    "codProvincia": 18,
    "provincia": "Granada",
    "codIne": 20,
    "codCatastro": 21,
    "nombre": "ARENAS DEL REY",
    "hojasSigpac": "18021A",
    "esCapital": false,
    "esSegregacion": false
  },
  {
    "codProvincia": 18,
    "provincia": "Granada",
    "codIne": 21,
    "codCatastro": 22,
    "nombre": "ARMILLA",
    "hojasSigpac": "18022A",
    "esCapital": false,
    "esSegregacion": false
  },
  {
    "codProvincia": 18,
    "provincia": "Granada",
    "codIne": 22,
    "codCatastro": 23,
    "nombre": "ATARFE",
    "hojasSigpac": "18023A",
    "esCapital": false,
    "esSegregacion": false
  },
  {
    "codProvincia": 18,
    "provincia": "Granada",
    "codIne": 23,
    "codCatastro": 24,
    "nombre": "BAZA",
    "hojasSigpac": "18024A",
    "esCapital": false,
    "esSegregacion": false
  },
  {
    "codProvincia": 18,
    "provincia": "Granada",
    "codIne": 24,
    "codCatastro": 25,
    "nombre": "BEAS DE GRANADA",
    "hojasSigpac": "18025A",
    "esCapital": false,
    "esSegregacion": false
  },
  {
    "codProvincia": 18,
    "provincia": "Granada",
    "codIne": 25,
    "codCatastro": 26,
    "nombre": "BEAS DE GUADIX",
    "hojasSigpac": "18026A",
    "esCapital": false,
    "esSegregacion": false
  },
  {
    "codProvincia": 18,
    "provincia": "Granada",
    "codIne": 27,
    "codCatastro": 28,
    "nombre": "BENALUA",
    "hojasSigpac": "18028A",
    "esCapital": false,
    "esSegregacion": false
  },
  {
    "codProvincia": 18,
    "provincia": "Granada",
    "codIne": 28,
    "codCatastro": 29,
    "nombre": "BENALUA DE LAS VILLAS",
    "hojasSigpac": "18029A",
    "esCapital": false,
    "esSegregacion": false
  },
  {
    "codProvincia": 18,
    "provincia": "Granada",
    "codIne": 29,
    "codCatastro": 30,
    "nombre": "BENAMAUREL",
    "hojasSigpac": "18030A",
    "esCapital": false,
    "esSegregacion": false
  },
  {
    "codProvincia": 18,
    "provincia": "Granada",
    "codIne": 30,
    "codCatastro": 31,
    "nombre": "BERCHULES",
    "hojasSigpac": "18031A",
    "esCapital": false,
    "esSegregacion": false
  },
  {
    "codProvincia": 18,
    "provincia": "Granada",
    "codIne": 32,
    "codCatastro": 33,
    "nombre": "BUBION",
    "hojasSigpac": "18033A",
    "esCapital": false,
    "esSegregacion": false
  },
  {
    "codProvincia": 18,
    "provincia": "Granada",
    "codIne": 33,
    "codCatastro": 34,
    "nombre": "BUSQUISTAR",
    "hojasSigpac": "18034A",
    "esCapital": false,
    "esSegregacion": false
  },
  {
    "codProvincia": 18,
    "provincia": "Granada",
    "codIne": 34,
    "codCatastro": 35,
    "nombre": "CACIN",
    "hojasSigpac": "18035A",
    "esCapital": false,
    "esSegregacion": false
  },
  {
    "codProvincia": 18,
    "provincia": "Granada",
    "codIne": 35,
    "codCatastro": 36,
    "nombre": "CADIAR",
    "hojasSigpac": "18036A",
    "esCapital": false,
    "esSegregacion": false
  },
  {
    "codProvincia": 18,
    "provincia": "Granada",
    "codIne": 36,
    "codCatastro": 37,
    "nombre": "CAJAR",
    "hojasSigpac": "18037A",
    "esCapital": false,
    "esSegregacion": false
  },
  {
    "codProvincia": 18,
    "provincia": "Granada",
    "codIne": 37,
    "codCatastro": 38,
    "nombre": "CALICASAS",
    "hojasSigpac": "18038A",
    "esCapital": false,
    "esSegregacion": false
  },
  {
    "codProvincia": 18,
    "provincia": "Granada",
    "codIne": 38,
    "codCatastro": 39,
    "nombre": "CAMPOTEJAR",
    "hojasSigpac": "18039A",
    "esCapital": false,
    "esSegregacion": false
  },
  {
    "codProvincia": 18,
    "provincia": "Granada",
    "codIne": 39,
    "codCatastro": 40,
    "nombre": "CANILES",
    "hojasSigpac": "18040A",
    "esCapital": false,
    "esSegregacion": false
  },
  {
    "codProvincia": 18,
    "provincia": "Granada",
    "codIne": 40,
    "codCatastro": 41,
    "nombre": "CAÑAR",
    "hojasSigpac": "18041A",
    "esCapital": false,
    "esSegregacion": false
  },
  {
    "codProvincia": 18,
    "provincia": "Granada",
    "codIne": 42,
    "codCatastro": 43,
    "nombre": "CAPILEIRA",
    "hojasSigpac": "18043A",
    "esCapital": false,
    "esSegregacion": false
  },
  {
    "codProvincia": 18,
    "provincia": "Granada",
    "codIne": 43,
    "codCatastro": 44,
    "nombre": "CARATAUNAS",
    "hojasSigpac": "18044A",
    "esCapital": false,
    "esSegregacion": false
  },
  {
    "codProvincia": 18,
    "provincia": "Granada",
    "codIne": 44,
    "codCatastro": 45,
    "nombre": "CASTARAS",
    "hojasSigpac": "18045A",
    "esCapital": false,
    "esSegregacion": false
  },
  {
    "codProvincia": 18,
    "provincia": "Granada",
    "codIne": 45,
    "codCatastro": 46,
    "nombre": "CASTILLEJAR",
    "hojasSigpac": "18046A",
    "esCapital": false,
    "esSegregacion": false
  },
  {
    "codProvincia": 18,
    "provincia": "Granada",
    "codIne": 46,
    "codCatastro": 47,
    "nombre": "CASTRIL",
    "hojasSigpac": "18047A",
    "esCapital": false,
    "esSegregacion": false
  },
  {
    "codProvincia": 18,
    "provincia": "Granada",
    "codIne": 47,
    "codCatastro": 48,
    "nombre": "CENES DE LA VEGA",
    "hojasSigpac": "18048A",
    "esCapital": false,
    "esSegregacion": false
  },
  {
    "codProvincia": 18,
    "provincia": "Granada",
    "codIne": 48,
    "codCatastro": 49,
    "nombre": "CIJUELA",
    "hojasSigpac": "18049A",
    "esCapital": false,
    "esSegregacion": false
  },
  {
    "codProvincia": 18,
    "provincia": "Granada",
    "codIne": 49,
    "codCatastro": 50,
    "nombre": "COGOLLOS DE GUADIX",
    "hojasSigpac": "18050A",
    "esCapital": false,
    "esSegregacion": false
  },
  {
    "codProvincia": 18,
    "provincia": "Granada",
    "codIne": 50,
    "codCatastro": 51,
    "nombre": "COGOLLOS VEGA",
    "hojasSigpac": "18051A",
    "esCapital": false,
    "esSegregacion": false
  },
  {
    "codProvincia": 18,
    "provincia": "Granada",
    "codIne": 51,
    "codCatastro": 52,
    "nombre": "COLOMERA",
    "hojasSigpac": "18052A",
    "esCapital": false,
    "esSegregacion": false
  },
  {
    "codProvincia": 18,
    "provincia": "Granada",
    "codIne": 53,
    "codCatastro": 54,
    "nombre": "CORTES DE BAZA",
    "hojasSigpac": "18054A",
    "esCapital": false,
    "esSegregacion": false
  },
  {
    "codProvincia": 18,
    "provincia": "Granada",
    "codIne": 54,
    "codCatastro": 55,
    "nombre": "CORTES Y GRAENA",
    "hojasSigpac": "18055A",
    "esCapital": false,
    "esSegregacion": false
  },
  {
    "codProvincia": 18,
    "provincia": "Granada",
    "codIne": 56,
    "codCatastro": 57,
    "nombre": "CULLAR",
    "hojasSigpac": "18057A",
    "esCapital": false,
    "esSegregacion": false
  },
  {
    "codProvincia": 18,
    "provincia": "Granada",
    "codIne": 57,
    "codCatastro": 58,
    "nombre": "CULLAR VEGA",
    "hojasSigpac": "18058A",
    "esCapital": false,
    "esSegregacion": false
  },
  {
    "codProvincia": 18,
    "provincia": "Granada",
    "codIne": 59,
    "codCatastro": 60,
    "nombre": "CHAUCHINA",
    "hojasSigpac": "18060A",
    "esCapital": false,
    "esSegregacion": false
  },
  {
    "codProvincia": 18,
    "provincia": "Granada",
    "codIne": 61,
    "codCatastro": 62,
    "nombre": "CHIMENEAS",
    "hojasSigpac": "18062A",
    "esCapital": false,
    "esSegregacion": false
  },
  {
    "codProvincia": 18,
    "provincia": "Granada",
    "codIne": 62,
    "codCatastro": 64,
    "nombre": "CHURRIANA DE LA VEGA",
    "hojasSigpac": "18064A",
    "esCapital": false,
    "esSegregacion": false
  },
  {
    "codProvincia": 18,
    "provincia": "Granada",
    "codIne": 63,
    "codCatastro": 65,
    "nombre": "DARRO",
    "hojasSigpac": "18065A",
    "esCapital": false,
    "esSegregacion": false
  },
  {
    "codProvincia": 18,
    "provincia": "Granada",
    "codIne": 64,
    "codCatastro": 66,
    "nombre": "DEHESAS DE GUADIX",
    "hojasSigpac": "18066A",
    "esCapital": false,
    "esSegregacion": false
  },
  {
    "codProvincia": 18,
    "provincia": "Granada",
    "codIne": 65,
    "codCatastro": 202,
    "nombre": "DEHESAS VIEJAS",
    "hojasSigpac": [
      "18107A",
      "18107D"
    ],
    "esCapital": false,
    "esSegregacion": false
  },
  {
    "codProvincia": 18,
    "provincia": "Granada",
    "codIne": 66,
    "codCatastro": 68,
    "nombre": "DEIFONTES",
    "hojasSigpac": "18068A",
    "esCapital": false,
    "esSegregacion": false
  },
  {
    "codProvincia": 18,
    "provincia": "Granada",
    "codIne": 67,
    "codCatastro": 69,
    "nombre": "DIEZMA",
    "hojasSigpac": "18069A",
    "esCapital": false,
    "esSegregacion": false
  },
  {
    "codProvincia": 18,
    "provincia": "Granada",
    "codIne": 68,
    "codCatastro": 70,
    "nombre": "DILAR",
    "hojasSigpac": "18070A",
    "esCapital": false,
    "esSegregacion": false
  },
  {
    "codProvincia": 18,
    "provincia": "Granada",
    "codIne": 69,
    "codCatastro": 71,
    "nombre": "DOLAR",
    "hojasSigpac": "18071A",
    "esCapital": false,
    "esSegregacion": false
  },
  {
    "codProvincia": 18,
    "provincia": "Granada",
    "codIne": 70,
    "codCatastro": 72,
    "nombre": "DUDAR",
    "hojasSigpac": "18072A",
    "esCapital": false,
    "esSegregacion": false
  },
  {
    "codProvincia": 18,
    "provincia": "Granada",
    "codIne": 71,
    "codCatastro": 73,
    "nombre": "DURCAL",
    "hojasSigpac": "18073A",
    "esCapital": false,
    "esSegregacion": false
  },
  {
    "codProvincia": 18,
    "provincia": "Granada",
    "codIne": 72,
    "codCatastro": 74,
    "nombre": "ESCUZAR",
    "hojasSigpac": [
      "18074A",
      "18074A"
    ],
    "esCapital": false,
    "esSegregacion": false
  },
  {
    "codProvincia": 18,
    "provincia": "Granada",
    "codIne": 74,
    "codCatastro": 76,
    "nombre": "FERREIRA",
    "hojasSigpac": "18076A",
    "esCapital": false,
    "esSegregacion": false
  },
  {
    "codProvincia": 18,
    "provincia": "Granada",
    "codIne": 76,
    "codCatastro": 78,
    "nombre": "FONELAS",
    "hojasSigpac": "18078A",
    "esCapital": false,
    "esSegregacion": false
  },
  {
    "codProvincia": 18,
    "provincia": "Granada",
    "codIne": 77,
    "codCatastro": 79,
    "nombre": "FORNES",
    "hojasSigpac": "18021A",
    "esCapital": false,
    "esSegregacion": false
  },
  {
    "codProvincia": 18,
    "provincia": "Granada",
    "codIne": 78,
    "codCatastro": 80,
    "nombre": "FREILA",
    "hojasSigpac": "18080A",
    "esCapital": false,
    "esSegregacion": false
  },
  {
    "codProvincia": 18,
    "provincia": "Granada",
    "codIne": 79,
    "codCatastro": 81,
    "nombre": "FUENTE VAQUEROS",
    "hojasSigpac": "18081A",
    "esCapital": false,
    "esSegregacion": false
  },
  {
    "codProvincia": 18,
    "provincia": "Granada",
    "codIne": 82,
    "codCatastro": 84,
    "nombre": "GALERA",
    "hojasSigpac": "18084A",
    "esCapital": false,
    "esSegregacion": false
  },
  {
    "codProvincia": 18,
    "provincia": "Granada",
    "codIne": 83,
    "codCatastro": 85,
    "nombre": "GOBERNADOR",
    "hojasSigpac": "18085A",
    "esCapital": false,
    "esSegregacion": false
  },
  {
    "codProvincia": 18,
    "provincia": "Granada",
    "codIne": 84,
    "codCatastro": 86,
    "nombre": "GOJAR",
    "hojasSigpac": "18086A",
    "esCapital": false,
    "esSegregacion": false
  },
  {
    "codProvincia": 18,
    "provincia": "Granada",
    "codIne": 85,
    "codCatastro": 87,
    "nombre": "GOR",
    "hojasSigpac": "18087A",
    "esCapital": false,
    "esSegregacion": false
  },
  {
    "codProvincia": 18,
    "provincia": "Granada",
    "codIne": 86,
    "codCatastro": 88,
    "nombre": "GORAFE",
    "hojasSigpac": "18088A",
    "esCapital": false,
    "esSegregacion": false
  },
  {
    "codProvincia": 18,
    "provincia": "Granada",
    "codIne": 87,
    "codCatastro": 900,
    "nombre": "GRANADA",
    "hojasSigpac": "18900A",
    "esCapital": true,
    "esSegregacion": false
  },
  {
    "codProvincia": 18,
    "provincia": "Granada",
    "codIne": 88,
    "codCatastro": 90,
    "nombre": "GUADAHORTUNA",
    "hojasSigpac": "18090A",
    "esCapital": false,
    "esSegregacion": false
  },
  {
    "codProvincia": 18,
    "provincia": "Granada",
    "codIne": 89,
    "codCatastro": 91,
    "nombre": "GUADIX",
    "hojasSigpac": "18091A",
    "esCapital": false,
    "esSegregacion": false
  },
  {
    "codProvincia": 18,
    "provincia": "Granada",
    "codIne": 93,
    "codCatastro": 95,
    "nombre": "GUALCHOS",
    "hojasSigpac": "18095A",
    "esCapital": false,
    "esSegregacion": false
  },
  {
    "codProvincia": 18,
    "provincia": "Granada",
    "codIne": 94,
    "codCatastro": 96,
    "nombre": "GUEJAR SIERRA",
    "hojasSigpac": "18096A",
    "esCapital": false,
    "esSegregacion": false
  },
  {
    "codProvincia": 18,
    "provincia": "Granada",
    "codIne": 95,
    "codCatastro": 97,
    "nombre": "GUEVEJAR",
    "hojasSigpac": "18097A",
    "esCapital": false,
    "esSegregacion": false
  },
  {
    "codProvincia": 18,
    "provincia": "Granada",
    "codIne": 96,
    "codCatastro": 98,
    "nombre": "HUELAGO",
    "hojasSigpac": "18098A",
    "esCapital": false,
    "esSegregacion": false
  },
  {
    "codProvincia": 18,
    "provincia": "Granada",
    "codIne": 97,
    "codCatastro": 99,
    "nombre": "HUENEJA",
    "hojasSigpac": "18099A",
    "esCapital": false,
    "esSegregacion": false
  },
  {
    "codProvincia": 18,
    "provincia": "Granada",
    "codIne": 98,
    "codCatastro": 100,
    "nombre": "HUESCAR",
    "hojasSigpac": "18100A",
    "esCapital": false,
    "esSegregacion": false
  },
  {
    "codProvincia": 18,
    "provincia": "Granada",
    "codIne": 99,
    "codCatastro": 101,
    "nombre": "HUETOR SANTILLAN",
    "hojasSigpac": "18101A",
    "esCapital": false,
    "esSegregacion": false
  },
  {
    "codProvincia": 18,
    "provincia": "Granada",
    "codIne": 100,
    "codCatastro": 102,
    "nombre": "HUETOR TAJAR",
    "hojasSigpac": "18102A",
    "esCapital": false,
    "esSegregacion": false
  },
  {
    "codProvincia": 18,
    "provincia": "Granada",
    "codIne": 101,
    "codCatastro": 103,
    "nombre": "HUETOR VEGA",
    "hojasSigpac": "18103A",
    "esCapital": false,
    "esSegregacion": false
  },
  {
    "codProvincia": 18,
    "provincia": "Granada",
    "codIne": 102,
    "codCatastro": 104,
    "nombre": "ILLORA",
    "hojasSigpac": [
      "18104A",
      "18104B"
    ],
    "esCapital": false,
    "esSegregacion": false
  },
  {
    "codProvincia": 18,
    "provincia": "Granada",
    "codIne": 103,
    "codCatastro": 106,
    "nombre": "ITRABO",
    "hojasSigpac": "18106A",
    "esCapital": false,
    "esSegregacion": false
  },
  {
    "codProvincia": 18,
    "provincia": "Granada",
    "codIne": 105,
    "codCatastro": 107,
    "nombre": "IZNALLOZ",
    "hojasSigpac": "18107A",
    "esCapital": false,
    "esSegregacion": false
  },
  {
    "codProvincia": 18,
    "provincia": "Granada",
    "codIne": 106,
    "codCatastro": 108,
    "nombre": "JATAR",
    "hojasSigpac": "18021A",
    "esCapital": false,
    "esSegregacion": false
  },
  {
    "codProvincia": 18,
    "provincia": "Granada",
    "codIne": 107,
    "codCatastro": 109,
    "nombre": "JAYENA",
    "hojasSigpac": "18109A",
    "esCapital": false,
    "esSegregacion": false
  },
  {
    "codProvincia": 18,
    "provincia": "Granada",
    "codIne": 108,
    "codCatastro": 110,
    "nombre": "JEREZ DEL MARQUESADO",
    "hojasSigpac": "18110A",
    "esCapital": false,
    "esSegregacion": false
  },
  {
    "codProvincia": 18,
    "provincia": "Granada",
    "codIne": 109,
    "codCatastro": 111,
    "nombre": "JETE",
    "hojasSigpac": "18111A",
    "esCapital": false,
    "esSegregacion": false
  },
  {
    "codProvincia": 18,
    "provincia": "Granada",
    "codIne": 111,
    "codCatastro": 113,
    "nombre": "JUN",
    "hojasSigpac": "18113A",
    "esCapital": false,
    "esSegregacion": false
  },
  {
    "codProvincia": 18,
    "provincia": "Granada",
    "codIne": 112,
    "codCatastro": 114,
    "nombre": "JUVILES",
    "hojasSigpac": "18114A",
    "esCapital": false,
    "esSegregacion": false
  },
  {
    "codProvincia": 18,
    "provincia": "Granada",
    "codIne": 114,
    "codCatastro": 116,
    "nombre": "LACALAHORRA",
    "hojasSigpac": "18116A",
    "esCapital": false,
    "esSegregacion": false
  },
  {
    "codProvincia": 18,
    "provincia": "Granada",
    "codIne": 115,
    "codCatastro": 117,
    "nombre": "LACHAR",
    "hojasSigpac": "18117A",
    "esCapital": false,
    "esSegregacion": false
  },
  {
    "codProvincia": 18,
    "provincia": "Granada",
    "codIne": 116,
    "codCatastro": 118,
    "nombre": "LANJARON",
    "hojasSigpac": "18118A",
    "esCapital": false,
    "esSegregacion": false
  },
  {
    "codProvincia": 18,
    "provincia": "Granada",
    "codIne": 117,
    "codCatastro": 119,
    "nombre": "LANTEIRA",
    "hojasSigpac": "18119A",
    "esCapital": false,
    "esSegregacion": false
  },
  {
    "codProvincia": 18,
    "provincia": "Granada",
    "codIne": 119,
    "codCatastro": 63,
    "nombre": "LECRIN",
    "hojasSigpac": "18063A",
    "esCapital": false,
    "esSegregacion": false
  },
  {
    "codProvincia": 18,
    "provincia": "Granada",
    "codIne": 120,
    "codCatastro": 121,
    "nombre": "LENTEJI",
    "hojasSigpac": "18121A",
    "esCapital": false,
    "esSegregacion": false
  },
  {
    "codProvincia": 18,
    "provincia": "Granada",
    "codIne": 121,
    "codCatastro": 122,
    "nombre": "LOBRAS",
    "hojasSigpac": "18122A",
    "esCapital": false,
    "esSegregacion": false
  },
  {
    "codProvincia": 18,
    "provincia": "Granada",
    "codIne": 122,
    "codCatastro": 123,
    "nombre": "LOJA",
    "hojasSigpac": "18123A",
    "esCapital": false,
    "esSegregacion": false
  },
  {
    "codProvincia": 18,
    "provincia": "Granada",
    "codIne": 123,
    "codCatastro": 124,
    "nombre": "LUGROS",
    "hojasSigpac": "18124A",
    "esCapital": false,
    "esSegregacion": false
  },
  {
    "codProvincia": 18,
    "provincia": "Granada",
    "codIne": 124,
    "codCatastro": 125,
    "nombre": "LUJAR",
    "hojasSigpac": "18125A",
    "esCapital": false,
    "esSegregacion": false
  },
  {
    "codProvincia": 18,
    "provincia": "Granada",
    "codIne": 126,
    "codCatastro": 127,
    "nombre": "LA MALAHA",
    "hojasSigpac": "18127A",
    "esCapital": false,
    "esSegregacion": false
  },
  {
    "codProvincia": 18,
    "provincia": "Granada",
    "codIne": 127,
    "codCatastro": 128,
    "nombre": "MARACENA",
    "hojasSigpac": "18128A",
    "esCapital": false,
    "esSegregacion": false
  },
  {
    "codProvincia": 18,
    "provincia": "Granada",
    "codIne": 128,
    "codCatastro": 129,
    "nombre": "MARCHAL",
    "hojasSigpac": "18129A",
    "esCapital": false,
    "esSegregacion": false
  },
  {
    "codProvincia": 18,
    "provincia": "Granada",
    "codIne": 132,
    "codCatastro": 133,
    "nombre": "MOCLIN",
    "hojasSigpac": "18133A",
    "esCapital": false,
    "esSegregacion": false
  },
  {
    "codProvincia": 18,
    "provincia": "Granada",
    "codIne": 133,
    "codCatastro": 134,
    "nombre": "MOLVIZAR",
    "hojasSigpac": "18134A",
    "esCapital": false,
    "esSegregacion": false
  },
  {
    "codProvincia": 18,
    "provincia": "Granada",
    "codIne": 134,
    "codCatastro": 135,
    "nombre": "MONACHIL",
    "hojasSigpac": "18135A",
    "esCapital": false,
    "esSegregacion": false
  },
  {
    "codProvincia": 18,
    "provincia": "Granada",
    "codIne": 135,
    "codCatastro": 137,
    "nombre": "MONTEFRIO",
    "hojasSigpac": "18137A",
    "esCapital": false,
    "esSegregacion": false
  },
  {
    "codProvincia": 18,
    "provincia": "Granada",
    "codIne": 136,
    "codCatastro": 138,
    "nombre": "MONTEJICAR",
    "hojasSigpac": "18138A",
    "esCapital": false,
    "esSegregacion": false
  },
  {
    "codProvincia": 18,
    "provincia": "Granada",
    "codIne": 137,
    "codCatastro": 139,
    "nombre": "MONTILLANA",
    "hojasSigpac": "18139A",
    "esCapital": false,
    "esSegregacion": false
  },
  {
    "codProvincia": 18,
    "provincia": "Granada",
    "codIne": 138,
    "codCatastro": 140,
    "nombre": "MORALEDA DE ZAFAYONA",
    "hojasSigpac": "18140A",
    "esCapital": false,
    "esSegregacion": false
  },
  {
    "codProvincia": 18,
    "provincia": "Granada",
    "codIne": 140,
    "codCatastro": 142,
    "nombre": "MOTRIL",
    "hojasSigpac": "18142A",
    "esCapital": false,
    "esSegregacion": false
  },
  {
    "codProvincia": 18,
    "provincia": "Granada",
    "codIne": 141,
    "codCatastro": 144,
    "nombre": "MURTAS",
    "hojasSigpac": "18144A",
    "esCapital": false,
    "esSegregacion": false
  },
  {
    "codProvincia": 18,
    "provincia": "Granada",
    "codIne": 143,
    "codCatastro": 146,
    "nombre": "NIGUELAS",
    "hojasSigpac": "18146A",
    "esCapital": false,
    "esSegregacion": false
  },
  {
    "codProvincia": 18,
    "provincia": "Granada",
    "codIne": 144,
    "codCatastro": 147,
    "nombre": "NIVAR",
    "hojasSigpac": "18147A",
    "esCapital": false,
    "esSegregacion": false
  },
  {
    "codProvincia": 18,
    "provincia": "Granada",
    "codIne": 145,
    "codCatastro": 148,
    "nombre": "OGIJARES",
    "hojasSigpac": "18148A",
    "esCapital": false,
    "esSegregacion": false
  },
  {
    "codProvincia": 18,
    "provincia": "Granada",
    "codIne": 146,
    "codCatastro": 149,
    "nombre": "ORCE",
    "hojasSigpac": "18149A",
    "esCapital": false,
    "esSegregacion": false
  },
  {
    "codProvincia": 18,
    "provincia": "Granada",
    "codIne": 147,
    "codCatastro": 150,
    "nombre": "ORGIVA",
    "hojasSigpac": "18150A",
    "esCapital": false,
    "esSegregacion": false
  },
  {
    "codProvincia": 18,
    "provincia": "Granada",
    "codIne": 148,
    "codCatastro": 151,
    "nombre": "OTIVAR",
    "hojasSigpac": "18151A",
    "esCapital": false,
    "esSegregacion": false
  },
  {
    "codProvincia": 18,
    "provincia": "Granada",
    "codIne": 149,
    "codCatastro": 152,
    "nombre": "VILLA DE OTURA",
    "hojasSigpac": "18152A",
    "esCapital": false,
    "esSegregacion": false
  },
  {
    "codProvincia": 18,
    "provincia": "Granada",
    "codIne": 150,
    "codCatastro": 153,
    "nombre": "PADUL",
    "hojasSigpac": "18153A",
    "esCapital": false,
    "esSegregacion": false
  },
  {
    "codProvincia": 18,
    "provincia": "Granada",
    "codIne": 151,
    "codCatastro": 154,
    "nombre": "PAMPANEIRA",
    "hojasSigpac": "18154A",
    "esCapital": false,
    "esSegregacion": false
  },
  {
    "codProvincia": 18,
    "provincia": "Granada",
    "codIne": 152,
    "codCatastro": 155,
    "nombre": "PEDRO MARTINEZ",
    "hojasSigpac": "18155A",
    "esCapital": false,
    "esSegregacion": false
  },
  {
    "codProvincia": 18,
    "provincia": "Granada",
    "codIne": 153,
    "codCatastro": 156,
    "nombre": "PELIGROS",
    "hojasSigpac": "18156A",
    "esCapital": false,
    "esSegregacion": false
  },
  {
    "codProvincia": 18,
    "provincia": "Granada",
    "codIne": 154,
    "codCatastro": 157,
    "nombre": "LA PEZA",
    "hojasSigpac": "18157A",
    "esCapital": false,
    "esSegregacion": false
  },
  {
    "codProvincia": 18,
    "provincia": "Granada",
    "codIne": 157,
    "codCatastro": 160,
    "nombre": "PINOS GENIL",
    "hojasSigpac": "18160A",
    "esCapital": false,
    "esSegregacion": false
  },
  {
    "codProvincia": 18,
    "provincia": "Granada",
    "codIne": 158,
    "codCatastro": 161,
    "nombre": "PINOS PUENTE",
    "hojasSigpac": [
      "18161A",
      "18161B"
    ],
    "esCapital": false,
    "esSegregacion": false
  },
  {
    "codProvincia": 18,
    "provincia": "Granada",
    "codIne": 159,
    "codCatastro": 162,
    "nombre": "PIÑAR",
    "hojasSigpac": "18162A",
    "esCapital": false,
    "esSegregacion": false
  },
  {
    "codProvincia": 18,
    "provincia": "Granada",
    "codIne": 161,
    "codCatastro": 164,
    "nombre": "POLICAR",
    "hojasSigpac": "18164A",
    "esCapital": false,
    "esSegregacion": false
  },
  {
    "codProvincia": 18,
    "provincia": "Granada",
    "codIne": 162,
    "codCatastro": 165,
    "nombre": "POLOPOS",
    "hojasSigpac": "18165A",
    "esCapital": false,
    "esSegregacion": false
  },
  {
    "codProvincia": 18,
    "provincia": "Granada",
    "codIne": 163,
    "codCatastro": 166,
    "nombre": "PORTUGOS",
    "hojasSigpac": "18166A",
    "esCapital": false,
    "esSegregacion": false
  },
  {
    "codProvincia": 18,
    "provincia": "Granada",
    "codIne": 164,
    "codCatastro": 167,
    "nombre": "PUEBLA DE DON FADRIQUE",
    "hojasSigpac": "18167A",
    "esCapital": false,
    "esSegregacion": false
  },
  {
    "codProvincia": 18,
    "provincia": "Granada",
    "codIne": 165,
    "codCatastro": 168,
    "nombre": "PULIANAS",
    "hojasSigpac": "18168A",
    "esCapital": false,
    "esSegregacion": false
  },
  {
    "codProvincia": 18,
    "provincia": "Granada",
    "codIne": 167,
    "codCatastro": 170,
    "nombre": "PURULLENA",
    "hojasSigpac": "18170A",
    "esCapital": false,
    "esSegregacion": false
  },
  {
    "codProvincia": 18,
    "provincia": "Granada",
    "codIne": 168,
    "codCatastro": 171,
    "nombre": "QUENTAR",
    "hojasSigpac": "18171A",
    "esCapital": false,
    "esSegregacion": false
  },
  {
    "codProvincia": 18,
    "provincia": "Granada",
    "codIne": 170,
    "codCatastro": 173,
    "nombre": "RUBITE",
    "hojasSigpac": "18173A",
    "esCapital": false,
    "esSegregacion": false
  },
  {
    "codProvincia": 18,
    "provincia": "Granada",
    "codIne": 171,
    "codCatastro": 174,
    "nombre": "SALAR",
    "hojasSigpac": "18174A",
    "esCapital": false,
    "esSegregacion": false
  },
  {
    "codProvincia": 18,
    "provincia": "Granada",
    "codIne": 173,
    "codCatastro": 176,
    "nombre": "SALOBREÑA",
    "hojasSigpac": "18176A",
    "esCapital": false,
    "esSegregacion": false
  },
  {
    "codProvincia": 18,
    "provincia": "Granada",
    "codIne": 174,
    "codCatastro": 177,
    "nombre": "SANTA CRUZ DEL COMERCIO",
    "hojasSigpac": "18177A",
    "esCapital": false,
    "esSegregacion": false
  },
  {
    "codProvincia": 18,
    "provincia": "Granada",
    "codIne": 175,
    "codCatastro": 178,
    "nombre": "SANTA FE",
    "hojasSigpac": "18178A",
    "esCapital": false,
    "esSegregacion": false
  },
  {
    "codProvincia": 18,
    "provincia": "Granada",
    "codIne": 176,
    "codCatastro": 179,
    "nombre": "SOPORTUJAR",
    "hojasSigpac": "18179A",
    "esCapital": false,
    "esSegregacion": false
  },
  {
    "codProvincia": 18,
    "provincia": "Granada",
    "codIne": 177,
    "codCatastro": 180,
    "nombre": "SORVILAN",
    "hojasSigpac": "18180A",
    "esCapital": false,
    "esSegregacion": false
  },
  {
    "codProvincia": 18,
    "provincia": "Granada",
    "codIne": 178,
    "codCatastro": 181,
    "nombre": "TORRE CARDELA",
    "hojasSigpac": "18181A",
    "esCapital": false,
    "esSegregacion": false
  },
  {
    "codProvincia": 18,
    "provincia": "Granada",
    "codIne": 179,
    "codCatastro": 182,
    "nombre": "TORVIZCON",
    "hojasSigpac": "18182A",
    "esCapital": false,
    "esSegregacion": false
  },
  {
    "codProvincia": 18,
    "provincia": "Granada",
    "codIne": 180,
    "codCatastro": 183,
    "nombre": "TREVELEZ",
    "hojasSigpac": "18183A",
    "esCapital": false,
    "esSegregacion": false
  },
  {
    "codProvincia": 18,
    "provincia": "Granada",
    "codIne": 181,
    "codCatastro": 185,
    "nombre": "TURON",
    "hojasSigpac": "18185A",
    "esCapital": false,
    "esSegregacion": false
  },
  {
    "codProvincia": 18,
    "provincia": "Granada",
    "codIne": 182,
    "codCatastro": 186,
    "nombre": "UGIJAR",
    "hojasSigpac": "18186A",
    "esCapital": false,
    "esSegregacion": false
  },
  {
    "codProvincia": 18,
    "provincia": "Granada",
    "codIne": 183,
    "codCatastro": 187,
    "nombre": "VALOR",
    "hojasSigpac": "18187A",
    "esCapital": false,
    "esSegregacion": false
  },
  {
    "codProvincia": 18,
    "provincia": "Granada",
    "codIne": 184,
    "codCatastro": 188,
    "nombre": "VELEZ DE BENAUDALLA",
    "hojasSigpac": "18188A",
    "esCapital": false,
    "esSegregacion": false
  },
  {
    "codProvincia": 18,
    "provincia": "Granada",
    "codIne": 185,
    "codCatastro": 189,
    "nombre": "VENTAS DE HUELMA",
    "hojasSigpac": "18189A",
    "esCapital": false,
    "esSegregacion": false
  },
  {
    "codProvincia": 18,
    "provincia": "Granada",
    "codIne": 187,
    "codCatastro": 191,
    "nombre": "VILLANUEVA DE LAS TORRES",
    "hojasSigpac": "18191A",
    "esCapital": false,
    "esSegregacion": false
  },
  {
    "codProvincia": 18,
    "provincia": "Granada",
    "codIne": 188,
    "codCatastro": 192,
    "nombre": "VILLANUEVA MESIA",
    "hojasSigpac": "18192A",
    "esCapital": false,
    "esSegregacion": false
  },
  {
    "codProvincia": 18,
    "provincia": "Granada",
    "codIne": 189,
    "codCatastro": 193,
    "nombre": "VIZNAR",
    "hojasSigpac": "18193A",
    "esCapital": false,
    "esSegregacion": false
  },
  {
    "codProvincia": 18,
    "provincia": "Granada",
    "codIne": 192,
    "codCatastro": 196,
    "nombre": "ZAFARRAYA",
    "hojasSigpac": "18196A",
    "esCapital": false,
    "esSegregacion": false
  },
  {
    "codProvincia": 18,
    "provincia": "Granada",
    "codIne": 193,
    "codCatastro": 197,
    "nombre": "LA ZUBIA",
    "hojasSigpac": "18197A",
    "esCapital": false,
    "esSegregacion": false
  },
  {
    "codProvincia": 18,
    "provincia": "Granada",
    "codIne": 194,
    "codCatastro": 198,
    "nombre": "ZUJAR",
    "hojasSigpac": "18198A",
    "esCapital": false,
    "esSegregacion": false
  },
  {
    "codProvincia": 18,
    "provincia": "Granada",
    "codIne": 901,
    "codCatastro": 163,
    "nombre": "LA TAHA",
    "hojasSigpac": "18163A",
    "esCapital": false,
    "esSegregacion": true
  },
  {
    "codProvincia": 18,
    "provincia": "Granada",
    "codIne": 902,
    "codCatastro": 132,
    "nombre": "EL VALLE",
    "hojasSigpac": "18132A",
    "esCapital": false,
    "esSegregacion": true
  },
  {
    "codProvincia": 18,
    "provincia": "Granada",
    "codIne": 903,
    "codCatastro": 120,
    "nombre": "NEVADA",
    "hojasSigpac": "18120A",
    "esCapital": false,
    "esSegregacion": true
  },
  {
    "codProvincia": 18,
    "provincia": "Granada",
    "codIne": 904,
    "codCatastro": 130,
    "nombre": "ALPUJARRA DE LA SIERRA",
    "hojasSigpac": "18130A",
    "esCapital": false,
    "esSegregacion": true
  },
  {
    "codProvincia": 18,
    "provincia": "Granada",
    "codIne": 905,
    "codCatastro": 83,
    "nombre": "LAS GABIAS",
    "hojasSigpac": "18083A",
    "esCapital": false,
    "esSegregacion": true
  },
  {
    "codProvincia": 18,
    "provincia": "Granada",
    "codIne": 906,
    "codCatastro": 92,
    "nombre": "LOS GUAJARES",
    "hojasSigpac": "18092A",
    "esCapital": false,
    "esSegregacion": true
  },
  {
    "codProvincia": 18,
    "provincia": "Granada",
    "codIne": 907,
    "codCatastro": 59,
    "nombre": "VALLE DEL ZALABI",
    "hojasSigpac": "18059A",
    "esCapital": false,
    "esSegregacion": true
  },
  {
    "codProvincia": 18,
    "provincia": "Granada",
    "codIne": 908,
    "codCatastro": 53,
    "nombre": "VILLAMENA",
    "hojasSigpac": "18053A",
    "esCapital": false,
    "esSegregacion": true
  },
  {
    "codProvincia": 18,
    "provincia": "Granada",
    "codIne": 909,
    "codCatastro": 141,
    "nombre": "MORELABOR",
    "hojasSigpac": "18141A",
    "esCapital": false,
    "esSegregacion": true
  },
  {
    "codProvincia": 18,
    "provincia": "Granada",
    "codIne": 910,
    "codCatastro": 105,
    "nombre": "EL PINAR",
    "hojasSigpac": "18105A",
    "esCapital": false,
    "esSegregacion": true
  },
  {
    "codProvincia": 18,
    "provincia": "Granada",
    "codIne": 911,
    "codCatastro": 20,
    "nombre": "VEGAS DEL GENIL",
    "hojasSigpac": "18020A",
    "esCapital": false,
    "esSegregacion": true
  },
  {
    "codProvincia": 18,
    "provincia": "Granada",
    "codIne": 912,
    "codCatastro": 199,
    "nombre": "CUEVAS CAMPO",
    "hojasSigpac": "18199A",
    "esCapital": false,
    "esSegregacion": true
  },
  {
    "codProvincia": 18,
    "provincia": "Granada",
    "codIne": 913,
    "codCatastro": 200,
    "nombre": "ZAGRA",
    "hojasSigpac": "18200A",
    "esCapital": false,
    "esSegregacion": true
  },
  {
    "codProvincia": 18,
    "provincia": "Granada",
    "codIne": 914,
    "codCatastro": 201,
    "nombre": "VALDERRUBIO",
    "hojasSigpac": "18201B",
    "esCapital": false,
    "esSegregacion": true
  },
  {
    "codProvincia": 18,
    "provincia": "Granada",
    "codIne": 915,
    "codCatastro": 204,
    "nombre": "DOMINGO PEREZ DE GRANADA",
    "hojasSigpac": "18107A",
    "esCapital": false,
    "esSegregacion": true
  },
  {
    "codProvincia": 18,
    "provincia": "Granada",
    "codIne": 916,
    "codCatastro": 205,
    "nombre": "TORRENUEVA-COSTA",
    "hojasSigpac": "18142A",
    "esCapital": false,
    "esSegregacion": true
  },
  {
    "codProvincia": 21,
    "provincia": "Huelva",
    "codIne": 1,
    "codCatastro": 1,
    "nombre": "ALAJAR",
    "hojasSigpac": "21001A",
    "esCapital": false,
    "esSegregacion": false
  },
  {
    "codProvincia": 21,
    "provincia": "Huelva",
    "codIne": 2,
    "codCatastro": 2,
    "nombre": "ALJARAQUE",
    "hojasSigpac": "21002A",
    "esCapital": false,
    "esSegregacion": false
  },
  {
    "codProvincia": 21,
    "provincia": "Huelva",
    "codIne": 3,
    "codCatastro": 3,
    "nombre": "EL ALMENDRO",
    "hojasSigpac": "21003A",
    "esCapital": false,
    "esSegregacion": false
  },
  {
    "codProvincia": 21,
    "provincia": "Huelva",
    "codIne": 4,
    "codCatastro": 4,
    "nombre": "ALMONASTER LA REAL",
    "hojasSigpac": "21004A",
    "esCapital": false,
    "esSegregacion": false
  },
  {
    "codProvincia": 21,
    "provincia": "Huelva",
    "codIne": 5,
    "codCatastro": 5,
    "nombre": "ALMONTE",
    "hojasSigpac": "21005A",
    "esCapital": false,
    "esSegregacion": false
  },
  {
    "codProvincia": 21,
    "provincia": "Huelva",
    "codIne": 6,
    "codCatastro": 6,
    "nombre": "ALOSNO",
    "hojasSigpac": "21006A",
    "esCapital": false,
    "esSegregacion": false
  },
  {
    "codProvincia": 21,
    "provincia": "Huelva",
    "codIne": 7,
    "codCatastro": 7,
    "nombre": "ARACENA",
    "hojasSigpac": "21007A",
    "esCapital": false,
    "esSegregacion": false
  },
  {
    "codProvincia": 21,
    "provincia": "Huelva",
    "codIne": 8,
    "codCatastro": 8,
    "nombre": "AROCHE",
    "hojasSigpac": "21008A",
    "esCapital": false,
    "esSegregacion": false
  },
  {
    "codProvincia": 21,
    "provincia": "Huelva",
    "codIne": 9,
    "codCatastro": 9,
    "nombre": "ARROYOMOLINOS DE LEON",
    "hojasSigpac": "21009A",
    "esCapital": false,
    "esSegregacion": false
  },
  {
    "codProvincia": 21,
    "provincia": "Huelva",
    "codIne": 10,
    "codCatastro": 10,
    "nombre": "AYAMONTE",
    "hojasSigpac": "21010A",
    "esCapital": false,
    "esSegregacion": false
  },
  {
    "codProvincia": 21,
    "provincia": "Huelva",
    "codIne": 11,
    "codCatastro": 11,
    "nombre": "BEAS",
    "hojasSigpac": "21011A",
    "esCapital": false,
    "esSegregacion": false
  },
  {
    "codProvincia": 21,
    "provincia": "Huelva",
    "codIne": 12,
    "codCatastro": 12,
    "nombre": "BERROCAL",
    "hojasSigpac": "21012A",
    "esCapital": false,
    "esSegregacion": false
  },
  {
    "codProvincia": 21,
    "provincia": "Huelva",
    "codIne": 13,
    "codCatastro": 13,
    "nombre": "BOLLULLOS PAR DEL CONDADO",
    "hojasSigpac": "21013A",
    "esCapital": false,
    "esSegregacion": false
  },
  {
    "codProvincia": 21,
    "provincia": "Huelva",
    "codIne": 14,
    "codCatastro": 14,
    "nombre": "BONARES",
    "hojasSigpac": "21014A",
    "esCapital": false,
    "esSegregacion": false
  },
  {
    "codProvincia": 21,
    "provincia": "Huelva",
    "codIne": 15,
    "codCatastro": 15,
    "nombre": "CABEZAS RUBIAS",
    "hojasSigpac": "21015A",
    "esCapital": false,
    "esSegregacion": false
  },
  {
    "codProvincia": 21,
    "provincia": "Huelva",
    "codIne": 16,
    "codCatastro": 16,
    "nombre": "CALA",
    "hojasSigpac": "21016A",
    "esCapital": false,
    "esSegregacion": false
  },
  {
    "codProvincia": 21,
    "provincia": "Huelva",
    "codIne": 17,
    "codCatastro": 17,
    "nombre": "CALAÑAS",
    "hojasSigpac": "21017A",
    "esCapital": false,
    "esSegregacion": false
  },
  {
    "codProvincia": 21,
    "provincia": "Huelva",
    "codIne": 18,
    "codCatastro": 18,
    "nombre": "EL CAMPILLO",
    "hojasSigpac": "21018A",
    "esCapital": false,
    "esSegregacion": false
  },
  {
    "codProvincia": 21,
    "provincia": "Huelva",
    "codIne": 19,
    "codCatastro": 19,
    "nombre": "CAMPOFRIO",
    "hojasSigpac": "21019A",
    "esCapital": false,
    "esSegregacion": false
  },
  {
    "codProvincia": 21,
    "provincia": "Huelva",
    "codIne": 20,
    "codCatastro": 20,
    "nombre": "CAÑAVERAL DE LEON",
    "hojasSigpac": "21020A",
    "esCapital": false,
    "esSegregacion": false
  },
  {
    "codProvincia": 21,
    "provincia": "Huelva",
    "codIne": 21,
    "codCatastro": 21,
    "nombre": "CARTAYA",
    "hojasSigpac": "21021A",
    "esCapital": false,
    "esSegregacion": false
  },
  {
    "codProvincia": 21,
    "provincia": "Huelva",
    "codIne": 22,
    "codCatastro": 22,
    "nombre": "CASTAÑO DEL ROBLEDO",
    "hojasSigpac": "21022A",
    "esCapital": false,
    "esSegregacion": false
  },
  {
    "codProvincia": 21,
    "provincia": "Huelva",
    "codIne": 23,
    "codCatastro": 23,
    "nombre": "EL CERRO DEL ANDEVALO",
    "hojasSigpac": "21023A",
    "esCapital": false,
    "esSegregacion": false
  },
  {
    "codProvincia": 21,
    "provincia": "Huelva",
    "codIne": 24,
    "codCatastro": 24,
    "nombre": "CORTECONCEPCION",
    "hojasSigpac": "21024A",
    "esCapital": false,
    "esSegregacion": false
  },
  {
    "codProvincia": 21,
    "provincia": "Huelva",
    "codIne": 25,
    "codCatastro": 25,
    "nombre": "CORTEGANA",
    "hojasSigpac": "21025A",
    "esCapital": false,
    "esSegregacion": false
  },
  {
    "codProvincia": 21,
    "provincia": "Huelva",
    "codIne": 26,
    "codCatastro": 26,
    "nombre": "CORTELAZOR",
    "hojasSigpac": "21026A",
    "esCapital": false,
    "esSegregacion": false
  },
  {
    "codProvincia": 21,
    "provincia": "Huelva",
    "codIne": 27,
    "codCatastro": 27,
    "nombre": "CUMBRES DE ENMEDIO",
    "hojasSigpac": "21027A",
    "esCapital": false,
    "esSegregacion": false
  },
  {
    "codProvincia": 21,
    "provincia": "Huelva",
    "codIne": 28,
    "codCatastro": 28,
    "nombre": "CUMBRES DE SAN BARTOLOME",
    "hojasSigpac": "21028A",
    "esCapital": false,
    "esSegregacion": false
  },
  {
    "codProvincia": 21,
    "provincia": "Huelva",
    "codIne": 29,
    "codCatastro": 29,
    "nombre": "CUMBRES MAYORES",
    "hojasSigpac": "21029A",
    "esCapital": false,
    "esSegregacion": false
  },
  {
    "codProvincia": 21,
    "provincia": "Huelva",
    "codIne": 30,
    "codCatastro": 30,
    "nombre": "CHUCENA",
    "hojasSigpac": "21030A",
    "esCapital": false,
    "esSegregacion": false
  },
  {
    "codProvincia": 21,
    "provincia": "Huelva",
    "codIne": 31,
    "codCatastro": 31,
    "nombre": "ENCINASOLA",
    "hojasSigpac": "21031A",
    "esCapital": false,
    "esSegregacion": false
  },
  {
    "codProvincia": 21,
    "provincia": "Huelva",
    "codIne": 32,
    "codCatastro": 32,
    "nombre": "ESCACENA DEL CAMPO",
    "hojasSigpac": "21032A",
    "esCapital": false,
    "esSegregacion": false
  },
  {
    "codProvincia": 21,
    "provincia": "Huelva",
    "codIne": 33,
    "codCatastro": 33,
    "nombre": "FUENTEHERIDOS",
    "hojasSigpac": "21033A",
    "esCapital": false,
    "esSegregacion": false
  },
  {
    "codProvincia": 21,
    "provincia": "Huelva",
    "codIne": 34,
    "codCatastro": 34,
    "nombre": "GALAROZA",
    "hojasSigpac": "21034A",
    "esCapital": false,
    "esSegregacion": false
  },
  {
    "codProvincia": 21,
    "provincia": "Huelva",
    "codIne": 35,
    "codCatastro": 35,
    "nombre": "GIBRALEON",
    "hojasSigpac": "21035A",
    "esCapital": false,
    "esSegregacion": false
  },
  {
    "codProvincia": 21,
    "provincia": "Huelva",
    "codIne": 36,
    "codCatastro": 36,
    "nombre": "LA GRANADA DE RIOTINTO",
    "hojasSigpac": "21036A",
    "esCapital": false,
    "esSegregacion": false
  },
  {
    "codProvincia": 21,
    "provincia": "Huelva",
    "codIne": 37,
    "codCatastro": 37,
    "nombre": "EL GRANADO",
    "hojasSigpac": "21037A",
    "esCapital": false,
    "esSegregacion": false
  },
  {
    "codProvincia": 21,
    "provincia": "Huelva",
    "codIne": 38,
    "codCatastro": 38,
    "nombre": "HIGUERA DE LA SIERRA",
    "hojasSigpac": "21038A",
    "esCapital": false,
    "esSegregacion": false
  },
  {
    "codProvincia": 21,
    "provincia": "Huelva",
    "codIne": 39,
    "codCatastro": 39,
    "nombre": "HINOJALES",
    "hojasSigpac": "21039A",
    "esCapital": false,
    "esSegregacion": false
  },
  {
    "codProvincia": 21,
    "provincia": "Huelva",
    "codIne": 40,
    "codCatastro": 40,
    "nombre": "HINOJOS",
    "hojasSigpac": "21040A",
    "esCapital": false,
    "esSegregacion": false
  },
  {
    "codProvincia": 21,
    "provincia": "Huelva",
    "codIne": 41,
    "codCatastro": 900,
    "nombre": "HUELVA",
    "hojasSigpac": "21900A",
    "esCapital": true,
    "esSegregacion": false
  },
  {
    "codProvincia": 21,
    "provincia": "Huelva",
    "codIne": 42,
    "codCatastro": 42,
    "nombre": "ISLA CRISTINA",
    "hojasSigpac": "21042A",
    "esCapital": false,
    "esSegregacion": false
  },
  {
    "codProvincia": 21,
    "provincia": "Huelva",
    "codIne": 43,
    "codCatastro": 43,
    "nombre": "JABUGO",
    "hojasSigpac": "21043A",
    "esCapital": false,
    "esSegregacion": false
  },
  {
    "codProvincia": 21,
    "provincia": "Huelva",
    "codIne": 44,
    "codCatastro": 44,
    "nombre": "LEPE",
    "hojasSigpac": "21044A",
    "esCapital": false,
    "esSegregacion": false
  },
  {
    "codProvincia": 21,
    "provincia": "Huelva",
    "codIne": 45,
    "codCatastro": 45,
    "nombre": "LINARES DE LA SIERRA",
    "hojasSigpac": "21045A",
    "esCapital": false,
    "esSegregacion": false
  },
  {
    "codProvincia": 21,
    "provincia": "Huelva",
    "codIne": 46,
    "codCatastro": 46,
    "nombre": "LUCENA DEL PUERTO",
    "hojasSigpac": "21046A",
    "esCapital": false,
    "esSegregacion": false
  },
  {
    "codProvincia": 21,
    "provincia": "Huelva",
    "codIne": 47,
    "codCatastro": 47,
    "nombre": "MANZANILLA",
    "hojasSigpac": "21047A",
    "esCapital": false,
    "esSegregacion": false
  },
  {
    "codProvincia": 21,
    "provincia": "Huelva",
    "codIne": 48,
    "codCatastro": 48,
    "nombre": "MARINES LOS",
    "hojasSigpac": "21048A",
    "esCapital": false,
    "esSegregacion": false
  },
  {
    "codProvincia": 21,
    "provincia": "Huelva",
    "codIne": 49,
    "codCatastro": 49,
    "nombre": "MINAS DE RIOTINTO",
    "hojasSigpac": "21049A",
    "esCapital": false,
    "esSegregacion": false
  },
  {
    "codProvincia": 21,
    "provincia": "Huelva",
    "codIne": 50,
    "codCatastro": 50,
    "nombre": "MOGUER",
    "hojasSigpac": "21050A",
    "esCapital": false,
    "esSegregacion": false
  },
  {
    "codProvincia": 21,
    "provincia": "Huelva",
    "codIne": 51,
    "codCatastro": 51,
    "nombre": "LA NAVA",
    "hojasSigpac": "21051A",
    "esCapital": false,
    "esSegregacion": false
  },
  {
    "codProvincia": 21,
    "provincia": "Huelva",
    "codIne": 52,
    "codCatastro": 52,
    "nombre": "NERVA",
    "hojasSigpac": "21052A",
    "esCapital": false,
    "esSegregacion": false
  },
  {
    "codProvincia": 21,
    "provincia": "Huelva",
    "codIne": 53,
    "codCatastro": 53,
    "nombre": "NIEBLA",
    "hojasSigpac": "21053A",
    "esCapital": false,
    "esSegregacion": false
  },
  {
    "codProvincia": 21,
    "provincia": "Huelva",
    "codIne": 54,
    "codCatastro": 54,
    "nombre": "LA PALMA DEL CONDADO",
    "hojasSigpac": "21054A",
    "esCapital": false,
    "esSegregacion": false
  },
  {
    "codProvincia": 21,
    "provincia": "Huelva",
    "codIne": 55,
    "codCatastro": 55,
    "nombre": "PALOS DE LA FRONTERA",
    "hojasSigpac": "21055A",
    "esCapital": false,
    "esSegregacion": false
  },
  {
    "codProvincia": 21,
    "provincia": "Huelva",
    "codIne": 56,
    "codCatastro": 56,
    "nombre": "PATERNA DEL CAMPO",
    "hojasSigpac": "21056A",
    "esCapital": false,
    "esSegregacion": false
  },
  {
    "codProvincia": 21,
    "provincia": "Huelva",
    "codIne": 57,
    "codCatastro": 57,
    "nombre": "PAYMOGO",
    "hojasSigpac": "21057A",
    "esCapital": false,
    "esSegregacion": false
  },
  {
    "codProvincia": 21,
    "provincia": "Huelva",
    "codIne": 58,
    "codCatastro": 58,
    "nombre": "PUEBLA DE GUZMAN",
    "hojasSigpac": "21058A",
    "esCapital": false,
    "esSegregacion": false
  },
  {
    "codProvincia": 21,
    "provincia": "Huelva",
    "codIne": 59,
    "codCatastro": 59,
    "nombre": "PUERTO MORAL",
    "hojasSigpac": "21059A",
    "esCapital": false,
    "esSegregacion": false
  },
  {
    "codProvincia": 21,
    "provincia": "Huelva",
    "codIne": 60,
    "codCatastro": 79,
    "nombre": "PUNTA UMBRIA",
    "hojasSigpac": "21079A",
    "esCapital": false,
    "esSegregacion": false
  },
  {
    "codProvincia": 21,
    "provincia": "Huelva",
    "codIne": 61,
    "codCatastro": 60,
    "nombre": "ROCIANA DEL CONDADO",
    "hojasSigpac": "21060A",
    "esCapital": false,
    "esSegregacion": false
  },
  {
    "codProvincia": 21,
    "provincia": "Huelva",
    "codIne": 62,
    "codCatastro": 61,
    "nombre": "ROSAL DE LA FRONTERA",
    "hojasSigpac": "21061A",
    "esCapital": false,
    "esSegregacion": false
  },
  {
    "codProvincia": 21,
    "provincia": "Huelva",
    "codIne": 63,
    "codCatastro": 62,
    "nombre": "SAN BARTOLOME TORRE",
    "hojasSigpac": "21062A",
    "esCapital": false,
    "esSegregacion": false
  },
  {
    "codProvincia": 21,
    "provincia": "Huelva",
    "codIne": 64,
    "codCatastro": 63,
    "nombre": "SAN JUAN DEL PUERTO",
    "hojasSigpac": "21063A",
    "esCapital": false,
    "esSegregacion": false
  },
  {
    "codProvincia": 21,
    "provincia": "Huelva",
    "codIne": 65,
    "codCatastro": 64,
    "nombre": "SANLUCAR DE GUADIANA",
    "hojasSigpac": "21064A",
    "esCapital": false,
    "esSegregacion": false
  },
  {
    "codProvincia": 21,
    "provincia": "Huelva",
    "codIne": 66,
    "codCatastro": 65,
    "nombre": "SAN SILVESTRE DE GUZMAN",
    "hojasSigpac": "21065A",
    "esCapital": false,
    "esSegregacion": false
  },
  {
    "codProvincia": 21,
    "provincia": "Huelva",
    "codIne": 67,
    "codCatastro": 66,
    "nombre": "SANTA ANA LA REAL",
    "hojasSigpac": "21066A",
    "esCapital": false,
    "esSegregacion": false
  },
  {
    "codProvincia": 21,
    "provincia": "Huelva",
    "codIne": 68,
    "codCatastro": 67,
    "nombre": "SANTA BARBARA DE CASA",
    "hojasSigpac": "21067A",
    "esCapital": false,
    "esSegregacion": false
  },
  {
    "codProvincia": 21,
    "provincia": "Huelva",
    "codIne": 69,
    "codCatastro": 68,
    "nombre": "SANTA OLALLA DEL CALA",
    "hojasSigpac": "21068A",
    "esCapital": false,
    "esSegregacion": false
  },
  {
    "codProvincia": 21,
    "provincia": "Huelva",
    "codIne": 70,
    "codCatastro": 69,
    "nombre": "TRIGUEROS",
    "hojasSigpac": "21069A",
    "esCapital": false,
    "esSegregacion": false
  },
  {
    "codProvincia": 21,
    "provincia": "Huelva",
    "codIne": 71,
    "codCatastro": 70,
    "nombre": "VALDELARCO",
    "hojasSigpac": "21070A",
    "esCapital": false,
    "esSegregacion": false
  },
  {
    "codProvincia": 21,
    "provincia": "Huelva",
    "codIne": 72,
    "codCatastro": 71,
    "nombre": "VALVERDE DEL CAMINO",
    "hojasSigpac": "21071A",
    "esCapital": false,
    "esSegregacion": false
  },
  {
    "codProvincia": 21,
    "provincia": "Huelva",
    "codIne": 73,
    "codCatastro": 72,
    "nombre": "VILLABLANCA",
    "hojasSigpac": "21072A",
    "esCapital": false,
    "esSegregacion": false
  },
  {
    "codProvincia": 21,
    "provincia": "Huelva",
    "codIne": 74,
    "codCatastro": 73,
    "nombre": "VILLALBA DEL ALCOR",
    "hojasSigpac": "21073A",
    "esCapital": false,
    "esSegregacion": false
  },
  {
    "codProvincia": 21,
    "provincia": "Huelva",
    "codIne": 75,
    "codCatastro": 74,
    "nombre": "VILLANUEVA DE LAS CRUCES",
    "hojasSigpac": "21074A",
    "esCapital": false,
    "esSegregacion": false
  },
  {
    "codProvincia": 21,
    "provincia": "Huelva",
    "codIne": 76,
    "codCatastro": 75,
    "nombre": "VILLANUEVA DE LOS CASTILLEJOS",
    "hojasSigpac": "21075A",
    "esCapital": false,
    "esSegregacion": false
  },
  {
    "codProvincia": 21,
    "provincia": "Huelva",
    "codIne": 77,
    "codCatastro": 76,
    "nombre": "VILLARRASA",
    "hojasSigpac": "21076A",
    "esCapital": false,
    "esSegregacion": false
  },
  {
    "codProvincia": 21,
    "provincia": "Huelva",
    "codIne": 78,
    "codCatastro": 77,
    "nombre": "ZALAMEA LA REAL",
    "hojasSigpac": "21077A",
    "esCapital": false,
    "esSegregacion": false
  },
  {
    "codProvincia": 21,
    "provincia": "Huelva",
    "codIne": 79,
    "codCatastro": 78,
    "nombre": "ZUFRE",
    "hojasSigpac": "21078A",
    "esCapital": false,
    "esSegregacion": false
  },
  {
    "codProvincia": 21,
    "provincia": "Huelva",
    "codIne": 902,
    "codCatastro": 80,
    "nombre": "LA ZARZA - PERRUNAL",
    "hojasSigpac": "21017A",
    "esCapital": false,
    "esSegregacion": true
  },
  {
    "codProvincia": 23,
    "provincia": "Jaén",
    "codIne": 1,
    "codCatastro": 1,
    "nombre": "ALBANCHEZ DE MAGINA",
    "hojasSigpac": "23001A",
    "esCapital": false,
    "esSegregacion": false
  },
  {
    "codProvincia": 23,
    "provincia": "Jaén",
    "codIne": 2,
    "codCatastro": 2,
    "nombre": "ALCALA LA REAL",
    "hojasSigpac": "23002A",
    "esCapital": false,
    "esSegregacion": false
  },
  {
    "codProvincia": 23,
    "provincia": "Jaén",
    "codIne": 3,
    "codCatastro": 3,
    "nombre": "ALCAUDETE",
    "hojasSigpac": "23003A",
    "esCapital": false,
    "esSegregacion": false
  },
  {
    "codProvincia": 23,
    "provincia": "Jaén",
    "codIne": 4,
    "codCatastro": 4,
    "nombre": "ALDEAQUEMADA",
    "hojasSigpac": "23004A",
    "esCapital": false,
    "esSegregacion": false
  },
  {
    "codProvincia": 23,
    "provincia": "Jaén",
    "codIne": 5,
    "codCatastro": 5,
    "nombre": "ANDUJAR",
    "hojasSigpac": "23005A",
    "esCapital": false,
    "esSegregacion": false
  },
  {
    "codProvincia": 23,
    "provincia": "Jaén",
    "codIne": 6,
    "codCatastro": 6,
    "nombre": "ARJONA",
    "hojasSigpac": "23006A",
    "esCapital": false,
    "esSegregacion": false
  },
  {
    "codProvincia": 23,
    "provincia": "Jaén",
    "codIne": 7,
    "codCatastro": 7,
    "nombre": "ARJONILLA",
    "hojasSigpac": "23007A",
    "esCapital": false,
    "esSegregacion": false
  },
  {
    "codProvincia": 23,
    "provincia": "Jaén",
    "codIne": 8,
    "codCatastro": 8,
    "nombre": "ARQUILLOS",
    "hojasSigpac": "23008A",
    "esCapital": false,
    "esSegregacion": false
  },
  {
    "codProvincia": 23,
    "provincia": "Jaén",
    "codIne": 9,
    "codCatastro": 9,
    "nombre": "BAEZA",
    "hojasSigpac": "23009A",
    "esCapital": false,
    "esSegregacion": false
  },
  {
    "codProvincia": 23,
    "provincia": "Jaén",
    "codIne": 10,
    "codCatastro": 10,
    "nombre": "BAILEN",
    "hojasSigpac": "23010A",
    "esCapital": false,
    "esSegregacion": false
  },
  {
    "codProvincia": 23,
    "provincia": "Jaén",
    "codIne": 11,
    "codCatastro": 11,
    "nombre": "BAÑOS DE LA ENCINA",
    "hojasSigpac": "23011A",
    "esCapital": false,
    "esSegregacion": false
  },
  {
    "codProvincia": 23,
    "provincia": "Jaén",
    "codIne": 12,
    "codCatastro": 12,
    "nombre": "BEAS DE SEGURA",
    "hojasSigpac": "23012A",
    "esCapital": false,
    "esSegregacion": false
  },
  {
    "codProvincia": 23,
    "provincia": "Jaén",
    "codIne": 14,
    "codCatastro": 14,
    "nombre": "BEGIJAR",
    "hojasSigpac": "23014A",
    "esCapital": false,
    "esSegregacion": false
  },
  {
    "codProvincia": 23,
    "provincia": "Jaén",
    "codIne": 15,
    "codCatastro": 15,
    "nombre": "BELMEZ DE LA MORALEDA",
    "hojasSigpac": "23015A",
    "esCapital": false,
    "esSegregacion": false
  },
  {
    "codProvincia": 23,
    "provincia": "Jaén",
    "codIne": 16,
    "codCatastro": 16,
    "nombre": "BENATAE",
    "hojasSigpac": "23016A",
    "esCapital": false,
    "esSegregacion": false
  },
  {
    "codProvincia": 23,
    "provincia": "Jaén",
    "codIne": 17,
    "codCatastro": 17,
    "nombre": "CABRA DEL SANTO CRISTO",
    "hojasSigpac": "23017A",
    "esCapital": false,
    "esSegregacion": false
  },
  {
    "codProvincia": 23,
    "provincia": "Jaén",
    "codIne": 18,
    "codCatastro": 18,
    "nombre": "CAMBIL",
    "hojasSigpac": "23018A",
    "esCapital": false,
    "esSegregacion": false
  },
  {
    "codProvincia": 23,
    "provincia": "Jaén",
    "codIne": 19,
    "codCatastro": 19,
    "nombre": "CAMPILLO DE ARENAS",
    "hojasSigpac": "23019A",
    "esCapital": false,
    "esSegregacion": false
  },
  {
    "codProvincia": 23,
    "provincia": "Jaén",
    "codIne": 20,
    "codCatastro": 20,
    "nombre": "CANENA",
    "hojasSigpac": "23020A",
    "esCapital": false,
    "esSegregacion": false
  },
  {
    "codProvincia": 23,
    "provincia": "Jaén",
    "codIne": 21,
    "codCatastro": 21,
    "nombre": "CARBONEROS",
    "hojasSigpac": "23021A",
    "esCapital": false,
    "esSegregacion": false
  },
  {
    "codProvincia": 23,
    "provincia": "Jaén",
    "codIne": 24,
    "codCatastro": 24,
    "nombre": "LA CAROLINA",
    "hojasSigpac": "23024A",
    "esCapital": false,
    "esSegregacion": false
  },
  {
    "codProvincia": 23,
    "provincia": "Jaén",
    "codIne": 25,
    "codCatastro": 25,
    "nombre": "CASTELLAR",
    "hojasSigpac": "23025A",
    "esCapital": false,
    "esSegregacion": false
  },
  {
    "codProvincia": 23,
    "provincia": "Jaén",
    "codIne": 26,
    "codCatastro": 26,
    "nombre": "CASTILLO DE LOCUBIN",
    "hojasSigpac": "23026A",
    "esCapital": false,
    "esSegregacion": false
  },
  {
    "codProvincia": 23,
    "provincia": "Jaén",
    "codIne": 27,
    "codCatastro": 27,
    "nombre": "CAZALILLA",
    "hojasSigpac": "23027A",
    "esCapital": false,
    "esSegregacion": false
  },
  {
    "codProvincia": 23,
    "provincia": "Jaén",
    "codIne": 28,
    "codCatastro": 28,
    "nombre": "CAZORLA",
    "hojasSigpac": "23028A",
    "esCapital": false,
    "esSegregacion": false
  },
  {
    "codProvincia": 23,
    "provincia": "Jaén",
    "codIne": 29,
    "codCatastro": 29,
    "nombre": "CHICLANA DE SEGURA",
    "hojasSigpac": "23029A",
    "esCapital": false,
    "esSegregacion": false
  },
  {
    "codProvincia": 23,
    "provincia": "Jaén",
    "codIne": 30,
    "codCatastro": 30,
    "nombre": "CHILLUEVAR",
    "hojasSigpac": "23030A",
    "esCapital": false,
    "esSegregacion": false
  },
  {
    "codProvincia": 23,
    "provincia": "Jaén",
    "codIne": 31,
    "codCatastro": 31,
    "nombre": "ESCAÑUELA",
    "hojasSigpac": "23031A",
    "esCapital": false,
    "esSegregacion": false
  },
  {
    "codProvincia": 23,
    "provincia": "Jaén",
    "codIne": 32,
    "codCatastro": 32,
    "nombre": "ESPELUY",
    "hojasSigpac": "23032A",
    "esCapital": false,
    "esSegregacion": false
  },
  {
    "codProvincia": 23,
    "provincia": "Jaén",
    "codIne": 33,
    "codCatastro": 33,
    "nombre": "FRAILES",
    "hojasSigpac": "23033A",
    "esCapital": false,
    "esSegregacion": false
  },
  {
    "codProvincia": 23,
    "provincia": "Jaén",
    "codIne": 34,
    "codCatastro": 34,
    "nombre": "FUENSANTA DE MARTOS",
    "hojasSigpac": "23034A",
    "esCapital": false,
    "esSegregacion": false
  },
  {
    "codProvincia": 23,
    "provincia": "Jaén",
    "codIne": 35,
    "codCatastro": 35,
    "nombre": "FUERTE DEL REY",
    "hojasSigpac": "23035A",
    "esCapital": false,
    "esSegregacion": false
  },
  {
    "codProvincia": 23,
    "provincia": "Jaén",
    "codIne": 37,
    "codCatastro": 37,
    "nombre": "GENAVE",
    "hojasSigpac": "23037A",
    "esCapital": false,
    "esSegregacion": false
  },
  {
    "codProvincia": 23,
    "provincia": "Jaén",
    "codIne": 38,
    "codCatastro": 38,
    "nombre": "LA GUARDIA DE JAEN",
    "hojasSigpac": "23038A",
    "esCapital": false,
    "esSegregacion": false
  },
  {
    "codProvincia": 23,
    "provincia": "Jaén",
    "codIne": 39,
    "codCatastro": 39,
    "nombre": "GUARROMAN",
    "hojasSigpac": "23039A",
    "esCapital": false,
    "esSegregacion": false
  },
  {
    "codProvincia": 23,
    "provincia": "Jaén",
    "codIne": 40,
    "codCatastro": 40,
    "nombre": "LAHIGUERA",
    "hojasSigpac": "23040A",
    "esCapital": false,
    "esSegregacion": false
  },
  {
    "codProvincia": 23,
    "provincia": "Jaén",
    "codIne": 41,
    "codCatastro": 41,
    "nombre": "HIGUERA DE CALATRAVA",
    "hojasSigpac": "23041A",
    "esCapital": false,
    "esSegregacion": false
  },
  {
    "codProvincia": 23,
    "provincia": "Jaén",
    "codIne": 42,
    "codCatastro": 42,
    "nombre": "HINOJARES",
    "hojasSigpac": "23042A",
    "esCapital": false,
    "esSegregacion": false
  },
  {
    "codProvincia": 23,
    "provincia": "Jaén",
    "codIne": 43,
    "codCatastro": 43,
    "nombre": "HORNOS DE SEGURA",
    "hojasSigpac": "23043A",
    "esCapital": false,
    "esSegregacion": false
  },
  {
    "codProvincia": 23,
    "provincia": "Jaén",
    "codIne": 44,
    "codCatastro": 44,
    "nombre": "HUELMA-SOLERA",
    "hojasSigpac": "23044A",
    "esCapital": false,
    "esSegregacion": false
  },
  {
    "codProvincia": 23,
    "provincia": "Jaén",
    "codIne": 45,
    "codCatastro": 45,
    "nombre": "HUESA",
    "hojasSigpac": "23045A",
    "esCapital": false,
    "esSegregacion": false
  },
  {
    "codProvincia": 23,
    "provincia": "Jaén",
    "codIne": 46,
    "codCatastro": 46,
    "nombre": "IBROS",
    "hojasSigpac": "23046A",
    "esCapital": false,
    "esSegregacion": false
  },
  {
    "codProvincia": 23,
    "provincia": "Jaén",
    "codIne": 47,
    "codCatastro": 47,
    "nombre": "LA IRUELA",
    "hojasSigpac": "23047A",
    "esCapital": false,
    "esSegregacion": false
  },
  {
    "codProvincia": 23,
    "provincia": "Jaén",
    "codIne": 48,
    "codCatastro": 48,
    "nombre": "IZNATORAF",
    "hojasSigpac": "23048A",
    "esCapital": false,
    "esSegregacion": false
  },
  {
    "codProvincia": 23,
    "provincia": "Jaén",
    "codIne": 49,
    "codCatastro": 49,
    "nombre": "JABALQUINTO",
    "hojasSigpac": "23049A",
    "esCapital": false,
    "esSegregacion": false
  },
  {
    "codProvincia": 23,
    "provincia": "Jaén",
    "codIne": 50,
    "codCatastro": 900,
    "nombre": "JAEN",
    "hojasSigpac": "23900A",
    "esCapital": true,
    "esSegregacion": false
  },
  {
    "codProvincia": 23,
    "provincia": "Jaén",
    "codIne": 51,
    "codCatastro": 51,
    "nombre": "JAMILENA",
    "hojasSigpac": "23051A",
    "esCapital": false,
    "esSegregacion": false
  },
  {
    "codProvincia": 23,
    "provincia": "Jaén",
    "codIne": 52,
    "codCatastro": 52,
    "nombre": "JIMENA",
    "hojasSigpac": "23052A",
    "esCapital": false,
    "esSegregacion": false
  },
  {
    "codProvincia": 23,
    "provincia": "Jaén",
    "codIne": 53,
    "codCatastro": 53,
    "nombre": "JODAR",
    "hojasSigpac": "23053A",
    "esCapital": false,
    "esSegregacion": false
  },
  {
    "codProvincia": 23,
    "provincia": "Jaén",
    "codIne": 54,
    "codCatastro": 54,
    "nombre": "LARVA",
    "hojasSigpac": "23054A",
    "esCapital": false,
    "esSegregacion": false
  },
  {
    "codProvincia": 23,
    "provincia": "Jaén",
    "codIne": 55,
    "codCatastro": 55,
    "nombre": "LINARES",
    "hojasSigpac": "23055A",
    "esCapital": false,
    "esSegregacion": false
  },
  {
    "codProvincia": 23,
    "provincia": "Jaén",
    "codIne": 56,
    "codCatastro": 56,
    "nombre": "LOPERA",
    "hojasSigpac": "23056A",
    "esCapital": false,
    "esSegregacion": false
  },
  {
    "codProvincia": 23,
    "provincia": "Jaén",
    "codIne": 57,
    "codCatastro": 57,
    "nombre": "LUPION",
    "hojasSigpac": "23057A",
    "esCapital": false,
    "esSegregacion": false
  },
  {
    "codProvincia": 23,
    "provincia": "Jaén",
    "codIne": 58,
    "codCatastro": 58,
    "nombre": "MANCHA REAL",
    "hojasSigpac": "23058A",
    "esCapital": false,
    "esSegregacion": false
  },
  {
    "codProvincia": 23,
    "provincia": "Jaén",
    "codIne": 59,
    "codCatastro": 59,
    "nombre": "MARMOLEJO",
    "hojasSigpac": "23059A",
    "esCapital": false,
    "esSegregacion": false
  },
  {
    "codProvincia": 23,
    "provincia": "Jaén",
    "codIne": 60,
    "codCatastro": 60,
    "nombre": "MARTOS",
    "hojasSigpac": "23060A",
    "esCapital": false,
    "esSegregacion": false
  },
  {
    "codProvincia": 23,
    "provincia": "Jaén",
    "codIne": 61,
    "codCatastro": 61,
    "nombre": "MENGIBAR",
    "hojasSigpac": "23061A",
    "esCapital": false,
    "esSegregacion": false
  },
  {
    "codProvincia": 23,
    "provincia": "Jaén",
    "codIne": 62,
    "codCatastro": 62,
    "nombre": "MONTIZON",
    "hojasSigpac": "23062A",
    "esCapital": false,
    "esSegregacion": false
  },
  {
    "codProvincia": 23,
    "provincia": "Jaén",
    "codIne": 63,
    "codCatastro": 63,
    "nombre": "NAVAS DE SAN JUAN",
    "hojasSigpac": "23063A",
    "esCapital": false,
    "esSegregacion": false
  },
  {
    "codProvincia": 23,
    "provincia": "Jaén",
    "codIne": 64,
    "codCatastro": 64,
    "nombre": "NOALEJO",
    "hojasSigpac": "23064A",
    "esCapital": false,
    "esSegregacion": false
  },
  {
    "codProvincia": 23,
    "provincia": "Jaén",
    "codIne": 65,
    "codCatastro": 65,
    "nombre": "ORCERA",
    "hojasSigpac": "23065A",
    "esCapital": false,
    "esSegregacion": false
  },
  {
    "codProvincia": 23,
    "provincia": "Jaén",
    "codIne": 66,
    "codCatastro": 66,
    "nombre": "PEAL DE BECERRO",
    "hojasSigpac": "23066A",
    "esCapital": false,
    "esSegregacion": false
  },
  {
    "codProvincia": 23,
    "provincia": "Jaén",
    "codIne": 67,
    "codCatastro": 67,
    "nombre": "PEGALAJAR",
    "hojasSigpac": "23067A",
    "esCapital": false,
    "esSegregacion": false
  },
  {
    "codProvincia": 23,
    "provincia": "Jaén",
    "codIne": 69,
    "codCatastro": 69,
    "nombre": "PORCUNA",
    "hojasSigpac": "23069A",
    "esCapital": false,
    "esSegregacion": false
  },
  {
    "codProvincia": 23,
    "provincia": "Jaén",
    "codIne": 70,
    "codCatastro": 70,
    "nombre": "POZO ALCON",
    "hojasSigpac": "23070A",
    "esCapital": false,
    "esSegregacion": false
  },
  {
    "codProvincia": 23,
    "provincia": "Jaén",
    "codIne": 71,
    "codCatastro": 71,
    "nombre": "PUENTE GENAVE",
    "hojasSigpac": "23071A",
    "esCapital": false,
    "esSegregacion": false
  },
  {
    "codProvincia": 23,
    "provincia": "Jaén",
    "codIne": 72,
    "codCatastro": 72,
    "nombre": "LA PUERTA DE SEGURA",
    "hojasSigpac": "23072A",
    "esCapital": false,
    "esSegregacion": false
  },
  {
    "codProvincia": 23,
    "provincia": "Jaén",
    "codIne": 73,
    "codCatastro": 73,
    "nombre": "QUESADA",
    "hojasSigpac": "23073A",
    "esCapital": false,
    "esSegregacion": false
  },
  {
    "codProvincia": 23,
    "provincia": "Jaén",
    "codIne": 74,
    "codCatastro": 74,
    "nombre": "RUS",
    "hojasSigpac": "23074A",
    "esCapital": false,
    "esSegregacion": false
  },
  {
    "codProvincia": 23,
    "provincia": "Jaén",
    "codIne": 75,
    "codCatastro": 75,
    "nombre": "SABIOTE",
    "hojasSigpac": "23075A",
    "esCapital": false,
    "esSegregacion": false
  },
  {
    "codProvincia": 23,
    "provincia": "Jaén",
    "codIne": 76,
    "codCatastro": 76,
    "nombre": "SANTA ELENA",
    "hojasSigpac": "23076A",
    "esCapital": false,
    "esSegregacion": false
  },
  {
    "codProvincia": 23,
    "provincia": "Jaén",
    "codIne": 77,
    "codCatastro": 77,
    "nombre": "SANTIAGO DE CALATRAVA",
    "hojasSigpac": "23077A",
    "esCapital": false,
    "esSegregacion": false
  },
  {
    "codProvincia": 23,
    "provincia": "Jaén",
    "codIne": 79,
    "codCatastro": 79,
    "nombre": "SANTISTEBAN DEL PUERTO",
    "hojasSigpac": "23079A",
    "esCapital": false,
    "esSegregacion": false
  },
  {
    "codProvincia": 23,
    "provincia": "Jaén",
    "codIne": 80,
    "codCatastro": 80,
    "nombre": "SANTO TOME",
    "hojasSigpac": "23080A",
    "esCapital": false,
    "esSegregacion": false
  },
  {
    "codProvincia": 23,
    "provincia": "Jaén",
    "codIne": 81,
    "codCatastro": 81,
    "nombre": "SEGURA DE LA SIERRA",
    "hojasSigpac": "23081A",
    "esCapital": false,
    "esSegregacion": false
  },
  {
    "codProvincia": 23,
    "provincia": "Jaén",
    "codIne": 82,
    "codCatastro": 82,
    "nombre": "SILES",
    "hojasSigpac": "23082A",
    "esCapital": false,
    "esSegregacion": false
  },
  {
    "codProvincia": 23,
    "provincia": "Jaén",
    "codIne": 84,
    "codCatastro": 84,
    "nombre": "SORIHUELA DEL GUADALIMAR",
    "hojasSigpac": "23084A",
    "esCapital": false,
    "esSegregacion": false
  },
  {
    "codProvincia": 23,
    "provincia": "Jaén",
    "codIne": 85,
    "codCatastro": 85,
    "nombre": "TORREBLASCOPEDRO",
    "hojasSigpac": "23085A",
    "esCapital": false,
    "esSegregacion": false
  },
  {
    "codProvincia": 23,
    "provincia": "Jaén",
    "codIne": 86,
    "codCatastro": 86,
    "nombre": "TORREDELCAMPO",
    "hojasSigpac": "23086A",
    "esCapital": false,
    "esSegregacion": false
  },
  {
    "codProvincia": 23,
    "provincia": "Jaén",
    "codIne": 87,
    "codCatastro": 87,
    "nombre": "TORREDONJIMENO",
    "hojasSigpac": "23087A",
    "esCapital": false,
    "esSegregacion": false
  },
  {
    "codProvincia": 23,
    "provincia": "Jaén",
    "codIne": 88,
    "codCatastro": 88,
    "nombre": "TORREPEROGIL",
    "hojasSigpac": "23088A",
    "esCapital": false,
    "esSegregacion": false
  },
  {
    "codProvincia": 23,
    "provincia": "Jaén",
    "codIne": 90,
    "codCatastro": 90,
    "nombre": "TORRES",
    "hojasSigpac": "23090A",
    "esCapital": false,
    "esSegregacion": false
  },
  {
    "codProvincia": 23,
    "provincia": "Jaén",
    "codIne": 91,
    "codCatastro": 91,
    "nombre": "TORRES DE ALBANCHEZ",
    "hojasSigpac": "23091A",
    "esCapital": false,
    "esSegregacion": false
  },
  {
    "codProvincia": 23,
    "provincia": "Jaén",
    "codIne": 92,
    "codCatastro": 92,
    "nombre": "UBEDA",
    "hojasSigpac": "23092A",
    "esCapital": false,
    "esSegregacion": false
  },
  {
    "codProvincia": 23,
    "provincia": "Jaén",
    "codIne": 93,
    "codCatastro": 93,
    "nombre": "VALDEPEÑAS DE JAEN",
    "hojasSigpac": "23093A",
    "esCapital": false,
    "esSegregacion": false
  },
  {
    "codProvincia": 23,
    "provincia": "Jaén",
    "codIne": 94,
    "codCatastro": 94,
    "nombre": "VILCHES",
    "hojasSigpac": "23094A",
    "esCapital": false,
    "esSegregacion": false
  },
  {
    "codProvincia": 23,
    "provincia": "Jaén",
    "codIne": 95,
    "codCatastro": 95,
    "nombre": "VILLACARRILLO",
    "hojasSigpac": "23095A",
    "esCapital": false,
    "esSegregacion": false
  },
  {
    "codProvincia": 23,
    "provincia": "Jaén",
    "codIne": 96,
    "codCatastro": 96,
    "nombre": "VILLANUEVA DE LA REINA",
    "hojasSigpac": "23096A",
    "esCapital": false,
    "esSegregacion": false
  },
  {
    "codProvincia": 23,
    "provincia": "Jaén",
    "codIne": 97,
    "codCatastro": 97,
    "nombre": "VILLANUEVA DEL ARZOBISPO",
    "hojasSigpac": "23097A",
    "esCapital": false,
    "esSegregacion": false
  },
  {
    "codProvincia": 23,
    "provincia": "Jaén",
    "codIne": 98,
    "codCatastro": 98,
    "nombre": "VILLARDOMPARDO",
    "hojasSigpac": "23098A",
    "esCapital": false,
    "esSegregacion": false
  },
  {
    "codProvincia": 23,
    "provincia": "Jaén",
    "codIne": 99,
    "codCatastro": 99,
    "nombre": "LOS VILLARES",
    "hojasSigpac": "23099A",
    "esCapital": false,
    "esSegregacion": false
  },
  {
    "codProvincia": 23,
    "provincia": "Jaén",
    "codIne": 101,
    "codCatastro": 101,
    "nombre": "VILLARRODRIGO",
    "hojasSigpac": "23101A",
    "esCapital": false,
    "esSegregacion": false
  },
  {
    "codProvincia": 23,
    "provincia": "Jaén",
    "codIne": 901,
    "codCatastro": 23,
    "nombre": "CARCHELES",
    "hojasSigpac": "23023A",
    "esCapital": false,
    "esSegregacion": true
  },
  {
    "codProvincia": 23,
    "provincia": "Jaén",
    "codIne": 902,
    "codCatastro": 13,
    "nombre": "BEDMAR-GARCIEZ",
    "hojasSigpac": "23013A",
    "esCapital": false,
    "esSegregacion": true
  },
  {
    "codProvincia": 23,
    "provincia": "Jaén",
    "codIne": 903,
    "codCatastro": 100,
    "nombre": "VILLATORRES",
    "hojasSigpac": "23100A",
    "esCapital": false,
    "esSegregacion": true
  },
  {
    "codProvincia": 23,
    "provincia": "Jaén",
    "codIne": 904,
    "codCatastro": 78,
    "nombre": "SANTIAGO-PONTONES",
    "hojasSigpac": "23078A",
    "esCapital": false,
    "esSegregacion": true
  },
  {
    "codProvincia": 23,
    "provincia": "Jaén",
    "codIne": 905,
    "codCatastro": 102,
    "nombre": "ARROYO DEL OJANCO",
    "hojasSigpac": "23102A",
    "esCapital": false,
    "esSegregacion": true
  },
  {
    "codProvincia": 29,
    "provincia": "Málaga",
    "codIne": 1,
    "codCatastro": 1,
    "nombre": "ALAMEDA",
    "hojasSigpac": "29001A",
    "esCapital": false,
    "esSegregacion": false
  },
  {
    "codProvincia": 29,
    "provincia": "Málaga",
    "codIne": 2,
    "codCatastro": 2,
    "nombre": "ALCAUCIN",
    "hojasSigpac": "29002A",
    "esCapital": false,
    "esSegregacion": false
  },
  {
    "codProvincia": 29,
    "provincia": "Málaga",
    "codIne": 3,
    "codCatastro": 3,
    "nombre": "ALFARNATE",
    "hojasSigpac": "29003A",
    "esCapital": false,
    "esSegregacion": false
  },
  {
    "codProvincia": 29,
    "provincia": "Málaga",
    "codIne": 4,
    "codCatastro": 4,
    "nombre": "ALFARNATEJO",
    "hojasSigpac": "29004A",
    "esCapital": false,
    "esSegregacion": false
  },
  {
    "codProvincia": 29,
    "provincia": "Málaga",
    "codIne": 5,
    "codCatastro": 5,
    "nombre": "ALGARROBO",
    "hojasSigpac": "29005A",
    "esCapital": false,
    "esSegregacion": false
  },
  {
    "codProvincia": 29,
    "provincia": "Málaga",
    "codIne": 6,
    "codCatastro": 6,
    "nombre": "ALGATOCIN",
    "hojasSigpac": "29006A",
    "esCapital": false,
    "esSegregacion": false
  },
  {
    "codProvincia": 29,
    "provincia": "Málaga",
    "codIne": 7,
    "codCatastro": 7,
    "nombre": "ALHAURIN DE LA TORRE",
    "hojasSigpac": "29007A",
    "esCapital": false,
    "esSegregacion": false
  },
  {
    "codProvincia": 29,
    "provincia": "Málaga",
    "codIne": 8,
    "codCatastro": 8,
    "nombre": "ALHAURIN EL GRANDE",
    "hojasSigpac": "29008A",
    "esCapital": false,
    "esSegregacion": false
  },
  {
    "codProvincia": 29,
    "provincia": "Málaga",
    "codIne": 9,
    "codCatastro": 9,
    "nombre": "ALMACHAR",
    "hojasSigpac": "29009A",
    "esCapital": false,
    "esSegregacion": false
  },
  {
    "codProvincia": 29,
    "provincia": "Málaga",
    "codIne": 10,
    "codCatastro": 10,
    "nombre": "ALMARGEN",
    "hojasSigpac": "29010A",
    "esCapital": false,
    "esSegregacion": false
  },
  {
    "codProvincia": 29,
    "provincia": "Málaga",
    "codIne": 11,
    "codCatastro": 11,
    "nombre": "ALMOGIA",
    "hojasSigpac": "29011A",
    "esCapital": false,
    "esSegregacion": false
  },
  {
    "codProvincia": 29,
    "provincia": "Málaga",
    "codIne": 12,
    "codCatastro": 12,
    "nombre": "ALORA",
    "hojasSigpac": "29012A",
    "esCapital": false,
    "esSegregacion": false
  },
  {
    "codProvincia": 29,
    "provincia": "Málaga",
    "codIne": 13,
    "codCatastro": 13,
    "nombre": "ALOZAINA",
    "hojasSigpac": "29013A",
    "esCapital": false,
    "esSegregacion": false
  },
  {
    "codProvincia": 29,
    "provincia": "Málaga",
    "codIne": 14,
    "codCatastro": 14,
    "nombre": "ALPANDEIRE",
    "hojasSigpac": "29014A",
    "esCapital": false,
    "esSegregacion": false
  },
  {
    "codProvincia": 29,
    "provincia": "Málaga",
    "codIne": 15,
    "codCatastro": 15,
    "nombre": "ANTEQUERA",
    "hojasSigpac": "29015A",
    "esCapital": false,
    "esSegregacion": false
  },
  {
    "codProvincia": 29,
    "provincia": "Málaga",
    "codIne": 16,
    "codCatastro": 16,
    "nombre": "ARCHEZ",
    "hojasSigpac": "29016A",
    "esCapital": false,
    "esSegregacion": false
  },
  {
    "codProvincia": 29,
    "provincia": "Málaga",
    "codIne": 17,
    "codCatastro": 17,
    "nombre": "ARCHIDONA",
    "hojasSigpac": "29017A",
    "esCapital": false,
    "esSegregacion": false
  },
  {
    "codProvincia": 29,
    "provincia": "Málaga",
    "codIne": 18,
    "codCatastro": 18,
    "nombre": "ARDALES",
    "hojasSigpac": "29018A",
    "esCapital": false,
    "esSegregacion": false
  },
  {
    "codProvincia": 29,
    "provincia": "Málaga",
    "codIne": 19,
    "codCatastro": 19,
    "nombre": "ARENAS",
    "hojasSigpac": "29019A",
    "esCapital": false,
    "esSegregacion": false
  },
  {
    "codProvincia": 29,
    "provincia": "Málaga",
    "codIne": 20,
    "codCatastro": 20,
    "nombre": "ARRIATE",
    "hojasSigpac": "29020A",
    "esCapital": false,
    "esSegregacion": false
  },
  {
    "codProvincia": 29,
    "provincia": "Málaga",
    "codIne": 21,
    "codCatastro": 21,
    "nombre": "ATAJATE",
    "hojasSigpac": "29021A",
    "esCapital": false,
    "esSegregacion": false
  },
  {
    "codProvincia": 29,
    "provincia": "Málaga",
    "codIne": 22,
    "codCatastro": 22,
    "nombre": "BENADALID",
    "hojasSigpac": "29022A",
    "esCapital": false,
    "esSegregacion": false
  },
  {
    "codProvincia": 29,
    "provincia": "Málaga",
    "codIne": 23,
    "codCatastro": 23,
    "nombre": "BENAHAVIS",
    "hojasSigpac": "29023A",
    "esCapital": false,
    "esSegregacion": false
  },
  {
    "codProvincia": 29,
    "provincia": "Málaga",
    "codIne": 24,
    "codCatastro": 24,
    "nombre": "BENALAURIA",
    "hojasSigpac": "29024A",
    "esCapital": false,
    "esSegregacion": false
  },
  {
    "codProvincia": 29,
    "provincia": "Málaga",
    "codIne": 25,
    "codCatastro": 25,
    "nombre": "BENALMADENA",
    "hojasSigpac": "29025A",
    "esCapital": false,
    "esSegregacion": false
  },
  {
    "codProvincia": 29,
    "provincia": "Málaga",
    "codIne": 26,
    "codCatastro": 26,
    "nombre": "BENAMARGOSA",
    "hojasSigpac": "29026A",
    "esCapital": false,
    "esSegregacion": false
  },
  {
    "codProvincia": 29,
    "provincia": "Málaga",
    "codIne": 27,
    "codCatastro": 27,
    "nombre": "BENAMOCARRA",
    "hojasSigpac": "29027A",
    "esCapital": false,
    "esSegregacion": false
  },
  {
    "codProvincia": 29,
    "provincia": "Málaga",
    "codIne": 28,
    "codCatastro": 28,
    "nombre": "BENAOJAN",
    "hojasSigpac": "29028A",
    "esCapital": false,
    "esSegregacion": false
  },
  {
    "codProvincia": 29,
    "provincia": "Málaga",
    "codIne": 29,
    "codCatastro": 29,
    "nombre": "BENARRABA",
    "hojasSigpac": "29029A",
    "esCapital": false,
    "esSegregacion": false
  },
  {
    "codProvincia": 29,
    "provincia": "Málaga",
    "codIne": 30,
    "codCatastro": 30,
    "nombre": "EL BORGE",
    "hojasSigpac": "29030A",
    "esCapital": false,
    "esSegregacion": false
  },
  {
    "codProvincia": 29,
    "provincia": "Málaga",
    "codIne": 31,
    "codCatastro": 31,
    "nombre": "EL BURGO",
    "hojasSigpac": "29031A",
    "esCapital": false,
    "esSegregacion": false
  },
  {
    "codProvincia": 29,
    "provincia": "Málaga",
    "codIne": 32,
    "codCatastro": 32,
    "nombre": "CAMPILLOS",
    "hojasSigpac": "29032A",
    "esCapital": false,
    "esSegregacion": false
  },
  {
    "codProvincia": 29,
    "provincia": "Málaga",
    "codIne": 33,
    "codCatastro": 33,
    "nombre": "CANILLAS DE ACEITUNO",
    "hojasSigpac": "29033A",
    "esCapital": false,
    "esSegregacion": false
  },
  {
    "codProvincia": 29,
    "provincia": "Málaga",
    "codIne": 34,
    "codCatastro": 34,
    "nombre": "CANILLAS DE ALBAIDA",
    "hojasSigpac": "29034A",
    "esCapital": false,
    "esSegregacion": false
  },
  {
    "codProvincia": 29,
    "provincia": "Málaga",
    "codIne": 35,
    "codCatastro": 35,
    "nombre": "CAÑETE LA REAL",
    "hojasSigpac": "29035A",
    "esCapital": false,
    "esSegregacion": false
  },
  {
    "codProvincia": 29,
    "provincia": "Málaga",
    "codIne": 36,
    "codCatastro": 36,
    "nombre": "CARRATRACA",
    "hojasSigpac": "29036A",
    "esCapital": false,
    "esSegregacion": false
  },
  {
    "codProvincia": 29,
    "provincia": "Málaga",
    "codIne": 37,
    "codCatastro": 37,
    "nombre": "CARTAJIMA",
    "hojasSigpac": "29037A",
    "esCapital": false,
    "esSegregacion": false
  },
  {
    "codProvincia": 29,
    "provincia": "Málaga",
    "codIne": 38,
    "codCatastro": 38,
    "nombre": "CARTAMA",
    "hojasSigpac": "29038A",
    "esCapital": false,
    "esSegregacion": false
  },
  {
    "codProvincia": 29,
    "provincia": "Málaga",
    "codIne": 39,
    "codCatastro": 39,
    "nombre": "CASABERMEJA",
    "hojasSigpac": "29039A",
    "esCapital": false,
    "esSegregacion": false
  },
  {
    "codProvincia": 29,
    "provincia": "Málaga",
    "codIne": 40,
    "codCatastro": 40,
    "nombre": "CASARABONELA",
    "hojasSigpac": "29040A",
    "esCapital": false,
    "esSegregacion": false
  },
  {
    "codProvincia": 29,
    "provincia": "Málaga",
    "codIne": 41,
    "codCatastro": 41,
    "nombre": "CASARES",
    "hojasSigpac": "29041A",
    "esCapital": false,
    "esSegregacion": false
  },
  {
    "codProvincia": 29,
    "provincia": "Málaga",
    "codIne": 42,
    "codCatastro": 42,
    "nombre": "COIN",
    "hojasSigpac": "29042A",
    "esCapital": false,
    "esSegregacion": false
  },
  {
    "codProvincia": 29,
    "provincia": "Málaga",
    "codIne": 43,
    "codCatastro": 43,
    "nombre": "COLMENAR",
    "hojasSigpac": "29043A",
    "esCapital": false,
    "esSegregacion": false
  },
  {
    "codProvincia": 29,
    "provincia": "Málaga",
    "codIne": 44,
    "codCatastro": 44,
    "nombre": "COMARES",
    "hojasSigpac": "29044A",
    "esCapital": false,
    "esSegregacion": false
  },
  {
    "codProvincia": 29,
    "provincia": "Málaga",
    "codIne": 45,
    "codCatastro": 45,
    "nombre": "COMPETA",
    "hojasSigpac": "29045A",
    "esCapital": false,
    "esSegregacion": false
  },
  {
    "codProvincia": 29,
    "provincia": "Málaga",
    "codIne": 46,
    "codCatastro": 46,
    "nombre": "CORTES DE LA FRONTERA",
    "hojasSigpac": "29046A",
    "esCapital": false,
    "esSegregacion": false
  },
  {
    "codProvincia": 29,
    "provincia": "Málaga",
    "codIne": 47,
    "codCatastro": 47,
    "nombre": "CUEVAS BAJAS",
    "hojasSigpac": "29047A",
    "esCapital": false,
    "esSegregacion": false
  },
  {
    "codProvincia": 29,
    "provincia": "Málaga",
    "codIne": 48,
    "codCatastro": 48,
    "nombre": "CUEVAS DEL BECERRO",
    "hojasSigpac": "29048A",
    "esCapital": false,
    "esSegregacion": false
  },
  {
    "codProvincia": 29,
    "provincia": "Málaga",
    "codIne": 49,
    "codCatastro": 49,
    "nombre": "CUEVAS DE SAN MARCOS",
    "hojasSigpac": "29049A",
    "esCapital": false,
    "esSegregacion": false
  },
  {
    "codProvincia": 29,
    "provincia": "Málaga",
    "codIne": 50,
    "codCatastro": 50,
    "nombre": "CUTAR",
    "hojasSigpac": "29050A",
    "esCapital": false,
    "esSegregacion": false
  },
  {
    "codProvincia": 29,
    "provincia": "Málaga",
    "codIne": 51,
    "codCatastro": 51,
    "nombre": "ESTEPONA",
    "hojasSigpac": "29051A",
    "esCapital": false,
    "esSegregacion": false
  },
  {
    "codProvincia": 29,
    "provincia": "Málaga",
    "codIne": 52,
    "codCatastro": 52,
    "nombre": "FARAJAN",
    "hojasSigpac": "29052A",
    "esCapital": false,
    "esSegregacion": false
  },
  {
    "codProvincia": 29,
    "provincia": "Málaga",
    "codIne": 53,
    "codCatastro": 53,
    "nombre": "FRIGILIANA",
    "hojasSigpac": "29053A",
    "esCapital": false,
    "esSegregacion": false
  },
  {
    "codProvincia": 29,
    "provincia": "Málaga",
    "codIne": 54,
    "codCatastro": 54,
    "nombre": "FUENGIROLA",
    "hojasSigpac": "29054A",
    "esCapital": false,
    "esSegregacion": false
  },
  {
    "codProvincia": 29,
    "provincia": "Málaga",
    "codIne": 55,
    "codCatastro": 55,
    "nombre": "FUENTE DE PIEDRA",
    "hojasSigpac": "29055A",
    "esCapital": false,
    "esSegregacion": false
  },
  {
    "codProvincia": 29,
    "provincia": "Málaga",
    "codIne": 56,
    "codCatastro": 56,
    "nombre": "GAUCIN",
    "hojasSigpac": "29056A",
    "esCapital": false,
    "esSegregacion": false
  },
  {
    "codProvincia": 29,
    "provincia": "Málaga",
    "codIne": 57,
    "codCatastro": 57,
    "nombre": "GENALGUACIL",
    "hojasSigpac": "29057A",
    "esCapital": false,
    "esSegregacion": false
  },
  {
    "codProvincia": 29,
    "provincia": "Málaga",
    "codIne": 58,
    "codCatastro": 58,
    "nombre": "GUARO",
    "hojasSigpac": "29058A",
    "esCapital": false,
    "esSegregacion": false
  },
  {
    "codProvincia": 29,
    "provincia": "Málaga",
    "codIne": 59,
    "codCatastro": 59,
    "nombre": "HUMILLADERO",
    "hojasSigpac": "29059A",
    "esCapital": false,
    "esSegregacion": false
  },
  {
    "codProvincia": 29,
    "provincia": "Málaga",
    "codIne": 60,
    "codCatastro": 60,
    "nombre": "IGUALEJA",
    "hojasSigpac": "29060A",
    "esCapital": false,
    "esSegregacion": false
  },
  {
    "codProvincia": 29,
    "provincia": "Málaga",
    "codIne": 61,
    "codCatastro": 61,
    "nombre": "ISTAN",
    "hojasSigpac": "29061A",
    "esCapital": false,
    "esSegregacion": false
  },
  {
    "codProvincia": 29,
    "provincia": "Málaga",
    "codIne": 62,
    "codCatastro": 62,
    "nombre": "IZNATE",
    "hojasSigpac": "29062A",
    "esCapital": false,
    "esSegregacion": false
  },
  {
    "codProvincia": 29,
    "provincia": "Málaga",
    "codIne": 63,
    "codCatastro": 63,
    "nombre": "JIMERA DE LIBAR",
    "hojasSigpac": "29063A",
    "esCapital": false,
    "esSegregacion": false
  },
  {
    "codProvincia": 29,
    "provincia": "Málaga",
    "codIne": 64,
    "codCatastro": 64,
    "nombre": "JUBRIQUE",
    "hojasSigpac": "29064A",
    "esCapital": false,
    "esSegregacion": false
  },
  {
    "codProvincia": 29,
    "provincia": "Málaga",
    "codIne": 65,
    "codCatastro": 65,
    "nombre": "JUZCAR",
    "hojasSigpac": "29065A",
    "esCapital": false,
    "esSegregacion": false
  },
  {
    "codProvincia": 29,
    "provincia": "Málaga",
    "codIne": 66,
    "codCatastro": 66,
    "nombre": "MACHARAVIAYA",
    "hojasSigpac": "29066A",
    "esCapital": false,
    "esSegregacion": false
  },
  {
    "codProvincia": 29,
    "provincia": "Málaga",
    "codIne": 67,
    "codCatastro": 900,
    "nombre": "MALAGA",
    "hojasSigpac": "29900A",
    "esCapital": true,
    "esSegregacion": false
  },
  {
    "codProvincia": 29,
    "provincia": "Málaga",
    "codIne": 68,
    "codCatastro": 68,
    "nombre": "MANILVA",
    "hojasSigpac": "29068A",
    "esCapital": false,
    "esSegregacion": false
  },
  {
    "codProvincia": 29,
    "provincia": "Málaga",
    "codIne": 69,
    "codCatastro": 69,
    "nombre": "MARBELLA",
    "hojasSigpac": "29069A",
    "esCapital": false,
    "esSegregacion": false
  },
  {
    "codProvincia": 29,
    "provincia": "Málaga",
    "codIne": 70,
    "codCatastro": 70,
    "nombre": "MIJAS",
    "hojasSigpac": "29070A",
    "esCapital": false,
    "esSegregacion": false
  },
  {
    "codProvincia": 29,
    "provincia": "Málaga",
    "codIne": 71,
    "codCatastro": 71,
    "nombre": "MOCLINEJO",
    "hojasSigpac": "29071A",
    "esCapital": false,
    "esSegregacion": false
  },
  {
    "codProvincia": 29,
    "provincia": "Málaga",
    "codIne": 72,
    "codCatastro": 72,
    "nombre": "MOLLINA",
    "hojasSigpac": "29072A",
    "esCapital": false,
    "esSegregacion": false
  },
  {
    "codProvincia": 29,
    "provincia": "Málaga",
    "codIne": 73,
    "codCatastro": 73,
    "nombre": "MONDA",
    "hojasSigpac": "29073A",
    "esCapital": false,
    "esSegregacion": false
  },
  {
    "codProvincia": 29,
    "provincia": "Málaga",
    "codIne": 74,
    "codCatastro": 74,
    "nombre": "MONTEJAQUE",
    "hojasSigpac": "29074A",
    "esCapital": false,
    "esSegregacion": false
  },
  {
    "codProvincia": 29,
    "provincia": "Málaga",
    "codIne": 75,
    "codCatastro": 75,
    "nombre": "NERJA",
    "hojasSigpac": "29075A",
    "esCapital": false,
    "esSegregacion": false
  },
  {
    "codProvincia": 29,
    "provincia": "Málaga",
    "codIne": 76,
    "codCatastro": 76,
    "nombre": "OJEN",
    "hojasSigpac": "29076A",
    "esCapital": false,
    "esSegregacion": false
  },
  {
    "codProvincia": 29,
    "provincia": "Málaga",
    "codIne": 77,
    "codCatastro": 77,
    "nombre": "PARAUTA",
    "hojasSigpac": "29077A",
    "esCapital": false,
    "esSegregacion": false
  },
  {
    "codProvincia": 29,
    "provincia": "Málaga",
    "codIne": 79,
    "codCatastro": 79,
    "nombre": "PERIANA",
    "hojasSigpac": "29079A",
    "esCapital": false,
    "esSegregacion": false
  },
  {
    "codProvincia": 29,
    "provincia": "Málaga",
    "codIne": 80,
    "codCatastro": 80,
    "nombre": "PIZARRA",
    "hojasSigpac": "29080A",
    "esCapital": false,
    "esSegregacion": false
  },
  {
    "codProvincia": 29,
    "provincia": "Málaga",
    "codIne": 81,
    "codCatastro": 81,
    "nombre": "PUJERRA",
    "hojasSigpac": "29081A",
    "esCapital": false,
    "esSegregacion": false
  },
  {
    "codProvincia": 29,
    "provincia": "Málaga",
    "codIne": 82,
    "codCatastro": 82,
    "nombre": "RINCON DE LA VICTORIA",
    "hojasSigpac": "29082A",
    "esCapital": false,
    "esSegregacion": false
  },
  {
    "codProvincia": 29,
    "provincia": "Málaga",
    "codIne": 83,
    "codCatastro": 83,
    "nombre": "RIOGORDO",
    "hojasSigpac": "29083A",
    "esCapital": false,
    "esSegregacion": false
  },
  {
    "codProvincia": 29,
    "provincia": "Málaga",
    "codIne": 84,
    "codCatastro": 84,
    "nombre": "RONDA",
    "hojasSigpac": "29084A",
    "esCapital": false,
    "esSegregacion": false
  },
  {
    "codProvincia": 29,
    "provincia": "Málaga",
    "codIne": 85,
    "codCatastro": 85,
    "nombre": "SALARES",
    "hojasSigpac": "29085A",
    "esCapital": false,
    "esSegregacion": false
  },
  {
    "codProvincia": 29,
    "provincia": "Málaga",
    "codIne": 86,
    "codCatastro": 86,
    "nombre": "SAYALONGA",
    "hojasSigpac": "29086A",
    "esCapital": false,
    "esSegregacion": false
  },
  {
    "codProvincia": 29,
    "provincia": "Málaga",
    "codIne": 87,
    "codCatastro": 87,
    "nombre": "SEDELLA",
    "hojasSigpac": "29087A",
    "esCapital": false,
    "esSegregacion": false
  },
  {
    "codProvincia": 29,
    "provincia": "Málaga",
    "codIne": 88,
    "codCatastro": 88,
    "nombre": "SIERRA DE YEGUAS",
    "hojasSigpac": "29088A",
    "esCapital": false,
    "esSegregacion": false
  },
  {
    "codProvincia": 29,
    "provincia": "Málaga",
    "codIne": 89,
    "codCatastro": 89,
    "nombre": "TEBA",
    "hojasSigpac": "29089A",
    "esCapital": false,
    "esSegregacion": false
  },
  {
    "codProvincia": 29,
    "provincia": "Málaga",
    "codIne": 90,
    "codCatastro": 90,
    "nombre": "TOLOX",
    "hojasSigpac": "29090A",
    "esCapital": false,
    "esSegregacion": false
  },
  {
    "codProvincia": 29,
    "provincia": "Málaga",
    "codIne": 91,
    "codCatastro": 91,
    "nombre": "TORROX",
    "hojasSigpac": "29091A",
    "esCapital": false,
    "esSegregacion": false
  },
  {
    "codProvincia": 29,
    "provincia": "Málaga",
    "codIne": 92,
    "codCatastro": 92,
    "nombre": "TOTALAN",
    "hojasSigpac": "29092A",
    "esCapital": false,
    "esSegregacion": false
  },
  {
    "codProvincia": 29,
    "provincia": "Málaga",
    "codIne": 93,
    "codCatastro": 93,
    "nombre": "VALLE DE ABDALAJIS",
    "hojasSigpac": "29093A",
    "esCapital": false,
    "esSegregacion": false
  },
  {
    "codProvincia": 29,
    "provincia": "Málaga",
    "codIne": 94,
    "codCatastro": 94,
    "nombre": "VELEZ-MALAGA",
    "hojasSigpac": "29094A",
    "esCapital": false,
    "esSegregacion": false
  },
  {
    "codProvincia": 29,
    "provincia": "Málaga",
    "codIne": 95,
    "codCatastro": 95,
    "nombre": "VILLANUEVA DE ALGAIDAS",
    "hojasSigpac": "29095A",
    "esCapital": false,
    "esSegregacion": false
  },
  {
    "codProvincia": 29,
    "provincia": "Málaga",
    "codIne": 96,
    "codCatastro": 96,
    "nombre": "VILLANUEVA DEL ROSARIO",
    "hojasSigpac": "29096A",
    "esCapital": false,
    "esSegregacion": false
  },
  {
    "codProvincia": 29,
    "provincia": "Málaga",
    "codIne": 97,
    "codCatastro": 97,
    "nombre": "VILLANUEVA DEL TRABUCO",
    "hojasSigpac": "29097A",
    "esCapital": false,
    "esSegregacion": false
  },
  {
    "codProvincia": 29,
    "provincia": "Málaga",
    "codIne": 98,
    "codCatastro": 98,
    "nombre": "VILLANUEVA DE TAPIA",
    "hojasSigpac": "29098A",
    "esCapital": false,
    "esSegregacion": false
  },
  {
    "codProvincia": 29,
    "provincia": "Málaga",
    "codIne": 99,
    "codCatastro": 99,
    "nombre": "VIÑUELA",
    "hojasSigpac": "29099A",
    "esCapital": false,
    "esSegregacion": false
  },
  {
    "codProvincia": 29,
    "provincia": "Málaga",
    "codIne": 100,
    "codCatastro": 100,
    "nombre": "YUNQUERA",
    "hojasSigpac": "29100A",
    "esCapital": false,
    "esSegregacion": false
  },
  {
    "codProvincia": 29,
    "provincia": "Málaga",
    "codIne": 901,
    "codCatastro": 103,
    "nombre": "TORREMOLINOS",
    "hojasSigpac": "29103A",
    "esCapital": false,
    "esSegregacion": true
  },
  {
    "codProvincia": 29,
    "provincia": "Málaga",
    "codIne": 902,
    "codCatastro": 102,
    "nombre": "VILLANUEVA DE LA CONCEPCION",
    "hojasSigpac": "29102A",
    "esCapital": false,
    "esSegregacion": true
  },
  {
    "codProvincia": 29,
    "provincia": "Málaga",
    "codIne": 903,
    "codCatastro": 101,
    "nombre": "MONTECORTO",
    "hojasSigpac": "29084A",
    "esCapital": false,
    "esSegregacion": true
  },
  {
    "codProvincia": 29,
    "provincia": "Málaga",
    "codIne": 904,
    "codCatastro": 104,
    "nombre": "SERRATO",
    "hojasSigpac": "29084A",
    "esCapital": false,
    "esSegregacion": true
  },
  {
    "codProvincia": 41,
    "provincia": "Sevilla",
    "codIne": 1,
    "codCatastro": 1,
    "nombre": "AGUADULCE",
    "hojasSigpac": "41001A",
    "esCapital": false,
    "esSegregacion": false
  },
  {
    "codProvincia": 41,
    "provincia": "Sevilla",
    "codIne": 2,
    "codCatastro": 2,
    "nombre": "ALANIS",
    "hojasSigpac": "41002A",
    "esCapital": false,
    "esSegregacion": false
  },
  {
    "codProvincia": 41,
    "provincia": "Sevilla",
    "codIne": 3,
    "codCatastro": 3,
    "nombre": "ALBAIDA DEL ALJARAFE",
    "hojasSigpac": "41003A",
    "esCapital": false,
    "esSegregacion": false
  },
  {
    "codProvincia": 41,
    "provincia": "Sevilla",
    "codIne": 4,
    "codCatastro": 4,
    "nombre": "ALCALA DE GUADAIRA",
    "hojasSigpac": "41004A",
    "esCapital": false,
    "esSegregacion": false
  },
  {
    "codProvincia": 41,
    "provincia": "Sevilla",
    "codIne": 5,
    "codCatastro": 5,
    "nombre": "ALCALA DEL RIO",
    "hojasSigpac": "41005A",
    "esCapital": false,
    "esSegregacion": false
  },
  {
    "codProvincia": 41,
    "provincia": "Sevilla",
    "codIne": 6,
    "codCatastro": 6,
    "nombre": "ALCOLEA DEL RIO",
    "hojasSigpac": "41006A",
    "esCapital": false,
    "esSegregacion": false
  },
  {
    "codProvincia": 41,
    "provincia": "Sevilla",
    "codIne": 7,
    "codCatastro": 7,
    "nombre": "ALGABA",
    "hojasSigpac": "41007A",
    "esCapital": false,
    "esSegregacion": false
  },
  {
    "codProvincia": 41,
    "provincia": "Sevilla",
    "codIne": 8,
    "codCatastro": 8,
    "nombre": "ALGAMITAS",
    "hojasSigpac": "41008A",
    "esCapital": false,
    "esSegregacion": false
  },
  {
    "codProvincia": 41,
    "provincia": "Sevilla",
    "codIne": 9,
    "codCatastro": 9,
    "nombre": "ALMADEN DE LA PLATA",
    "hojasSigpac": "41009A",
    "esCapital": false,
    "esSegregacion": false
  },
  {
    "codProvincia": 41,
    "provincia": "Sevilla",
    "codIne": 10,
    "codCatastro": 10,
    "nombre": "ALMENSILLA",
    "hojasSigpac": "41010A",
    "esCapital": false,
    "esSegregacion": false
  },
  {
    "codProvincia": 41,
    "provincia": "Sevilla",
    "codIne": 11,
    "codCatastro": 11,
    "nombre": "ARAHAL",
    "hojasSigpac": "41011A",
    "esCapital": false,
    "esSegregacion": false
  },
  {
    "codProvincia": 41,
    "provincia": "Sevilla",
    "codIne": 12,
    "codCatastro": 12,
    "nombre": "AZNALCAZAR",
    "hojasSigpac": "41012A",
    "esCapital": false,
    "esSegregacion": false
  },
  {
    "codProvincia": 41,
    "provincia": "Sevilla",
    "codIne": 13,
    "codCatastro": 13,
    "nombre": "AZNALCOLLAR",
    "hojasSigpac": "41013A",
    "esCapital": false,
    "esSegregacion": false
  },
  {
    "codProvincia": 41,
    "provincia": "Sevilla",
    "codIne": 14,
    "codCatastro": 14,
    "nombre": "BADOLATOSA",
    "hojasSigpac": "41014A",
    "esCapital": false,
    "esSegregacion": false
  },
  {
    "codProvincia": 41,
    "provincia": "Sevilla",
    "codIne": 15,
    "codCatastro": 15,
    "nombre": "BENACAZON",
    "hojasSigpac": "41015A",
    "esCapital": false,
    "esSegregacion": false
  },
  {
    "codProvincia": 41,
    "provincia": "Sevilla",
    "codIne": 16,
    "codCatastro": 16,
    "nombre": "BOLLULLOS DE LA MITACION",
    "hojasSigpac": "41016A",
    "esCapital": false,
    "esSegregacion": false
  },
  {
    "codProvincia": 41,
    "provincia": "Sevilla",
    "codIne": 17,
    "codCatastro": 17,
    "nombre": "BORMUJOS",
    "hojasSigpac": "41017A",
    "esCapital": false,
    "esSegregacion": false
  },
  {
    "codProvincia": 41,
    "provincia": "Sevilla",
    "codIne": 18,
    "codCatastro": 18,
    "nombre": "BRENES",
    "hojasSigpac": "41018A",
    "esCapital": false,
    "esSegregacion": false
  },
  {
    "codProvincia": 41,
    "provincia": "Sevilla",
    "codIne": 19,
    "codCatastro": 19,
    "nombre": "BURGUILLOS",
    "hojasSigpac": "41019A",
    "esCapital": false,
    "esSegregacion": false
  },
  {
    "codProvincia": 41,
    "provincia": "Sevilla",
    "codIne": 20,
    "codCatastro": 20,
    "nombre": "LAS CABEZAS DE SAN JUAN",
    "hojasSigpac": "41020A",
    "esCapital": false,
    "esSegregacion": false
  },
  {
    "codProvincia": 41,
    "provincia": "Sevilla",
    "codIne": 21,
    "codCatastro": 21,
    "nombre": "CAMAS",
    "hojasSigpac": "41021A",
    "esCapital": false,
    "esSegregacion": false
  },
  {
    "codProvincia": 41,
    "provincia": "Sevilla",
    "codIne": 22,
    "codCatastro": 22,
    "nombre": "LA CAMPANA",
    "hojasSigpac": "41022A",
    "esCapital": false,
    "esSegregacion": false
  },
  {
    "codProvincia": 41,
    "provincia": "Sevilla",
    "codIne": 23,
    "codCatastro": 23,
    "nombre": "CANTILLANA",
    "hojasSigpac": "41023A",
    "esCapital": false,
    "esSegregacion": false
  },
  {
    "codProvincia": 41,
    "provincia": "Sevilla",
    "codIne": 24,
    "codCatastro": 24,
    "nombre": "CARMONA",
    "hojasSigpac": "41024A",
    "esCapital": false,
    "esSegregacion": false
  },
  {
    "codProvincia": 41,
    "provincia": "Sevilla",
    "codIne": 25,
    "codCatastro": 25,
    "nombre": "CARRION DE LOS CESPEDES",
    "hojasSigpac": "41025A",
    "esCapital": false,
    "esSegregacion": false
  },
  {
    "codProvincia": 41,
    "provincia": "Sevilla",
    "codIne": 26,
    "codCatastro": 26,
    "nombre": "CASARICHE",
    "hojasSigpac": "41026A",
    "esCapital": false,
    "esSegregacion": false
  },
  {
    "codProvincia": 41,
    "provincia": "Sevilla",
    "codIne": 27,
    "codCatastro": 27,
    "nombre": "CASTILBLANCO DE LOS ARROYOS",
    "hojasSigpac": "41027A",
    "esCapital": false,
    "esSegregacion": false
  },
  {
    "codProvincia": 41,
    "provincia": "Sevilla",
    "codIne": 28,
    "codCatastro": 28,
    "nombre": "CASTILLEJA DE GUZMAN",
    "hojasSigpac": "41028A",
    "esCapital": false,
    "esSegregacion": false
  },
  {
    "codProvincia": 41,
    "provincia": "Sevilla",
    "codIne": 29,
    "codCatastro": 29,
    "nombre": "CASTILLEJA DE LA CUESTA",
    "hojasSigpac": "41029A",
    "esCapital": false,
    "esSegregacion": false
  },
  {
    "codProvincia": 41,
    "provincia": "Sevilla",
    "codIne": 30,
    "codCatastro": 30,
    "nombre": "CASTILLEJA DEL CAMPO",
    "hojasSigpac": "41030A",
    "esCapital": false,
    "esSegregacion": false
  },
  {
    "codProvincia": 41,
    "provincia": "Sevilla",
    "codIne": 31,
    "codCatastro": 31,
    "nombre": "EL CASTILLO DE LAS GUARDAS",
    "hojasSigpac": "41031A",
    "esCapital": false,
    "esSegregacion": false
  },
  {
    "codProvincia": 41,
    "provincia": "Sevilla",
    "codIne": 32,
    "codCatastro": 32,
    "nombre": "CAZALLA DE LA SIERRA",
    "hojasSigpac": "41032A",
    "esCapital": false,
    "esSegregacion": false
  },
  {
    "codProvincia": 41,
    "provincia": "Sevilla",
    "codIne": 33,
    "codCatastro": 33,
    "nombre": "CONSTANTINA",
    "hojasSigpac": "41033A",
    "esCapital": false,
    "esSegregacion": false
  },
  {
    "codProvincia": 41,
    "provincia": "Sevilla",
    "codIne": 34,
    "codCatastro": 34,
    "nombre": "CORIA DEL RIO",
    "hojasSigpac": "41034A",
    "esCapital": false,
    "esSegregacion": false
  },
  {
    "codProvincia": 41,
    "provincia": "Sevilla",
    "codIne": 35,
    "codCatastro": 35,
    "nombre": "CORIPE",
    "hojasSigpac": "41035A",
    "esCapital": false,
    "esSegregacion": false
  },
  {
    "codProvincia": 41,
    "provincia": "Sevilla",
    "codIne": 36,
    "codCatastro": 36,
    "nombre": "EL CORONIL",
    "hojasSigpac": "41036A",
    "esCapital": false,
    "esSegregacion": false
  },
  {
    "codProvincia": 41,
    "provincia": "Sevilla",
    "codIne": 37,
    "codCatastro": 37,
    "nombre": "LOS CORRALES",
    "hojasSigpac": "41037A",
    "esCapital": false,
    "esSegregacion": false
  },
  {
    "codProvincia": 41,
    "provincia": "Sevilla",
    "codIne": 38,
    "codCatastro": 38,
    "nombre": "DOS HERMANAS",
    "hojasSigpac": "41038A",
    "esCapital": false,
    "esSegregacion": false
  },
  {
    "codProvincia": 41,
    "provincia": "Sevilla",
    "codIne": 39,
    "codCatastro": 39,
    "nombre": "ECIJA",
    "hojasSigpac": "41039A",
    "esCapital": false,
    "esSegregacion": false
  },
  {
    "codProvincia": 41,
    "provincia": "Sevilla",
    "codIne": 40,
    "codCatastro": 40,
    "nombre": "ESPARTINAS",
    "hojasSigpac": "41040A",
    "esCapital": false,
    "esSegregacion": false
  },
  {
    "codProvincia": 41,
    "provincia": "Sevilla",
    "codIne": 41,
    "codCatastro": 41,
    "nombre": "ESTEPA",
    "hojasSigpac": "41041A",
    "esCapital": false,
    "esSegregacion": false
  },
  {
    "codProvincia": 41,
    "provincia": "Sevilla",
    "codIne": 42,
    "codCatastro": 42,
    "nombre": "FUENTES DE ANDALUCIA",
    "hojasSigpac": "41042A",
    "esCapital": false,
    "esSegregacion": false
  },
  {
    "codProvincia": 41,
    "provincia": "Sevilla",
    "codIne": 43,
    "codCatastro": 43,
    "nombre": "EL GARROBO",
    "hojasSigpac": "41043A",
    "esCapital": false,
    "esSegregacion": false
  },
  {
    "codProvincia": 41,
    "provincia": "Sevilla",
    "codIne": 44,
    "codCatastro": 44,
    "nombre": "GELVES",
    "hojasSigpac": "41044A",
    "esCapital": false,
    "esSegregacion": false
  },
  {
    "codProvincia": 41,
    "provincia": "Sevilla",
    "codIne": 45,
    "codCatastro": 45,
    "nombre": "GERENA",
    "hojasSigpac": "41045A",
    "esCapital": false,
    "esSegregacion": false
  },
  {
    "codProvincia": 41,
    "provincia": "Sevilla",
    "codIne": 46,
    "codCatastro": 46,
    "nombre": "GILENA",
    "hojasSigpac": "41046A",
    "esCapital": false,
    "esSegregacion": false
  },
  {
    "codProvincia": 41,
    "provincia": "Sevilla",
    "codIne": 47,
    "codCatastro": 47,
    "nombre": "GINES",
    "hojasSigpac": "41047A",
    "esCapital": false,
    "esSegregacion": false
  },
  {
    "codProvincia": 41,
    "provincia": "Sevilla",
    "codIne": 48,
    "codCatastro": 48,
    "nombre": "GUADALCANAL",
    "hojasSigpac": "41048A",
    "esCapital": false,
    "esSegregacion": false
  },
  {
    "codProvincia": 41,
    "provincia": "Sevilla",
    "codIne": 49,
    "codCatastro": 49,
    "nombre": "GUILLENA",
    "hojasSigpac": "41049A",
    "esCapital": false,
    "esSegregacion": false
  },
  {
    "codProvincia": 41,
    "provincia": "Sevilla",
    "codIne": 50,
    "codCatastro": 50,
    "nombre": "HERRERA",
    "hojasSigpac": "41050A",
    "esCapital": false,
    "esSegregacion": false
  },
  {
    "codProvincia": 41,
    "provincia": "Sevilla",
    "codIne": 51,
    "codCatastro": 51,
    "nombre": "HUEVAR DEL ALJARAFE",
    "hojasSigpac": "41051A",
    "esCapital": false,
    "esSegregacion": false
  },
  {
    "codProvincia": 41,
    "provincia": "Sevilla",
    "codIne": 52,
    "codCatastro": 52,
    "nombre": "LANTEJUELA",
    "hojasSigpac": "41052A",
    "esCapital": false,
    "esSegregacion": false
  },
  {
    "codProvincia": 41,
    "provincia": "Sevilla",
    "codIne": 53,
    "codCatastro": 53,
    "nombre": "LEBRIJA",
    "hojasSigpac": "41053A",
    "esCapital": false,
    "esSegregacion": false
  },
  {
    "codProvincia": 41,
    "provincia": "Sevilla",
    "codIne": 54,
    "codCatastro": 54,
    "nombre": "LORA DE ESTEPA",
    "hojasSigpac": "41054A",
    "esCapital": false,
    "esSegregacion": false
  },
  {
    "codProvincia": 41,
    "provincia": "Sevilla",
    "codIne": 55,
    "codCatastro": 55,
    "nombre": "LORA DEL RIO",
    "hojasSigpac": "41055A",
    "esCapital": false,
    "esSegregacion": false
  },
  {
    "codProvincia": 41,
    "provincia": "Sevilla",
    "codIne": 56,
    "codCatastro": 56,
    "nombre": "LA LUISIANA",
    "hojasSigpac": "41056A",
    "esCapital": false,
    "esSegregacion": false
  },
  {
    "codProvincia": 41,
    "provincia": "Sevilla",
    "codIne": 57,
    "codCatastro": 57,
    "nombre": "EL MADROÑO",
    "hojasSigpac": "41057A",
    "esCapital": false,
    "esSegregacion": false
  },
  {
    "codProvincia": 41,
    "provincia": "Sevilla",
    "codIne": 58,
    "codCatastro": 58,
    "nombre": "MAIRENA DEL ALCOR",
    "hojasSigpac": "41058A",
    "esCapital": false,
    "esSegregacion": false
  },
  {
    "codProvincia": 41,
    "provincia": "Sevilla",
    "codIne": 59,
    "codCatastro": 59,
    "nombre": "MAIRENA DEL ALJARAFE",
    "hojasSigpac": "41059A",
    "esCapital": false,
    "esSegregacion": false
  },
  {
    "codProvincia": 41,
    "provincia": "Sevilla",
    "codIne": 60,
    "codCatastro": 60,
    "nombre": "MARCHENA",
    "hojasSigpac": "41060A",
    "esCapital": false,
    "esSegregacion": false
  },
  {
    "codProvincia": 41,
    "provincia": "Sevilla",
    "codIne": 61,
    "codCatastro": 61,
    "nombre": "MARINALEDA",
    "hojasSigpac": "41061A",
    "esCapital": false,
    "esSegregacion": false
  },
  {
    "codProvincia": 41,
    "provincia": "Sevilla",
    "codIne": 62,
    "codCatastro": 62,
    "nombre": "MARTIN DE LA JARA",
    "hojasSigpac": "41062A",
    "esCapital": false,
    "esSegregacion": false
  },
  {
    "codProvincia": 41,
    "provincia": "Sevilla",
    "codIne": 63,
    "codCatastro": 63,
    "nombre": "LOS MOLARES",
    "hojasSigpac": "41063A",
    "esCapital": false,
    "esSegregacion": false
  },
  {
    "codProvincia": 41,
    "provincia": "Sevilla",
    "codIne": 64,
    "codCatastro": 64,
    "nombre": "MONTELLANO",
    "hojasSigpac": "41064A",
    "esCapital": false,
    "esSegregacion": false
  },
  {
    "codProvincia": 41,
    "provincia": "Sevilla",
    "codIne": 65,
    "codCatastro": 65,
    "nombre": "MORON DE LA FRONTERA",
    "hojasSigpac": "41065A",
    "esCapital": false,
    "esSegregacion": false
  },
  {
    "codProvincia": 41,
    "provincia": "Sevilla",
    "codIne": 66,
    "codCatastro": 66,
    "nombre": "LAS NAVAS DE LA CONCEPCION",
    "hojasSigpac": "41066A",
    "esCapital": false,
    "esSegregacion": false
  },
  {
    "codProvincia": 41,
    "provincia": "Sevilla",
    "codIne": 67,
    "codCatastro": 67,
    "nombre": "OLIVARES",
    "hojasSigpac": "41067A",
    "esCapital": false,
    "esSegregacion": false
  },
  {
    "codProvincia": 41,
    "provincia": "Sevilla",
    "codIne": 68,
    "codCatastro": 68,
    "nombre": "OSUNA",
    "hojasSigpac": "41068A",
    "esCapital": false,
    "esSegregacion": false
  },
  {
    "codProvincia": 41,
    "provincia": "Sevilla",
    "codIne": 69,
    "codCatastro": 69,
    "nombre": "LOS PALACIOS Y VILLAFRANCA",
    "hojasSigpac": "41069A",
    "esCapital": false,
    "esSegregacion": false
  },
  {
    "codProvincia": 41,
    "provincia": "Sevilla",
    "codIne": 70,
    "codCatastro": 70,
    "nombre": "PALOMARES DEL RIO",
    "hojasSigpac": "41070A",
    "esCapital": false,
    "esSegregacion": false
  },
  {
    "codProvincia": 41,
    "provincia": "Sevilla",
    "codIne": 71,
    "codCatastro": 71,
    "nombre": "PARADAS",
    "hojasSigpac": "41071A",
    "esCapital": false,
    "esSegregacion": false
  },
  {
    "codProvincia": 41,
    "provincia": "Sevilla",
    "codIne": 72,
    "codCatastro": 72,
    "nombre": "PEDRERA",
    "hojasSigpac": "41072A",
    "esCapital": false,
    "esSegregacion": false
  },
  {
    "codProvincia": 41,
    "provincia": "Sevilla",
    "codIne": 73,
    "codCatastro": 73,
    "nombre": "EL PEDROSO",
    "hojasSigpac": "41073A",
    "esCapital": false,
    "esSegregacion": false
  },
  {
    "codProvincia": 41,
    "provincia": "Sevilla",
    "codIne": 74,
    "codCatastro": 74,
    "nombre": "PEÑAFLOR",
    "hojasSigpac": "41074A",
    "esCapital": false,
    "esSegregacion": false
  },
  {
    "codProvincia": 41,
    "provincia": "Sevilla",
    "codIne": 75,
    "codCatastro": 75,
    "nombre": "PILAS",
    "hojasSigpac": "41075A",
    "esCapital": false,
    "esSegregacion": false
  },
  {
    "codProvincia": 41,
    "provincia": "Sevilla",
    "codIne": 76,
    "codCatastro": 76,
    "nombre": "PRUNA",
    "hojasSigpac": "41076A",
    "esCapital": false,
    "esSegregacion": false
  },
  {
    "codProvincia": 41,
    "provincia": "Sevilla",
    "codIne": 77,
    "codCatastro": 77,
    "nombre": "LA PUEBLA DE CAZALLA",
    "hojasSigpac": "41077A",
    "esCapital": false,
    "esSegregacion": false
  },
  {
    "codProvincia": 41,
    "provincia": "Sevilla",
    "codIne": 78,
    "codCatastro": 78,
    "nombre": "LA PUEBLA DE LOS INFANTES",
    "hojasSigpac": "41078A",
    "esCapital": false,
    "esSegregacion": false
  },
  {
    "codProvincia": 41,
    "provincia": "Sevilla",
    "codIne": 79,
    "codCatastro": 79,
    "nombre": "LA PUEBLA DEL RIO",
    "hojasSigpac": "41079A",
    "esCapital": false,
    "esSegregacion": false
  },
  {
    "codProvincia": 41,
    "provincia": "Sevilla",
    "codIne": 80,
    "codCatastro": 80,
    "nombre": "EL REAL DE LA JARA",
    "hojasSigpac": "41080A",
    "esCapital": false,
    "esSegregacion": false
  },
  {
    "codProvincia": 41,
    "provincia": "Sevilla",
    "codIne": 81,
    "codCatastro": 81,
    "nombre": "LA RINCONADA",
    "hojasSigpac": "41081A",
    "esCapital": false,
    "esSegregacion": false
  },
  {
    "codProvincia": 41,
    "provincia": "Sevilla",
    "codIne": 82,
    "codCatastro": 82,
    "nombre": "LA RODA DE ANDALUCIA",
    "hojasSigpac": "41082A",
    "esCapital": false,
    "esSegregacion": false
  },
  {
    "codProvincia": 41,
    "provincia": "Sevilla",
    "codIne": 83,
    "codCatastro": 83,
    "nombre": "EL RONQUILLO",
    "hojasSigpac": "41083A",
    "esCapital": false,
    "esSegregacion": false
  },
  {
    "codProvincia": 41,
    "provincia": "Sevilla",
    "codIne": 84,
    "codCatastro": 84,
    "nombre": "EL RUBIO",
    "hojasSigpac": "41084A",
    "esCapital": false,
    "esSegregacion": false
  },
  {
    "codProvincia": 41,
    "provincia": "Sevilla",
    "codIne": 85,
    "codCatastro": 85,
    "nombre": "SALTERAS",
    "hojasSigpac": "41085A",
    "esCapital": false,
    "esSegregacion": false
  },
  {
    "codProvincia": 41,
    "provincia": "Sevilla",
    "codIne": 86,
    "codCatastro": 86,
    "nombre": "SAN JUAN DE AZNALFARACHE",
    "hojasSigpac": "41086A",
    "esCapital": false,
    "esSegregacion": false
  },
  {
    "codProvincia": 41,
    "provincia": "Sevilla",
    "codIne": 87,
    "codCatastro": 87,
    "nombre": "SANLUCAR LA MAYOR",
    "hojasSigpac": "41087A",
    "esCapital": false,
    "esSegregacion": false
  },
  {
    "codProvincia": 41,
    "provincia": "Sevilla",
    "codIne": 88,
    "codCatastro": 88,
    "nombre": "SAN NICOLAS DEL PUERTO",
    "hojasSigpac": "41088A",
    "esCapital": false,
    "esSegregacion": false
  },
  {
    "codProvincia": 41,
    "provincia": "Sevilla",
    "codIne": 89,
    "codCatastro": 89,
    "nombre": "SANTIPONCE",
    "hojasSigpac": "41089A",
    "esCapital": false,
    "esSegregacion": false
  },
  {
    "codProvincia": 41,
    "provincia": "Sevilla",
    "codIne": 90,
    "codCatastro": 90,
    "nombre": "EL SAUCEJO",
    "hojasSigpac": "41090A",
    "esCapital": false,
    "esSegregacion": false
  },
  {
    "codProvincia": 41,
    "provincia": "Sevilla",
    "codIne": 91,
    "codCatastro": 900,
    "nombre": "SEVILLA",
    "hojasSigpac": "41900A",
    "esCapital": true,
    "esSegregacion": false
  },
  {
    "codProvincia": 41,
    "provincia": "Sevilla",
    "codIne": 92,
    "codCatastro": 92,
    "nombre": "TOCINA",
    "hojasSigpac": "41092A",
    "esCapital": false,
    "esSegregacion": false
  },
  {
    "codProvincia": 41,
    "provincia": "Sevilla",
    "codIne": 93,
    "codCatastro": 93,
    "nombre": "TOMARES",
    "hojasSigpac": "41093A",
    "esCapital": false,
    "esSegregacion": false
  },
  {
    "codProvincia": 41,
    "provincia": "Sevilla",
    "codIne": 94,
    "codCatastro": 94,
    "nombre": "UMBRETE",
    "hojasSigpac": "41094A",
    "esCapital": false,
    "esSegregacion": false
  },
  {
    "codProvincia": 41,
    "provincia": "Sevilla",
    "codIne": 95,
    "codCatastro": 95,
    "nombre": "UTRERA",
    "hojasSigpac": "41095A",
    "esCapital": false,
    "esSegregacion": false
  },
  {
    "codProvincia": 41,
    "provincia": "Sevilla",
    "codIne": 96,
    "codCatastro": 96,
    "nombre": "VALENCINA DE LA CONCEPCION",
    "hojasSigpac": "41096A",
    "esCapital": false,
    "esSegregacion": false
  },
  {
    "codProvincia": 41,
    "provincia": "Sevilla",
    "codIne": 97,
    "codCatastro": 97,
    "nombre": "VILLAMANRIQUE DE LA CONDESA",
    "hojasSigpac": "41097A",
    "esCapital": false,
    "esSegregacion": false
  },
  {
    "codProvincia": 41,
    "provincia": "Sevilla",
    "codIne": 98,
    "codCatastro": 98,
    "nombre": "VILLANUEVA DEL ARISCAL",
    "hojasSigpac": "41098A",
    "esCapital": false,
    "esSegregacion": false
  },
  {
    "codProvincia": 41,
    "provincia": "Sevilla",
    "codIne": 99,
    "codCatastro": 99,
    "nombre": "VILLANUEVA DEL RIO Y MINAS",
    "hojasSigpac": "41099A",
    "esCapital": false,
    "esSegregacion": false
  },
  {
    "codProvincia": 41,
    "provincia": "Sevilla",
    "codIne": 100,
    "codCatastro": 100,
    "nombre": "VILLANUEVA DE SAN JUAN",
    "hojasSigpac": "41100A",
    "esCapital": false,
    "esSegregacion": false
  },
  {
    "codProvincia": 41,
    "provincia": "Sevilla",
    "codIne": 101,
    "codCatastro": 101,
    "nombre": "VILLAVERDE DEL RIO",
    "hojasSigpac": "41101A",
    "esCapital": false,
    "esSegregacion": false
  },
  {
    "codProvincia": 41,
    "provincia": "Sevilla",
    "codIne": 102,
    "codCatastro": 102,
    "nombre": "EL VISO DEL ALCOR",
    "hojasSigpac": "41102A",
    "esCapital": false,
    "esSegregacion": false
  },
  {
    "codProvincia": 41,
    "provincia": "Sevilla",
    "codIne": 901,
    "codCatastro": 103,
    "nombre": "CAÑADA ROSAL",
    "hojasSigpac": "41103A",
    "esCapital": false,
    "esSegregacion": true
  },
  {
    "codProvincia": 41,
    "provincia": "Sevilla",
    "codIne": 902,
    "codCatastro": 104,
    "nombre": "ISLA MAYOR",
    "hojasSigpac": "41104A",
    "esCapital": false,
    "esSegregacion": true
  },
  {
    "codProvincia": 41,
    "provincia": "Sevilla",
    "codIne": 903,
    "codCatastro": 105,
    "nombre": "EL CUERVO DE SEVILLA",
    "hojasSigpac": "41105A",
    "esCapital": false,
    "esSegregacion": true
  },
  {
    "codProvincia": 41,
    "provincia": "Sevilla",
    "codIne": 904,
    "codCatastro": 106,
    "nombre": "EL PALMAR DE TROYA",
    "hojasSigpac": "41095A",
    "esCapital": false,
    "esSegregacion": true
  }
];
